export const API_SRUDENT_URL = 'http://localhost:3001/';
export const MAIN_URL = 'https://iifabackend.soof.uz';
export const MAIN_URL_LOCAL = 'http://192.168.100.112:8001';
export const M_URL_FAKE = 'http://185.80.234.21:8050'
// export const M_URL = 'http://148.251.188.97:8989'
export const M_URL = 'https://videogenerator.soof.uz'
export const M_URL2 = 'https://videogeneratortwo.soof.uz'

export const data = [
  {
    "id": "EMP-2025-001-KZH",
    "name": "Каримов Жамшид",
    "certificates": [
      {
        "id": "CERT-KZH-1",
        "name": "Введение в Международный стандарт управления качеством (ISQM 1): принципы, структура и внедрение",
        "date": "14.11.2025",
        "time": "20 (5 дней)-часового курса"
      },
      {
        "id": "CERT-KZH-2",
        "name": "Эффективная деловая коммуникация в профессиональной среде: навыки взаимодействия, переговоров и презентации",
        "date": "24.11.2025",
        "time": "2-часового курса"
      },
      {
        "id": "CERT-KZH-3",
        "name": "Применение МСА 330: Аудиторские процедуры в ответ на оцененные риски существенного искажения",
        "date": "28.11.2025",
        "time": "2-часового курса"
      },
      {
        "id": "CERT-KZH-4",
        "name": "Аудит оценочных значений, включая справедливую стоимость и резервы: применение МСА 540",
        "date": "05.12.2025",
        "time": "2-часового курса"
      },
      {
        "id": "CERT-KZH-5",
        "name": "Разработка и реализация стратегии управления клиентским портфелем: сегментация, приоритеты и качество обслуживания",
        "date": "19.12.2025",
        "time": "6-часового курса"
      }
    ]
  },
  {
    "id": "EMP-2025-002-SFZ",
    "name": "Шерембаева Феруза",
    "certificates": [
      {
        "id": "CERT-SFZ-1",
        "name": "Введение в Международный стандарт управления качеством (ISQM 1): принципы, структура и внедрение",
        "date": "14.11.2025",
        "time": "20 (5 дней)-часового курса"
      },
      {
        "id": "CERT-SFZ-2",
        "name": "Эффективная деловая коммуникация в профессиональной среде: навыки взаимодействия, переговоров и презентации",
        "date": "24.11.2025",
        "time": "2-часового курса"
      },
      {
        "id": "CERT-SFZ-3",
        "name": "Применение МСА 330: Аудиторские процедуры в ответ на оцененные риски существенного искажения",
        "date": "28.11.2025",
        "time": "2-часового курса"
      },
      {
        "id": "CERT-SFZ-4",
        "name": "Аудит оценочных значений, включая справедливую стоимость и резервы: применение МСА 540",
        "date": "05.12.2025",
        "time": "2-часового курса"
      },
      {
        "id": "CERT-SFZ-5",
        "name": "Разработка и реализация стратегии управления клиентским портфелем: сегментация, приоритеты и качество обслуживания",
        "date": "19.12.2025",
        "time": "6-часового курса"
      }
    ]
  },
  {
    "id": "EMP-2025-003-UAR",
    "name": "Узаков Абдурасул",
    "certificates": [
      {
        "id": "CERT-UAR-1",
        "name": "Введение в Международный стандарт управления качеством (ISQM 1): принципы, структура и внедрение",
        "date": "14.11.2025",
        "time": "20 (5 дней)-часового курса"
      },
      {
        "id": "CERT-UAR-2",
        "name": "Эффективная деловая коммуникация в профессиональной среде: навыки взаимодействия, переговоров и презентации",
        "date": "24.11.2025",
        "time": "2-часового курса"
      },
      {
        "id": "CERT-UAR-3",
        "name": "Применение МСА 330: Аудиторские процедуры в ответ на оцененные риски существенного искажения",
        "date": "28.11.2025",
        "time": "2-часового курса"
      },
      {
        "id": "CERT-UAR-4",
        "name": "Аудит оценочных значений, включая справедливую стоимость и резервы: применение МСА 540",
        "date": "05.12.2025",
        "time": "2-часового курса"
      },
      {
        "id": "CERT-UAR-5",
        "name": "Разработка и реализация стратегии управления клиентским портфелем: сегментация, приоритеты и качество обслуживания",
        "date": "19.12.2025",
        "time": "6-часового курса"
      }
    ]
  },
  {
    "id": "EMP-2025-004-YNI",
    "name": "Юлдашов Нодирбек",
    "certificates": [
      {
        "id": "CERT-YNI-1",
        "name": "Введение в Международный стандарт управления качеством (ISQM 1): принципы, структура и внедрение",
        "date": "14.11.2025",
        "time": "20 (5 дней)-часового курса"
      },
      {
        "id": "CERT-YNI-2",
        "name": "Эффективная деловая коммуникация в профессиональной среде: навыки взаимодействия, переговоров и презентации",
        "date": "24.11.2025",
        "time": "2-часового курса"
      },
      {
        "id": "CERT-YNI-3",
        "name": "Применение МСА 330: Аудиторские процедуры в ответ на оцененные риски существенного искажения",
        "date": "28.11.2025",
        "time": "2-часового курса"
      },
      {
        "id": "CERT-YNI-4",
        "name": "Аудит оценочных значений, включая справедливую стоимость и резервы: применение МСА 540",
        "date": "05.12.2025",
        "time": "2-часового курса"
      },
      {
        "id": "CERT-YNI-5",
        "name": "Разработка и реализация стратегии управления клиентским портфелем: сегментация, приоритеты и качество обслуживания",
        "date": "19.12.2025",
        "time": "6-часового курса"
      }
    ]
  },
  {
    "id": "EMP-2025-005-AOD",
    "name": "Азимбаев Обиджан",
    "certificates": [
      {
        "id": "CERT-AOD-1",
        "name": "Введение в Международный стандарт управления качеством (ISQM 1): принципы, структура и внедрение",
        "date": "14.11.2025",
        "time": "20 (5 дней)-часового курса"
      },
      {
        "id": "CERT-AOD-2",
        "name": "Эффективная деловая коммуникация в профессиональной среде: навыки взаимодействия, переговоров и презентации",
        "date": "24.11.2025",
        "time": "2-часового курса"
      },
      {
        "id": "CERT-AOD-3",
        "name": "Применение МСА 330: Аудиторские процедуры в ответ на оцененные риски существенного искажения",
        "date": "28.11.2025",
        "time": "2-часового курса"
      },
      {
        "id": "CERT-AOD-4",
        "name": "Аудит оценочных значений, включая справедливую стоимость и резервы: применение МСА 540",
        "date": "05.12.2025",
        "time": "2-часового курса"
      },
      {
        "id": "CERT-AOD-5",
        "name": "Разработка и реализация стратегии управления клиентским портфелем: сегментация, приоритеты и качество обслуживания",
        "date": "19.12.2025",
        "time": "6-часового курса"
      }
    ]
  },
  {
    "id": "EMP-2025-006-NSH",
    "name": "Носиров Шодил",
    "certificates": [
      {
        "id": "CERT-NSH-1",
        "name": "Введение в Международный стандарт управления качеством (ISQM 1): принципы, структура и внедрение",
        "date": "14.11.2025",
        "time": "20 (5 дней)-часового курса"
      },
      {
        "id": "CERT-NSH-2",
        "name": "Эффективная деловая коммуникация в профессиональной среде: навыки взаимодействия, переговоров и презентации",
        "date": "24.11.2025",
        "time": "2-часового курса"
      },
      {
        "id": "CERT-NSH-3",
        "name": "Применение МСА 330: Аудиторские процедуры в ответ на оцененные риски существенного искажения",
        "date": "28.11.2025",
        "time": "2-часового курса"
      },
      {
        "id": "CERT-NSH-4",
        "name": "Аудит оценочных значений, включая справедливую стоимость и резервы: применение МСА 540",
        "date": "05.12.2025",
        "time": "2-часового курса"
      },
      {
        "id": "CERT-NSH-5",
        "name": "Разработка и реализация стратегии управления клиентским портфелем: сегментация, приоритеты и качество обслуживания",
        "date": "19.12.2025",
        "time": "6-часового курса"
      }
    ]
  },
  {
    "id": "EMP-2025-007-TAA",
    "name": "Тангиркулов Абдиҳофиз",
    "certificates": [
      {
        "id": "CERT-TAA-1",
        "name": "Введение в Международный стандарт управления качеством (ISQM 1): принципы, структура и внедрение",
        "date": "14.11.2025",
        "time": "20 (5 дней)-часового курса"
      },
      {
        "id": "CERT-TAA-2",
        "name": "Эффективная деловая коммуникация в профессиональной среде: навыки взаимодействия, переговоров и презентации",
        "date": "24.11.2025",
        "time": "2-часового курса"
      },
      {
        "id": "CERT-TAA-3",
        "name": "Применение МСА 330: Аудиторские процедуры в ответ на оцененные риски существенного искажения",
        "date": "28.11.2025",
        "time": "2-часового курса"
      },
      {
        "id": "CERT-TAA-4",
        "name": "Аудит оценочных значений, включая справедливую стоимость и резервы: применение МСА 540",
        "date": "05.12.2025",
        "time": "2-часового курса"
      },
      {
        "id": "CERT-TAA-5",
        "name": "Разработка и реализация стратегии управления клиентским портфелем: сегментация, приоритеты и качество обслуживания",
        "date": "19.12.2025",
        "time": "6-часового курса"
      }
    ]
  },
  {
    "id": "EMP-2025-008-IY",
    "name": "Йўлчиев Нодиржон",
    "certificates": [
      {
        "id": "CERT-IY-1",
        "name": "Введение в Международный стандарт управления качеством (ISQM 1): принципы, структура и внедрение",
        "date": "14.11.2025",
        "time": "20 (5 дней)-часового курса"
      },
      {
        "id": "CERT-IY-2",
        "name": "Эффективная деловая коммуникация в профессиональной среде: навыки взаимодействия, переговоров и презентации",
        "date": "24.11.2025",
        "time": "2-часового курса"
      },
      {
        "id": "CERT-IY-3",
        "name": "Применение МСА 330: Аудиторские процедуры в ответ на оцененные риски существенного искажения",
        "date": "28.11.2025",
        "time": "2-часового курса"
      },
      {
        "id": "CERT-IY-4",
        "name": "Аудит оценочных значений, включая справедливую стоимость и резервы: применение МСА 540",
        "date": "05.12.2025",
        "time": "2-часового курса"
      },
      {
        "id": "CERT-IY-5",
        "name": "Разработка и реализация стратегии управления клиентским портфелем: сегментация, приоритеты и качество обслуживания",
        "date": "19.12.2025",
        "time": "6-часового курса"
      }
    ]
  },
  {
    "id": "EMP-2025-009-YRH",
    "name": "Юлдашев Рахматулло",
    "certificates": [
      {
        "id": "CERT-YRH-1",
        "name": "Введение в Международный стандарт управления качеством (ISQM 1): принципы, структура и внедрение",
        "date": "14.11.2025",
        "time": "20 (5 дней)-часового курса"
      },
      {
        "id": "CERT-YRH-2",
        "name": "Эффективная деловая коммуникация в профессиональной среде: навыки взаимодействия, переговоров и презентации",
        "date": "24.11.2025",
        "time": "2-часового курса"
      },
      {
        "id": "CERT-YRH-3",
        "name": "Применение МСА 330: Аудиторские процедуры в ответ на оцененные риски существенного искажения",
        "date": "28.11.2025",
        "time": "2-часового курса"
      },
      {
        "id": "CERT-YRH-4",
        "name": "Аудит оценочных значений, включая справедливую стоимость и резервы: применение МСА 540",
        "date": "05.12.2025",
        "time": "2-часового курса"
      },
      {
        "id": "CERT-YRH-5",
        "name": "Разработка и реализация стратегии управления клиентским портфелем: сегментация, приоритеты и качество обслуживания",
        "date": "19.12.2025",
        "time": "6-часового курса"
      }
    ]
  },
  {
    "id": "EMP-2025-010-RE",
    "name": "Раззаков Элдор",
    "certificates": [
      {
        "id": "CERT-RE-1",
        "name": "Введение в Международный стандарт управления качеством (ISQM 1): принципы, структура и внедрение",
        "date": "14.11.2025",
        "time": "20 (5 дней)-часового курса"
      },
      {
        "id": "CERT-RE-2",
        "name": "Эффективная деловая коммуникация в профессиональной среде: навыки взаимодействия, переговоров и презентации",
        "date": "24.11.2025",
        "time": "2-часового курса"
      },
      {
        "id": "CERT-RE-3",
        "name": "Применение МСА 330: Аудиторские процедуры в ответ на оцененные риски существенного искажения",
        "date": "28.11.2025",
        "time": "2-часового курса"
      },
      {
        "id": "CERT-RE-4",
        "name": "Аудит оценочных значений, включая справедливую стоимость и резервы: применение МСА 540",
        "date": "05.12.2025",
        "time": "2-часового курса"
      },
      {
        "id": "CERT-RE-5",
        "name": "Разработка и реализация стратегии управления клиентским портфелем: сегментация, приоритеты и качество обслуживания",
        "date": "19.12.2025",
        "time": "6-часового курса"
      }
    ]
  },
  {
    "id": "EMP-2025-011-RO",
    "name": "Рахимов Одил",
    "certificates": [
      {
        "id": "CERT-RO-1",
        "name": "Введение в Международный стандарт управления качеством (ISQM 1): принципы, структура и внедрение",
        "date": "14.11.2025",
        "time": "20 (5 дней)-часового курса"
      },
      {
        "id": "CERT-RO-2",
        "name": "Эффективная деловая коммуникация в профессиональной среде: навыки взаимодействия, переговоров и презентации",
        "date": "24.11.2025",
        "time": "2-часового курса"
      },
      {
        "id": "CERT-RO-3",
        "name": "Применение МСА 330: Аудиторские процедуры в ответ на оцененные риски существенного искажения",
        "date": "28.11.2025",
        "time": "2-часового курса"
      },
      {
        "id": "CERT-RO-4",
        "name": "Аудит оценочных значений, включая справедливую стоимость и резервы: применение МСА 540",
        "date": "05.12.2025",
        "time": "2-часового курса"
      },
      {
        "id": "CERT-RO-5",
        "name": "Разработка и реализация стратегии управления клиентским портфелем: сегментация, приоритеты и качество обслуживания",
        "date": "19.12.2025",
        "time": "6-часового курса"
      }
    ]
  },
  {
    "id": "EMP-2025-012-TJ",
    "name": "Туляганов Жахонгир",
    "certificates": [
      {
        "id": "CERT-TJ-1",
        "name": "Введение в Международный стандарт управления качеством (ISQM 1): принципы, структура и внедрение",
        "date": "14.11.2025",
        "time": "20 (5 дней)-часового курса"
      },
      {
        "id": "CERT-TJ-2",
        "name": "Эффективная деловая коммуникация в профессиональной среде: навыки взаимодействия, переговоров и презентации",
        "date": "24.11.2025",
        "time": "2-часового курса"
      },
      {
        "id": "CERT-TJ-3",
        "name": "Применение МСА 330: Аудиторские процедуры в ответ на оцененные риски существенного искажения",
        "date": "28.11.2025",
        "time": "2-часового курса"
      },
      {
        "id": "CERT-TJ-4",
        "name": "Аудит оценочных значений, включая справедливую стоимость и резервы: применение МСА 540",
        "date": "05.12.2025",
        "time": "2-часового курса"
      },
      {
        "id": "CERT-TJ-5",
        "name": "Разработка и реализация стратегии управления клиентским портфелем: сегментация, приоритеты и качество обслуживания",
        "date": "19.12.2025",
        "time": "6-часового курса"
      }
    ]
  },
  {
    "id": "EMP-2025-013-HJM",
    "name": "Ходжимухамедов Жамолиддин",
    "certificates": [
      {
        "id": "CERT-HJM-1",
        "name": "Введение в Международный стандарт управления качеством (ISQM 1): принципы, структура и внедрение",
        "date": "14.11.2025",
        "time": "20 (5 дней)-часового курса"
      },
      {
        "id": "CERT-HJM-2",
        "name": "Эффективная деловая коммуникация в профессиональной среде: навыки взаимодействия, переговоров и презентации",
        "date": "24.11.2025",
        "time": "2-часового курса"
      },
      {
        "id": "CERT-HJM-3",
        "name": "Применение МСА 330: Аудиторские процедуры в ответ на оцененные риски существенного искажения",
        "date": "28.11.2025",
        "time": "2-часового курса"
      },
      {
        "id": "CERT-HJM-4",
        "name": "Аудит оценочных значений, включая справедливую стоимость и резервы: применение МСА 540",
        "date": "05.12.2025",
        "time": "2-часового курса"
      },
      {
        "id": "CERT-HJM-5",
        "name": "Разработка и реализация стратегии управления клиентским портфелем: сегментация, приоритеты и качество обслуживания",
        "date": "19.12.2025",
        "time": "6-часового курса"
      }
    ]
  },
  {
    "id": "EMP-2025-014-JTB",
    "name": "Жумабоев Толибжон",
    "certificates": [
      {
        "id": "CERT-JTB-1",
        "name": "Введение в Международный стандарт управления качеством (ISQM 1): принципы, структура и внедрение",
        "date": "14.11.2025",
        "time": "20 (5 дней)-часового курса"
      },
      {
        "id": "CERT-JTB-2",
        "name": "Эффективная деловая коммуникация в профессиональной среде: навыки взаимодействия, переговоров и презентации",
        "date": "24.11.2025",
        "time": "2-часового курса"
      },
      {
        "id": "CERT-JTB-3",
        "name": "Применение МСА 330: Аудиторские процедуры в ответ на оцененные риски существенного искажения",
        "date": "28.11.2025",
        "time": "2-часового курса"
      },
      {
        "id": "CERT-JTB-4",
        "name": "Аудит оценочных значений, включая справедливую стоимость и резервы: применение МСА 540",
        "date": "05.12.2025",
        "time": "2-часового курса"
      },
      {
        "id": "CERT-JTB-5",
        "name": "Разработка и реализация стратегии управления клиентским портфелем: сегментация, приоритеты и качество обслуживания",
        "date": "19.12.2025",
        "time": "6-часового курса"
      }
    ]
  },
  {
    "id": "EMP-2025-015-OE",
    "name": "Омонова Элеонора",
    "certificates": [
      {
        "id": "CERT-OE-1",
        "name": "Введение в Международный стандарт управления качеством (ISQM 1): принципы, структура и внедрение",
        "date": "14.11.2025",
        "time": "20 (5 дней)-часового курса"
      }
    ]
  },
  {
    "id": "EMP-2025-016-RX",
    "name": "Рахматуллаев Хасан",
    "certificates": [
      {
        "id": "CERT-RX-1",
        "name": "Введение в Международный стандарт управления качеством (ISQM 1): принципы, структура и внедрение",
        "date": "14.11.2025",
        "time": "20 (5 дней)-часового курса"
      },
      {
        "id": "CERT-RX-2",
        "name": "Эффективная деловая коммуникация в профессиональной среде: навыки взаимодействия, переговоров и презентации",
        "date": "24.11.2025",
        "time": "2-часового курса"
      },
      {
        "id": "CERT-RX-3",
        "name": "Применение МСА 330: Аудиторские процедуры в ответ на оцененные риски существенного искажения",
        "date": "28.11.2025",
        "time": "2-часового курса"
      },
      {
        "id": "CERT-RX-4",
        "name": "Аудит оценочных значений, включая справедливую стоимость и резервы: применение МСА 540",
        "date": "05.12.2025",
        "time": "2-часового курса"
      },
      {
        "id": "CERT-RX-5",
        "name": "Разработка и реализация стратегии управления клиентским портфелем: сегментация, приоритеты и качество обслуживания",
        "date": "19.12.2025",
        "time": "6-часового курса"
      }
    ]
  },
  {
    "id": "EMP-2025-017-AA",
    "name": "Аразгельдиев Арсланбек",
    "certificates": [
      {
        "id": "CERT-AA-1",
        "name": "Введение в Международный стандарт управления качеством (ISQM 1): принципы, структура и внедрение",
        "date": "14.11.2025",
        "time": "20 (5 дней)-часового курса"
      },
      {
        "id": "CERT-AA-2",
        "name": "Эффективная деловая коммуникация в профессиональной среде: навыки взаимодействия, переговоров и презентации",
        "date": "24.11.2025",
        "time": "2-часового курса"
      },
      {
        "id": "CERT-AA-3",
        "name": "Применение МСА 330: Аудиторские процедуры в ответ на оцененные риски существенного искажения",
        "date": "28.11.2025",
        "time": "2-часового курса"
      },
      {
        "id": "CERT-AA-4",
        "name": "Аудит оценочных значений, включая справедливую стоимость и резервы: применение МСА 540",
        "date": "05.12.2025",
        "time": "2-часового курса"
      },
      {
        "id": "CERT-AA-5",
        "name": "Разработка и реализация стратегии управления клиентским портфелем: сегментация, приоритеты и качество обслуживания",
        "date": "19.12.2025",
        "time": "6-часового курса"
      }
    ]
  },
  {
    "id": "EMP-2025-018-MI",
    "name": "Мухитдинов Иброхим",
    "certificates": [
      {
        "id": "CERT-MI-1",
        "name": "Введение в Международный стандарт управления качеством (ISQM 1): принципы, структура и внедрение",
        "date": "14.11.2025",
        "time": "20 (5 дней)-часового курса"
      },
      {
        "id": "CERT-MI-2",
        "name": "Эффективная деловая коммуникация в профессиональной среде: навыки взаимодействия, переговоров и презентации",
        "date": "24.11.2025",
        "time": "2-часового курса"
      },
      {
        "id": "CERT-MI-3",
        "name": "Применение МСА 330: Аудиторские процедуры в ответ на оцененные риски существенного искажения",
        "date": "28.11.2025",
        "time": "2-часового курса"
      },
      {
        "id": "CERT-MI-4",
        "name": "Аудит оценочных значений, включая справедливую стоимость и резервы: применение МСА 540",
        "date": "05.12.2025",
        "time": "2-часового курса"
      },
      {
        "id": "CERT-MI-5",
        "name": "Разработка и реализация стратегии управления клиентским портфелем: сегментация, приоритеты и качество обслуживания",
        "date": "19.12.2025",
        "time": "6-часового курса"
      }
    ]
  },
  {
    "id": "EMP-2025-019-EA",
    "name": "Эшбуриев Аббос",
    "certificates": [
      {
        "id": "CERT-EA-1",
        "name": "Введение в Международный стандарт управления качеством (ISQM 1): принципы, структура и внедрение",
        "date": "14.11.2025",
        "time": "20 (5 дней)-часового курса"
      },
      {
        "id": "CERT-EA-2",
        "name": "Эффективная деловая коммуникация в профессиональной среде: навыки взаимодействия, переговоров и презентации",
        "date": "24.11.2025",
        "time": "2-часового курса"
      },
      {
        "id": "CERT-EA-3",
        "name": "Применение МСА 330: Аудиторские процедуры в ответ на оцененные риски существенного искажения",
        "date": "28.11.2025",
        "time": "2-часового курса"
      },
      {
        "id": "CERT-EA-4",
        "name": "Аудит оценочных значений, включая справедливую стоимость и резервы: применение МСА 540",
        "date": "05.12.2025",
        "time": "2-часового курса"
      },
      {
        "id": "CERT-EA-5",
        "name": "Разработка и реализация стратегии управления клиентским портфелем: сегментация, приоритеты и качество обслуживания",
        "date": "19.12.2025",
        "time": "6-часового курса"
      }
    ]
  },
  {
    "id": "EMP-2025-020-IR",
    "name": "Исроилова Раййан",
    "certificates": [
      {
        "id": "CERT-IR-1",
        "name": "Введение в Международный стандарт управления качеством (ISQM 1): принципы, структура и внедрение",
        "date": "14.11.2025",
        "time": "20 (5 дней)-часового курса"
      },
      {
        "id": "CERT-IR-2",
        "name": "Эффективная деловая коммуникация в профессиональной среде: навыки взаимодействия, переговоров и презентации",
        "date": "24.11.2025",
        "time": "2-часового курса"
      },
      {
        "id": "CERT-IR-3",
        "name": "Применение МСА 330: Аудиторские процедуры в ответ на оцененные риски существенного искажения",
        "date": "28.11.2025",
        "time": "2-часового курса"
      },
      {
        "id": "CERT-IR-4",
        "name": "Аудит оценочных значений, включая справедливую стоимость и резервы: применение МСА 540",
        "date": "05.12.2025",
        "time": "2-часового курса"
      },
      {
        "id": "CERT-IR-5",
        "name": "Разработка и реализация стратегии управления клиентским портфелем: сегментация, приоритеты и качество обслуживания",
        "date": "19.12.2025",
        "time": "6-часового курса"
      }
    ]
  },
  {
    "id": "EMP-2025-021-MN",
    "name": "Маъруфжонова Нигорахон",
    "certificates": [
      {
        "id": "CERT-MN-1",
        "name": "Введение в Международный стандарт управления качеством (ISQM 1): принципы, структура и внедрение",
        "date": "14.11.2025",
        "time": "20 (5 дней)-часового курса"
      },
      {
        "id": "CERT-MN-2",
        "name": "Эффективная деловая коммуникация в профессиональной среде: навыки взаимодействия, переговоров и презентации",
        "date": "24.11.2025",
        "time": "2-часового курса"
      },
      {
        "id": "CERT-MN-3",
        "name": "Применение МСА 330: Аудиторские процедуры в ответ на оцененные риски существенного искажения",
        "date": "28.11.2025",
        "time": "2-часового курса"
      },
      {
        "id": "CERT-MN-4",
        "name": "Аудит оценочных значений, включая справедливую стоимость и резервы: применение МСА 540",
        "date": "05.12.2025",
        "time": "2-часового курса"
      },
      {
        "id": "CERT-MN-5",
        "name": "Разработка и реализация стратегии управления клиентским портфелем: сегментация, приоритеты и качество обслуживания",
        "date": "19.12.2025",
        "time": "6-часового курса"
      }
    ]
  },
  {
    "id": "EMP-2025-022-TA",
    "name": "Турсунпулатов Анвар",
    "certificates": [
      {
        "id": "CERT-TA-1",
        "name": "Введение в Международный стандарт управления качеством (ISQM 1): принципы, структура и внедрение",
        "date": "14.11.2025",
        "time": "20 (5 дней)-часового курса"
      },
      {
        "id": "CERT-TA-2",
        "name": "Эффективная деловая коммуникация в профессиональной среде: навыки взаимодействия, переговоров и презентации",
        "date": "24.11.2025",
        "time": "2-часового курса"
      },
      {
        "id": "CERT-TA-3",
        "name": "Применение МСА 330: Аудиторские процедуры в ответ на оцененные риски существенного искажения",
        "date": "28.11.2025",
        "time": "2-часового курса"
      },
      {
        "id": "CERT-TA-4",
        "name": "Аудит оценочных значений, включая справедливую стоимость и резервы: применение МСА 540",
        "date": "05.12.2025",
        "time": "2-часового курса"
      },
      {
        "id": "CERT-TA-5",
        "name": "Разработка и реализация стратегии управления клиентским портфелем: сегментация, приоритеты и качество обслуживания",
        "date": "19.12.2025",
        "time": "6-часового курса"
      }
    ]
  },
  {
    "id": "EMP-2025-023-FD",
    "name": "Фатхуллаев Дилмурод",
    "certificates": [
      {
        "id": "CERT-FD-1",
        "name": "Введение в Международный стандарт управления качеством (ISQM 1): принципы, структура и внедрение",
        "date": "14.11.2025",
        "time": "20 (5 дней)-часового курса"
      },
      {
        "id": "CERT-FD-2",
        "name": "Эффективная деловая коммуникация в профессиональной среде: навыки взаимодействия, переговоров и презентации",
        "date": "24.11.2025",
        "time": "2-часового курса"
      },
      {
        "id": "CERT-FD-3",
        "name": "Применение МСА 330: Аудиторские процедуры в ответ на оцененные риски существенного искажения",
        "date": "28.11.2025",
        "time": "2-часового курса"
      },
      {
        "id": "CERT-FD-4",
        "name": "Аудит оценочных значений, включая справедливую стоимость и резервы: применение МСА 540",
        "date": "05.12.2025",
        "time": "2-часового курса"
      },
      {
        "id": "CERT-FD-5",
        "name": "Разработка и реализация стратегии управления клиентским портфелем: сегментация, приоритеты и качество обслуживания",
        "date": "19.12.2025",
        "time": "6-часового курса"
      }
    ]
  },
  {
    "id": "EMP-2025-024-FI",
    "name": "Фатхуллаев Иброхим",
    "certificates": [
      {
        "id": "CERT-FI-1",
        "name": "Введение в Международный стандарт управления качеством (ISQM 1): принципы, структура и внедрение",
        "date": "14.11.2025",
        "time": "20 (5 дней)-часового курса"
      },
      {
        "id": "CERT-FI-2",
        "name": "Эффективная деловая коммуникация в профессиональной среде: навыки взаимодействия, переговоров и презентации",
        "date": "24.11.2025",
        "time": "2-часового курса"
      },
      {
        "id": "CERT-FI-3",
        "name": "Применение МСА 330: Аудиторские процедуры в ответ на оцененные риски существенного искажения",
        "date": "28.11.2025",
        "time": "2-часового курса"
      },
      {
        "id": "CERT-FI-4",
        "name": "Аудит оценочных значений, включая справедливую стоимость и резервы: применение МСА 540",
        "date": "05.12.2025",
        "time": "2-часового курса"
      },
      {
        "id": "CERT-FI-5",
        "name": "Разработка и реализация стратегии управления клиентским портфелем: сегментация, приоритеты и качество обслуживания",
        "date": "19.12.2025",
        "time": "6-часового курса"
      }
    ]
  },
  {
    "id": "EMP-2025-028-AN",
    "name": "Алимова Нилуфар",
    "certificates": [
      {
        "id": "CERT-AN-1",
        "name": "Введение в Международный стандарт управления качеством (ISQM 1): принципы, структура и внедрение",
        "date": "14.11.2025",
        "time": "20 (5 дней)-часового курса"
      },
      {
        "id": "CERT-AN-2",
        "name": "Эффективная деловая коммуникация в профессиональной среде: навыки взаимодействия, переговоров и презентации",
        "date": "24.11.2025",
        "time": "2-часового курса"
      }
    ]
  },
  {
    "id": "EMP-2025-030-AU",
    "name": "Азимов Улугбек",
    "certificates": [
      {
        "id": "CERT-AU-1",
        "name": "Введение в Международный стандарт управления качеством (ISQM 1): принципы, структура и внедрение",
        "date": "14.11.2025",
        "time": "20 (5 дней)-часового курса"
      },
      {
        "id": "CERT-AU-2",
        "name": "Эффективная деловая коммуникация в профессиональной среде: навыки взаимодействия, переговоров и презентации",
        "date": "24.11.2025",
        "time": "2-часового курса"
      },
      {
        "id": "CERT-AU-3",
        "name": "Применение МСА 330: Аудиторские процедуры в ответ на оцененные риски существенного искажения",
        "date": "28.11.2025",
        "time": "2-часового курса"
      },
      {
        "id": "CERT-AU-4",
        "name": "Аудит оценочных значений, включая справедливую стоимость и резервы: применение МСА 540",
        "date": "05.12.2025",
        "time": "2-часового курса"
      },
      {
        "id": "CERT-AU-5",
        "name": "Разработка и реализация стратегии управления клиентским портфелем: сегментация, приоритеты и качество обслуживания",
        "date": "19.12.2025",
        "time": "6-часового курса"
      }
    ]
  },
  {
    "id": "EMP-2025-031-NN",
    "name": "Норбоева Нигина",
    "certificates": [
      {
        "id": "CERT-NN-1",
        "name": "Введение в Международный стандарт управления качеством (ISQM 1): принципы, структура и внедрение",
        "date": "14.11.2025",
        "time": "20 (5 дней)-часового курса"
      },
      {
        "id": "CERT-NN-2",
        "name": "Эффективная деловая коммуникация в профессиональной среде: навыки взаимодействия, переговоров и презентации",
        "date": "24.11.2025",
        "time": "2-часового курса"
      },
      {
        "id": "CERT-NN-3",
        "name": "Применение МСА 330: Аудиторские процедуры в ответ на оцененные риски существенного искажения",
        "date": "28.11.2025",
        "time": "2-часового курса"
      },
      {
        "id": "CERT-NN-4",
        "name": "Аудит оценочных значений, включая справедливую стоимость и резервы: применение МСА 540",
        "date": "05.12.2025",
        "time": "2-часового курса"
      },
      {
        "id": "CERT-NN-5",
        "name": "Разработка и реализация стратегии управления клиентским портфелем: сегментация, приоритеты и качество обслуживания",
        "date": "19.12.2025",
        "time": "6-часового курса"
      }
    ]
  },
  {
    "id": "EMP-2025-032-UF",
    "name": "Убайдуллаева Фазилат",
    "certificates": [
      {
        "id": "CERT-UF-1",
        "name": "Введение в Международный стандарт управления качеством (ISQM 1): принципы, структура и внедрение",
        "date": "14.11.2025",
        "time": "20 (5 дней)-часового курса"
      },
      {
        "id": "CERT-UF-2",
        "name": "Эффективная деловая коммуникация в профессиональной среде: навыки взаимодействия, переговоров и презентации",
        "date": "24.11.2025",
        "time": "2-часового курса"
      },
      {
        "id": "CERT-UF-3",
        "name": "Применение МСА 330: Аудиторские процедуры в ответ на оцененные риски существенного искажения",
        "date": "28.11.2025",
        "time": "2-часового курса"
      },
      {
        "id": "CERT-UF-4",
        "name": "Аудит оценочных значений, включая справедливую стоимость и резервы: применение МСА 540",
        "date": "05.12.2025",
        "time": "2-часового курса"
      },
      {
        "id": "CERT-UF-5",
        "name": "Разработка и реализация стратегии управления клиентским портфелем: сегментация, приоритеты и качество обслуживания",
        "date": "19.12.2025",
        "time": "6-часового курса"
      }
    ]
  },
  {
    "id": "EMP-2025-033-AU",
    "name": "Аскарова Угилой",
    "certificates": [
      {
        "id": "CERT-AU-1",
        "name": "Введение в Международный стандарт управления качеством (ISQM 1): принципы, структура и внедрение",
        "date": "14.11.2025",
        "time": "20 (5 дней)-часового курса"
      },
      {
        "id": "CERT-AU-2",
        "name": "Эффективная деловая коммуникация в профессиональной среде: навыки взаимодействия, переговоров и презентации",
        "date": "24.11.2025",
        "time": "2-часового курса"
      },
      {
        "id": "CERT-AU-3",
        "name": "Применение МСА 330: Аудиторские процедуры в ответ на оцененные риски существенного искажения",
        "date": "28.11.2025",
        "time": "2-часового курса"
      },
      {
        "id": "CERT-AU-4",
        "name": "Аудит оценочных значений, включая справедливую стоимость и резервы: применение МСА 540",
        "date": "05.12.2025",
        "time": "2-часового курса"
      },
      {
        "id": "CERT-AU-5",
        "name": "Разработка и реализация стратегии управления клиентским портфелем: сегментация, приоритеты и качество обслуживания",
        "date": "19.12.2025",
        "time": "6-часового курса"
      }
    ]
  },
  {
    "id": "EMP-2025-034-GF",
    "name": "Гаффоров Фазлиддин",
    "certificates": [
      {
        "id": "CERT-GF-1",
        "name": "Введение в Международный стандарт управления качеством (ISQM 1): принципы, структура и внедрение",
        "date": "14.11.2025",
        "time": "20 (5 дней)-часового курса"
      },
      {
        "id": "CERT-GF-2",
        "name": "Эффективная деловая коммуникация в профессиональной среде: навыки взаимодействия, переговоров и презентации",
        "date": "24.11.2025",
        "time": "2-часового курса"
      },
      {
        "id": "CERT-GF-3",
        "name": "Применение МСА 330: Аудиторские процедуры в ответ на оцененные риски существенного искажения",
        "date": "28.11.2025",
        "time": "2-часового курса"
      },
      {
        "id": "CERT-GF-4",
        "name": "Аудит оценочных значений, включая справедливую стоимость и резервы: применение МСА 540",
        "date": "05.12.2025",
        "time": "2-часового курса"
      },
      {
        "id": "CERT-GF-5",
        "name": "Разработка и реализация стратегии управления клиентским портфелем: сегментация, приоритеты и качество обслуживания",
        "date": "19.12.2025",
        "time": "6-часового курса"
      }
    ]
  },
  {
    "id": "EMP-2025-035-AS",
    "name": "Абдурахимов Сарварбек",
    "certificates": [
      {
        "id": "CERT-AS-1",
        "name": "Введение в Международный стандарт управления качеством (ISQM 1): принципы, структура и внедрение",
        "date": "14.11.2025",
        "time": "20 (5 дней)-часового курса"
      },
      {
        "id": "CERT-AS-2",
        "name": "Эффективная деловая коммуникация в профессиональной среде: навыки взаимодействия, переговоров и презентации",
        "date": "24.11.2025",
        "time": "2-часового курса"
      },
      {
        "id": "CERT-AS-3",
        "name": "Применение МСА 330: Аудиторские процедуры в ответ на оцененные риски существенного искажения",
        "date": "28.11.2025",
        "time": "2-часового курса"
      },
      {
        "id": "CERT-AS-4",
        "name": "Аудит оценочных значений, включая справедливую стоимость и резервы: применение МСА 540",
        "date": "05.12.2025",
        "time": "2-часового курса"
      },
      {
        "id": "CERT-AS-5",
        "name": "Разработка и реализация стратегии управления клиентским портфелем: сегментация, приоритеты и качество обслуживания",
        "date": "19.12.2025",
        "time": "6-часового курса"
      }
    ]
  },
  {
    "id": "EMP-2025-036-HI",
    "name": "Хошимов Иброхимжон",
    "certificates": [
      {
        "id": "CERT-HI-1",
        "name": "Введение в Международный стандарт управления качеством (ISQM 1): принципы, структура и внедрение",
        "date": "14.11.2025",
        "time": "20 (5 дней)-часового курса"
      },
      {
        "id": "CERT-HI-2",
        "name": "Эффективная деловая коммуникация в профессиональной среде: навыки взаимодействия, переговоров и презентации",
        "date": "24.11.2025",
        "time": "2-часового курса"
      },
      {
        "id": "CERT-HI-3",
        "name": "Применение МСА 330: Аудиторские процедуры в ответ на оцененные риски существенного искажения",
        "date": "28.11.2025",
        "time": "2-часового курса"
      },
      {
        "id": "CERT-HI-4",
        "name": "Аудит оценочных значений, включая справедливую стоимость и резервы: применение МСА 540",
        "date": "05.12.2025",
        "time": "2-часового курса"
      },
      {
        "id": "CERT-HI-5",
        "name": "Разработка и реализация стратегии управления клиентским портфелем: сегментация, приоритеты и качество обслуживания",
        "date": "19.12.2025",
        "time": "6-часового курса"
      }
    ]
  },
  {
    "id": "EMP-2025-037-YK",
    "name": "Юлдашева Камола",
    "certificates": [
      {
        "id": "CERT-YK-1",
        "name": "Введение в Международный стандарт управления качеством (ISQM 1): принципы, структура и внедрение",
        "date": "14.11.2025",
        "time": "20 (5 дней)-часового курса"
      },
      {
        "id": "CERT-YK-2",
        "name": "Эффективная деловая коммуникация в профессиональной среде: навыки взаимодействия, переговоров и презентации",
        "date": "24.11.2025",
        "time": "2-часового курса"
      },
      {
        "id": "CERT-YK-3",
        "name": "Применение МСА 330: Аудиторские процедуры в ответ на оцененные риски существенного искажения",
        "date": "28.11.2025",
        "time": "2-часового курса"
      },
      {
        "id": "CERT-YK-4",
        "name": "Аудит оценочных значений, включая справедливую стоимость и резервы: применение МСА 540",
        "date": "05.12.2025",
        "time": "2-часового курса"
      },
      {
        "id": "CERT-YK-5",
        "name": "Разработка и реализация стратегии управления клиентским портфелем: сегментация, приоритеты и качество обслуживания",
        "date": "19.12.2025",
        "time": "6-часового курса"
      }
    ]
  },
  {
    "id": "EMP-2025-038-SJ",
    "name": "Суннатуллаев Жавохир",
    "certificates": [
      {
        "id": "CERT-SJ-1",
        "name": "Введение в Международный стандарт управления качеством (ISQM 1): принципы, структура и внедрение",
        "date": "14.11.2025",
        "time": "20 (5 дней)-часового курса"
      },
      {
        "id": "CERT-SJ-2",
        "name": "Эффективная деловая коммуникация в профессиональной среде: навыки взаимодействия, переговоров и презентации",
        "date": "24.11.2025",
        "time": "2-часового курса"
      },
      {
        "id": "CERT-SJ-3",
        "name": "Применение МСА 330: Аудиторские процедуры в ответ на оцененные риски существенного искажения",
        "date": "28.11.2025",
        "time": "2-часового курса"
      },
      {
        "id": "CERT-SJ-4",
        "name": "Аудит оценочных значений, включая справедливую стоимость и резервы: применение МСА 540",
        "date": "05.12.2025",
        "time": "2-часового курса"
      },
      {
        "id": "CERT-SJ-5",
        "name": "Разработка и реализация стратегии управления клиентским портфелем: сегментация, приоритеты и качество обслуживания",
        "date": "19.12.2025",
        "time": "6-часового курса"
      }
    ]
  },
  {
    "id": "EMP-2025-039-ON",
    "name": "Олижонова Насиба",
    "certificates": [
      {
        "id": "CERT-ON-1",
        "name": "Введение в Международный стандарт управления качеством (ISQM 1): принципы, структура и внедрение",
        "date": "14.11.2025",
        "time": "20 (5 дней)-часового курса"
      },
      {
        "id": "CERT-ON-2",
        "name": "Эффективная деловая коммуникация в профессиональной среде: навыки взаимодействия, переговоров и презентации",
        "date": "24.11.2025",
        "time": "2-часового курса"
      },
      {
        "id": "CERT-ON-3",
        "name": "Применение МСА 330: Аудиторские процедуры в ответ на оцененные риски существенного искажения",
        "date": "28.11.2025",
        "time": "2-часового курса"
      },
      {
        "id": "CERT-ON-4",
        "name": "Аудит оценочных значений, включая справедливую стоимость и резервы: применение МСА 540",
        "date": "05.12.2025",
        "time": "2-часового курса"
      },
      {
        "id": "CERT-ON-5",
        "name": "Разработка и реализация стратегии управления клиентским портфелем: сегментация, приоритеты и качество обслуживания",
        "date": "19.12.2025",
        "time": "6-часового курса"
      }
    ]
  },
  {
    "id": "EMP-2025-040-UM",
    "name": "Уткирова Мадина",
    "certificates": [
      {
        "id": "CERT-UM-1",
        "name": "Введение в Международный стандарт управления качеством (ISQM 1): принципы, структура и внедрение",
        "date": "14.11.2025",
        "time": "20 (5 дней)-часового курса"
      },
      {
        "id": "CERT-UM-2",
        "name": "Эффективная деловая коммуникация в профессиональной среде: навыки взаимодействия, переговоров и презентации",
        "date": "24.11.2025",
        "time": "2-часового курса"
      },
      {
        "id": "CERT-UM-3",
        "name": "Применение МСА 330: Аудиторские процедуры в ответ на оцененные риски существенного искажения",
        "date": "28.11.2025",
        "time": "2-часового курса"
      },
      {
        "id": "CERT-UM-4",
        "name": "Аудит оценочных значений, включая справедливую стоимость и резервы: применение МСА 540",
        "date": "05.12.2025",
        "time": "2-часового курса"
      },
      {
        "id": "CERT-UM-5",
        "name": "Разработка и реализация стратегии управления клиентским портфелем: сегментация, приоритеты и качество обслуживания",
        "date": "19.12.2025",
        "time": "6-часового курса"
      }
    ]
  },
  {
    "id": "EMP-2025-041-SSH",
    "name": "Саид-Азизова Шахнозахон",
    "certificates": [
      {
        "id": "CERT-SSH-1",
        "name": "Введение в Международный стандарт управления качеством (ISQM 1): принципы, структура и внедрение",
        "date": "14.11.2025",
        "time": "20 (5 дней)-часового курса"
      },
      {
        "id": "CERT-SSH-2",
        "name": "Эффективная деловая коммуникация в профессиональной среде: навыки взаимодействия, переговоров и презентации",
        "date": "24.11.2025",
        "time": "2-часового курса"
      },
      {
        "id": "CERT-SSH-3",
        "name": "Применение МСА 330: Аудиторские процедуры в ответ на оцененные риски существенного искажения",
        "date": "28.11.2025",
        "time": "2-часового курса"
      },
      {
        "id": "CERT-SSH-4",
        "name": "Аудит оценочных значений, включая справедливую стоимость и резервы: применение МСА 540",
        "date": "05.12.2025",
        "time": "2-часового курса"
      },
      {
        "id": "CERT-SSH-5",
        "name": "Разработка и реализация стратегии управления клиентским портфелем: сегментация, приоритеты и качество обслуживания",
        "date": "19.12.2025",
        "time": "6-часового курса"
      }
    ]
  },
  {
    "id": "EMP-2025-042-KA",
    "name": "Кариев Азиз",
    "certificates": [
      {
        "id": "CERT-KA-1",
        "name": "Введение в Международный стандарт управления качеством (ISQM 1): принципы, структура и внедрение",
        "date": "14.11.2025",
        "time": "20 (5 дней)-часового курса"
      },
      {
        "id": "CERT-KA-2",
        "name": "Эффективная деловая коммуникация в профессиональной среде: навыки взаимодействия, переговоров и презентации",
        "date": "24.11.2025",
        "time": "2-часового курса"
      },
      {
        "id": "CERT-KA-3",
        "name": "Применение МСА 330: Аудиторские процедуры в ответ на оцененные риски существенного искажения",
        "date": "28.11.2025",
        "time": "2-часового курса"
      },
      {
        "id": "CERT-KA-4",
        "name": "Аудит оценочных значений, включая справедливую стоимость и резервы: применение МСА 540",
        "date": "05.12.2025",
        "time": "2-часового курса"
      },
      {
        "id": "CERT-KA-5",
        "name": "Разработка и реализация стратегии управления клиентским портфелем: сегментация, приоритеты и качество обслуживания",
        "date": "19.12.2025",
        "time": "6-часового курса"
      }
    ]
  },
  {
    "id": "EMP-2025-044-NKH",
    "name": "Носирова Халима",
    "certificates": [
      {
        "id": "CERT-NKH-1",
        "name": "Введение в Международный стандарт управления качеством (ISQM 1): принципы, структура и внедрение",
        "date": "14.11.2025",
        "time": "20 (5 дней)-часового курса"
      },
      {
        "id": "CERT-NKH-2",
        "name": "Эффективная деловая коммуникация в профессиональной среде: навыки взаимодействия, переговоров и презентации",
        "date": "24.11.2025",
        "time": "2-часового курса"
      },
      {
        "id": "CERT-NKH-3",
        "name": "Применение МСА 330: Аудиторские процедуры в ответ на оцененные риски существенного искажения",
        "date": "28.11.2025",
        "time": "2-часового курса"
      },
      {
        "id": "CERT-NKH-4",
        "name": "Аудит оценочных значений, включая справедливую стоимость и резервы: применение МСА 540",
        "date": "05.12.2025",
        "time": "2-часового курса"
      },
      {
        "id": "CERT-NKH-5",
        "name": "Разработка и реализация стратегии управления клиентским портфелем: сегментация, приоритеты и качество обслуживания",
        "date": "19.12.2025",
        "time": "6-часового курса"
      }
    ]
  },
  {
    "id": "EMP-2025-046-ZD",
    "name": "Зупарова Дилором",
    "certificates": [
      {
        "id": "CERT-ZD-1",
        "name": "Введение в Международный стандарт управления качеством (ISQM 1): принципы, структура и внедрение",
        "date": "14.11.2025",
        "time": "20 (5 дней)-часового курса"
      },
      {
        "id": "CERT-ZD-2",
        "name": "Эффективная деловая коммуникация в профессиональной среде: навыки взаимодействия, переговоров и презентации",
        "date": "24.11.2025",
        "time": "2-часового курса"
      },
      {
        "id": "CERT-ZD-3",
        "name": "Аудит оценочных значений, включая справедливую стоимость и резервы: применение МСА 540",
        "date": "05.12.2025",
        "time": "2-часового курса"
      },
      {
        "id": "CERT-ZD-4",
        "name": "Разработка и реализация стратегии управления клиентским портфелем: сегментация, приоритеты и качество обслуживания",
        "date": "19.12.2025",
        "time": "6-часового курса"
      }
    ]
  },
  {
    "id": "EMP-2025-001-KN",
    "name": "Каримов Нематулла",
    "certificates": [
      {
        "id": "CERT-KN-1",
        "name": "Принципы профессиональной этики и обеспечение независимости аудиторской организации",
        "date": "08.01.2025",
        "time": "8-часового курса"
      },
      {
        "id": "CERT-KN-2",
        "name": "Профессиональные требования к независимости аудитора",
        "date": "17.01.2025",
        "time": "6-часового курса"
      },
      {
        "id": "CERT-KN-3",
        "name": "Актуальные изменения в международных стандартах аудита и нормативных требованиях",
        "date": "24.01.2025",
        "time": "6-часового курса"
      },
      {
        "id": "CERT-KN-4",
        "name": "Применение МСА 315 при выявлении и оценке рисков существенного искажения финансовой отчетности",
        "date": "10.01.2025",
        "time": "2-часового курса"
      },
      {
        "id": "CERT-KN-5",
        "name": "Противодействие легализации доходов, полученных преступным путём, и финансированию терроризма",
        "date": "27.01.2025",
        "time": "2-часового курса"
      },
      {
        "id": "CERT-KN-6",
        "name": "Основы кибербезопасности и защита информации в аудиторской практике",
        "date": "07.02.2025",
        "time": "6-часового курса"
      },
      {
        "id": "CERT-KN-7",
        "name": "Международный стандарт контроля качества 1: Построение системы управления качеством в аудиторской фирме",
        "date": "14.03.2025",
        "time": "8-часового курса"
      },
      {
        "id": "CERT-KN-8",
        "name": "Комплексный обзор Международных стандартов аудита и их практическое применение",
        "date": "11.04.2025",
        "time": "8-часового курса"
      },
      {
        "id": "CERT-KN-9",
        "name": "Международные стандарты финансовой отчетности: принципы, структура и применение",
        "date": "16.05.2025",
        "time": "8-часового курса"
      },
      {
        "id": "CERT-KN-10",
        "name": "Аудиторские доказательства",
        "date": "11.07.2025",
        "time": "3-часового курса"
      },
      {
        "id": "CERT-KN-11",
        "name": "Эффективное взаимодействие с клиентами и обеспечение качества аудиторских услуг",
        "date": "15.08.2025",
        "time": "6-часового курса"
      },
      {
        "id": "CERT-KN-12",
        "name": "Нормативно-правовые требования и стандарты, применимые к аудиту в отдельных секторах экономики",
        "date": "12.09.2025",
        "time": "5-часового курса"
      },
      {
        "id": "CERT-KN-13",
        "name": "Введение в Международный стандарт управления качеством (ISQM 1): принципы, структура и внедрение",
        "date": "14.11.2025",
        "time": "20 (5 дней)-часового курса"
      },
      {
        "id": "CERT-KN-14",
        "name": "Эффективная деловая коммуникация в профессиональной среде: навыки взаимодействия, переговоров и презентации",
        "date": "24.11.2025",
        "time": "2-часового курса"
      },
      {
        "id": "CERT-KN-15",
        "name": "Применение МСА 330: Аудиторские процедуры в ответ на оцененные риски существенного искажения",
        "date": "28.11.2025",
        "time": "2-часового курса"
      },
      {
        "id": "CERT-KN-16",
        "name": "Аудит оценочных значений, включая справедливую стоимость и резервы: применение МСА 540",
        "date": "05.12.2025",
        "time": "2-часового курса"
      },
      {
        "id": "CERT-KN-17",
        "name": "Разработка и реализация стратегии управления клиентским портфелем: сегментация, приоритеты и качество обслуживания",
        "date": "19.12.2025",
        "time": "6-часового курса"
      }
    ]
  },

  {
    "id": "std-2024-001",
    "name": "Каримов Жамшид",
    "certificates": [
      {
        "id": "std-2024-001-1",
        "name": "Принципы профессиональной этики и обеспечение независимости аудиторской организации",
        "date": "06.01.2024",
        "time": "8-часового курса"
      },
      {
        "id": "std-2024-001-2",
        "name": "Профессиональные требования к независимости аудитора",
        "date": "12.01.2024",
        "time": "6-часового курса"
      },
      {
        "id": "std-2024-001-3",
        "name": "Применение МСА 315 при выявлении и оценке рисков существенного искажения финансовой отчетности",
        "date": "19.01.2024",
        "time": "2-часового курса"
      },
      {
        "id": "std-2024-001-4",
        "name": "Актуальные изменения в международных стандартах аудита и нормативных требованиях",
        "date": "26.01.2024",
        "time": "6-часового курса"
      },
      {
        "id": "std-2024-001-5",
        "name": "Основы кибербезопасности и защита информации в аудиторской практике",
        "date": "31.01.2024",
        "time": "6-часового курса"
      },
      {
        "id": "std-2024-001-6",
        "name": "Международный стандарт контроля качества 1: Построение системы управления качеством в аудиторской фирме",
        "date": "23.02.2024",
        "time": "8-часового курса"
      },
      {
        "id": "std-2024-001-7",
        "name": "Комплексный обзор Международных стандартов аудита и их практическое применение",
        "date": "15.03.2024",
        "time": "8-часового курса"
      },
      {
        "id": "std-2024-001-8",
        "name": "Международные стандарты финансовой отчетности: принципы, структура и применение",
        "date": "26.04.2024",
        "time": "8-часового курса"
      },
      {
        "id": "std-2024-001-9",
        "name": "Аудиторские доказательства",
        "date": "24.05.2024",
        "time": "3-часового курса"
      },
      {
        "id": "std-2024-001-10",
        "name": "Нормативно-правовые требования и стандарты, применимые к аудиту в отдельных секторах экономики",
        "date": "26.07.2024",
        "time": "5-часового курса"
      },
      {
        "id": "std-2024-001-11",
        "name": "Введение в Международный стандарт управления качеством (ISQM 1): принципы, структура и внедрение",
        "date": "29.08.2024",
        "time": "20 (5 дней)-часового курса"
      },
      {
        "id": "std-2024-001-12",
        "name": "Эффективная деловая коммуникация в профессиональной среде: навыки взаимодействия, переговоров и презентации",
        "date": "20.09.2024",
        "time": "2-часового курса"
      },
      {
        "id": "std-2024-001-13",
        "name": "Применение МСА 330: Аудиторские процедуры в ответ на оцененные риски существенного искажения",
        "date": "24.10.2024",
        "time": "2-часового курса"
      },
      {
        "id": "std-2024-001-14",
        "name": "Аудит оценочных значений, включая справедливую стоимость и резервы: применение МСА 540",
        "date": "25.10.2024",
        "time": "2-часового курса"
      },
      {
        "id": "std-2024-001-15",
        "name": "Разработка и реализация стратегии управления клиентским портфелем: сегментация, приоритеты и качество обслуживани",
        "date": "20.12.2024",
        "time": "6-часового курса"
      }
    ]
  },
  {
    "id": "std-2024-002",
    "name": "Шерембаева Феруза ",
    "certificates": [
      {
        "id": "std-2024-002-1",
        "name": "Принципы профессиональной этики и обеспечение независимости аудиторской организации",
        "date": "06.01.2024",
        "time": "8-часового курса"
      },
      {
        "id": "std-2024-002-2",
        "name": "Профессиональные требования к независимости аудитора",
        "date": "12.01.2024",
        "time": "6-часового курса"
      },
      {
        "id": "std-2024-002-3",
        "name": "Международный стандарт контроля качества 1: Построение системы управления качеством в аудиторской фирме",
        "date": "23.02.2024",
        "time": "8-часового курса"
      },
      {
        "id": "std-2024-002-4",
        "name": "Международные стандарты финансовой отчетности: принципы, структура и применение",
        "date": "26.04.2024",
        "time": "8-часового курса"
      },
      {
        "id": "std-2024-002-5",
        "name": "Аудиторские доказательства",
        "date": "24.05.2024",
        "time": "3-часового курса"
      },
      {
        "id": "std-2024-002-6",
        "name": "Нормативно-правовые требования и стандарты, применимые к аудиту в отдельных секторах экономики",
        "date": "26.07.2024",
        "time": "5-часового курса"
      },
      {
        "id": "std-2024-002-7",
        "name": "Введение в Международный стандарт управления качеством (ISQM 1): принципы, структура и внедрение",
        "date": "29.08.2024",
        "time": "20 (5 дней)-часового курса"
      },
      {
        "id": "std-2024-002-8",
        "name": "Эффективная деловая коммуникация в профессиональной среде: навыки взаимодействия, переговоров и презентации",
        "date": "20.09.2024",
        "time": "2-часового курса"
      }
    ]
  },
  {
    "id": "std-2024-003",
    "name": "Шеркузиев Уткиржон",
    "certificates": [
      {
        "id": "std-2024-003-1",
        "name": "Принципы профессиональной этики и обеспечение независимости аудиторской организации",
        "date": "06.01.2024",
        "time": "8-часового курса"
      },
      {
        "id": "std-2024-003-2",
        "name": "Профессиональные требования к независимости аудитора",
        "date": "12.01.2024",
        "time": "6-часового курса"
      },
      {
        "id": "std-2024-003-3",
        "name": "Актуальные изменения в международных стандартах аудита и нормативных требованиях",
        "date": "26.01.2024",
        "time": "6-часового курса"
      },
      {
        "id": "std-2024-003-4",
        "name": "Основы кибербезопасности и защита информации в аудиторской практике",
        "date": "31.01.2024",
        "time": "6-часового курса"
      },
      {
        "id": "std-2024-003-5",
        "name": "Международный стандарт контроля качества 1: Построение системы управления качеством в аудиторской фирме",
        "date": "23.02.2024",
        "time": "8-часового курса"
      },
      {
        "id": "std-2024-003-6",
        "name": "Аудиторские доказательства",
        "date": "24.05.2024",
        "time": "3-часового курса"
      },
      {
        "id": "std-2024-003-7",
        "name": "Эффективное взаимодействие с клиентами и обеспечение качества аудиторских услуг",
        "date": "21.06.2024",
        "time": "6-часового курса"
      }
    ]
  },
  {
    "id": "std-2024-004",
    "name": "Узаков Абдурасул ",
    "certificates": [
      {
        "id": "std-2024-004-1",
        "name": "Принципы профессиональной этики и обеспечение независимости аудиторской организации",
        "date": "06.01.2024",
        "time": "8-часового курса"
      },
      {
        "id": "std-2024-004-2",
        "name": "Профессиональные требования к независимости аудитора",
        "date": "12.01.2024",
        "time": "6-часового курса"
      },
      {
        "id": "std-2024-004-3",
        "name": "Применение МСА 315 при выявлении и оценке рисков существенного искажения финансовой отчетности",
        "date": "19.01.2024",
        "time": "2-часового курса"
      },
      {
        "id": "std-2024-004-4",
        "name": "Актуальные изменения в международных стандартах аудита и нормативных требованиях",
        "date": "26.01.2024",
        "time": "6-часового курса"
      },
      {
        "id": "std-2024-004-5",
        "name": "Основы кибербезопасности и защита информации в аудиторской практике",
        "date": "31.01.2024",
        "time": "6-часового курса"
      },
      {
        "id": "std-2024-004-6",
        "name": "Международный стандарт контроля качества 1: Построение системы управления качеством в аудиторской фирме",
        "date": "23.02.2024",
        "time": "8-часового курса"
      },
      {
        "id": "std-2024-004-7",
        "name": "Комплексный обзор Международных стандартов аудита и их практическое применение",
        "date": "15.03.2024",
        "time": "8-часового курса"
      },
      {
        "id": "std-2024-004-8",
        "name": "Международные стандарты финансовой отчетности: принципы, структура и применение",
        "date": "26.04.2024",
        "time": "8-часового курса"
      },
      {
        "id": "std-2024-004-9",
        "name": "Аудиторские доказательства",
        "date": "24.05.2024",
        "time": "3-часового курса"
      },
      {
        "id": "std-2024-004-10",
        "name": "Эффективное взаимодействие с клиентами и обеспечение качества аудиторских услуг",
        "date": "21.06.2024",
        "time": "6-часового курса"
      },
      {
        "id": "std-2024-004-11",
        "name": "Нормативно-правовые требования и стандарты, применимые к аудиту в отдельных секторах экономики",
        "date": "26.07.2024",
        "time": "5-часового курса"
      },
      {
        "id": "std-2024-004-12",
        "name": "Введение в Международный стандарт управления качеством (ISQM 1): принципы, структура и внедрение",
        "date": "29.08.2024",
        "time": "20 (5 дней)-часового курса"
      },
      {
        "id": "std-2024-004-13",
        "name": "Эффективная деловая коммуникация в профессиональной среде: навыки взаимодействия, переговоров и презентации",
        "date": "20.09.2024",
        "time": "2-часового курса"
      },
      {
        "id": "std-2024-004-14",
        "name": "Разработка и реализация стратегии управления клиентским портфелем: сегментация, приоритеты и качество обслуживани",
        "date": "20.12.2024",
        "time": "6-часового курса"
      }
    ]
  },
  {
    "id": "std-2024-005",
    "name": "Азимбаев Обиджан ",
    "certificates": [
      {
        "id": "std-2024-005-1",
        "name": "Принципы профессиональной этики и обеспечение независимости аудиторской организации",
        "date": "06.01.2024",
        "time": "8-часового курса"
      },
      {
        "id": "std-2024-005-2",
        "name": "Профессиональные требования к независимости аудитора",
        "date": "12.01.2024",
        "time": "6-часового курса"
      },
      {
        "id": "std-2024-005-3",
        "name": "Актуальные изменения в международных стандартах аудита и нормативных требованиях",
        "date": "26.01.2024",
        "time": "6-часового курса"
      },
      {
        "id": "std-2024-005-4",
        "name": "Основы кибербезопасности и защита информации в аудиторской практике",
        "date": "31.01.2024",
        "time": "6-часового курса"
      },
      {
        "id": "std-2024-005-5",
        "name": "Международный стандарт контроля качества 1: Построение системы управления качеством в аудиторской фирме",
        "date": "23.02.2024",
        "time": "8-часового курса"
      },
      {
        "id": "std-2024-005-6",
        "name": "Аудиторские доказательства",
        "date": "24.05.2024",
        "time": "3-часового курса"
      },
      {
        "id": "std-2024-005-7",
        "name": "Эффективное взаимодействие с клиентами и обеспечение качества аудиторских услуг",
        "date": "21.06.2024",
        "time": "6-часового курса"
      },
      {
        "id": "std-2024-005-8",
        "name": "Нормативно-правовые требования и стандарты, применимые к аудиту в отдельных секторах экономики",
        "date": "26.07.2024",
        "time": "5-часового курса"
      },
      {
        "id": "std-2024-005-9",
        "name": "Введение в Международный стандарт управления качеством (ISQM 1): принципы, структура и внедрение",
        "date": "29.08.2024",
        "time": "20 (5 дней)-часового курса"
      },
      {
        "id": "std-2024-005-10",
        "name": "Эффективная деловая коммуникация в профессиональной среде: навыки взаимодействия, переговоров и презентации",
        "date": "20.09.2024",
        "time": "2-часового курса"
      }
    ]
  },
  {
    "id": "std-2024-006",
    "name": "Носиров Шоодил ",
    "certificates": [
      {
        "id": "std-2024-006-1",
        "name": "Принципы профессиональной этики и обеспечение независимости аудиторской организации",
        "date": "06.01.2024",
        "time": "8-часового курса"
      },
      {
        "id": "std-2024-006-2",
        "name": "Профессиональные требования к независимости аудитора",
        "date": "12.01.2024",
        "time": "6-часового курса"
      },
      {
        "id": "std-2024-006-3",
        "name": "Применение МСА 315 при выявлении и оценке рисков существенного искажения финансовой отчетности",
        "date": "19.01.2024",
        "time": "2-часового курса"
      },
      {
        "id": "std-2024-006-4",
        "name": "Актуальные изменения в международных стандартах аудита и нормативных требованиях",
        "date": "26.01.2024",
        "time": "6-часового курса"
      },
      {
        "id": "std-2024-006-5",
        "name": "Основы кибербезопасности и защита информации в аудиторской практике",
        "date": "31.01.2024",
        "time": "6-часового курса"
      },
      {
        "id": "std-2024-006-6",
        "name": "Международный стандарт контроля качества 1: Построение системы управления качеством в аудиторской фирме",
        "date": "23.02.2024",
        "time": "8-часового курса"
      },
      {
        "id": "std-2024-006-7",
        "name": "Комплексный обзор Международных стандартов аудита и их практическое применение",
        "date": "15.03.2024",
        "time": "8-часового курса"
      },
      {
        "id": "std-2024-006-8",
        "name": "Международные стандарты финансовой отчетности: принципы, структура и применение",
        "date": "26.04.2024",
        "time": "8-часового курса"
      },
      {
        "id": "std-2024-006-9",
        "name": "Аудиторские доказательства",
        "date": "24.05.2024",
        "time": "3-часового курса"
      },
      {
        "id": "std-2024-006-10",
        "name": "Эффективное взаимодействие с клиентами и обеспечение качества аудиторских услуг",
        "date": "21.06.2024",
        "time": "6-часового курса"
      },
      {
        "id": "std-2024-006-11",
        "name": "Нормативно-правовые требования и стандарты, применимые к аудиту в отдельных секторах экономики",
        "date": "26.07.2024",
        "time": "5-часового курса"
      },
      {
        "id": "std-2024-006-12",
        "name": "Введение в Международный стандарт управления качеством (ISQM 1): принципы, структура и внедрение",
        "date": "29.08.2024",
        "time": "20 (5 дней)-часового курса"
      },
      {
        "id": "std-2024-006-13",
        "name": "Эффективная деловая коммуникация в профессиональной среде: навыки взаимодействия, переговоров и презентации",
        "date": "20.09.2024",
        "time": "2-часового курса"
      },
      {
        "id": "std-2024-006-14",
        "name": "Применение МСА 330: Аудиторские процедуры в ответ на оцененные риски существенного искажения",
        "date": "24.10.2024",
        "time": "2-часового курса"
      },
      {
        "id": "std-2024-006-15",
        "name": "Аудит оценочных значений, включая справедливую стоимость и резервы: применение МСА 540",
        "date": "25.10.2024",
        "time": "2-часового курса"
      },
      {
        "id": "std-2024-006-16",
        "name": "Разработка и реализация стратегии управления клиентским портфелем: сегментация, приоритеты и качество обслуживани",
        "date": "20.12.2024",
        "time": "6-часового курса"
      }
    ]
  },
  {
    "id": "std-2024-007",
    "name": "Тангиркулов Абдихофиз",
    "certificates": [
      {
        "id": "std-2024-007-1",
        "name": "Принципы профессиональной этики и обеспечение независимости аудиторской организации",
        "date": "06.01.2024",
        "time": "8-часового курса"
      },
      {
        "id": "std-2024-007-2",
        "name": "Профессиональные требования к независимости аудитора",
        "date": "12.01.2024",
        "time": "6-часового курса"
      },
      {
        "id": "std-2024-007-3",
        "name": "Применение МСА 315 при выявлении и оценке рисков существенного искажения финансовой отчетности",
        "date": "19.01.2024",
        "time": "2-часового курса"
      },
      {
        "id": "std-2024-007-4",
        "name": "Актуальные изменения в международных стандартах аудита и нормативных требованиях",
        "date": "26.01.2024",
        "time": "6-часового курса"
      },
      {
        "id": "std-2024-007-5",
        "name": "Основы кибербезопасности и защита информации в аудиторской практике",
        "date": "31.01.2024",
        "time": "6-часового курса"
      },
      {
        "id": "std-2024-007-6",
        "name": "Международный стандарт контроля качества 1: Построение системы управления качеством в аудиторской фирме",
        "date": "23.02.2024",
        "time": "8-часового курса"
      },
      {
        "id": "std-2024-007-7",
        "name": "Комплексный обзор Международных стандартов аудита и их практическое применение",
        "date": "15.03.2024",
        "time": "8-часового курса"
      },
      {
        "id": "std-2024-007-8",
        "name": "Международные стандарты финансовой отчетности: принципы, структура и применение",
        "date": "26.04.2024",
        "time": "8-часового курса"
      },
      {
        "id": "std-2024-007-9",
        "name": "Аудиторские доказательства",
        "date": "24.05.2024",
        "time": "3-часового курса"
      },
      {
        "id": "std-2024-007-10",
        "name": "Эффективное взаимодействие с клиентами и обеспечение качества аудиторских услуг",
        "date": "21.06.2024",
        "time": "6-часового курса"
      },
      {
        "id": "std-2024-007-11",
        "name": "Нормативно-правовые требования и стандарты, применимые к аудиту в отдельных секторах экономики",
        "date": "26.07.2024",
        "time": "5-часового курса"
      },
      {
        "id": "std-2024-007-12",
        "name": "Введение в Международный стандарт управления качеством (ISQM 1): принципы, структура и внедрение",
        "date": "29.08.2024",
        "time": "20 (5 дней)-часового курса"
      },
      {
        "id": "std-2024-007-13",
        "name": "Эффективная деловая коммуникация в профессиональной среде: навыки взаимодействия, переговоров и презентации",
        "date": "20.09.2024",
        "time": "2-часового курса"
      },
      {
        "id": "std-2024-007-14",
        "name": "Применение МСА 330: Аудиторские процедуры в ответ на оцененные риски существенного искажения",
        "date": "24.10.2024",
        "time": "2-часового курса"
      },
      {
        "id": "std-2024-007-15",
        "name": "Аудит оценочных значений, включая справедливую стоимость и резервы: применение МСА 540",
        "date": "25.10.2024",
        "time": "2-часового курса"
      },
      {
        "id": "std-2024-007-16",
        "name": "Разработка и реализация стратегии управления клиентским портфелем: сегментация, приоритеты и качество обслуживани",
        "date": "20.12.2024",
        "time": "6-часового курса"
      }
    ]
  },
  {
    "id": "std-2024-008",
    "name": "Йулчиев Нодиржон ",
    "certificates": [
      {
        "id": "std-2024-008-1",
        "name": "Принципы профессиональной этики и обеспечение независимости аудиторской организации",
        "date": "06.01.2024",
        "time": "8-часового курса"
      },
      {
        "id": "std-2024-008-2",
        "name": "Профессиональные требования к независимости аудитора",
        "date": "12.01.2024",
        "time": "6-часового курса"
      },
      {
        "id": "std-2024-008-3",
        "name": "Применение МСА 315 при выявлении и оценке рисков существенного искажения финансовой отчетности",
        "date": "19.01.2024",
        "time": "2-часового курса"
      },
      {
        "id": "std-2024-008-4",
        "name": "Актуальные изменения в международных стандартах аудита и нормативных требованиях",
        "date": "26.01.2024",
        "time": "6-часового курса"
      },
      {
        "id": "std-2024-008-5",
        "name": "Основы кибербезопасности и защита информации в аудиторской практике",
        "date": "31.01.2024",
        "time": "6-часового курса"
      },
      {
        "id": "std-2024-008-6",
        "name": "Международный стандарт контроля качества 1: Построение системы управления качеством в аудиторской фирме",
        "date": "23.02.2024",
        "time": "8-часового курса"
      },
      {
        "id": "std-2024-008-7",
        "name": "Комплексный обзор Международных стандартов аудита и их практическое применение",
        "date": "15.03.2024",
        "time": "8-часового курса"
      },
      {
        "id": "std-2024-008-8",
        "name": "Международные стандарты финансовой отчетности: принципы, структура и применение",
        "date": "26.04.2024",
        "time": "8-часового курса"
      },
      {
        "id": "std-2024-008-9",
        "name": "Аудиторские доказательства",
        "date": "24.05.2024",
        "time": "3-часового курса"
      },
      {
        "id": "std-2024-008-10",
        "name": "Эффективное взаимодействие с клиентами и обеспечение качества аудиторских услуг",
        "date": "21.06.2024",
        "time": "6-часового курса"
      },
      {
        "id": "std-2024-008-11",
        "name": "Введение в Международный стандарт управления качеством (ISQM 1): принципы, структура и внедрение",
        "date": "29.08.2024",
        "time": "20 (5 дней)-часового курса"
      },
      {
        "id": "std-2024-008-12",
        "name": "Эффективная деловая коммуникация в профессиональной среде: навыки взаимодействия, переговоров и презентации",
        "date": "20.09.2024",
        "time": "2-часового курса"
      },
      {
        "id": "std-2024-008-13",
        "name": "Применение МСА 330: Аудиторские процедуры в ответ на оцененные риски существенного искажения",
        "date": "24.10.2024",
        "time": "2-часового курса"
      },
      {
        "id": "std-2024-008-14",
        "name": "Аудит оценочных значений, включая справедливую стоимость и резервы: применение МСА 540",
        "date": "25.10.2024",
        "time": "2-часового курса"
      },
      {
        "id": "std-2024-008-15",
        "name": "Разработка и реализация стратегии управления клиентским портфелем: сегментация, приоритеты и качество обслуживани",
        "date": "20.12.2024",
        "time": "6-часового курса"
      }
    ]
  },
  {
    "id": "std-2024-009",
    "name": "Юлдашев Рахматулло ",
    "certificates": [
      {
        "id": "std-2024-009-1",
        "name": "Принципы профессиональной этики и обеспечение независимости аудиторской организации",
        "date": "06.01.2024",
        "time": "8-часового курса"
      },
      {
        "id": "std-2024-009-2",
        "name": "Профессиональные требования к независимости аудитора",
        "date": "12.01.2024",
        "time": "6-часового курса"
      },
      {
        "id": "std-2024-009-3",
        "name": "Применение МСА 315 при выявлении и оценке рисков существенного искажения финансовой отчетности",
        "date": "19.01.2024",
        "time": "2-часового курса"
      },
      {
        "id": "std-2024-009-4",
        "name": "Актуальные изменения в международных стандартах аудита и нормативных требованиях",
        "date": "26.01.2024",
        "time": "6-часового курса"
      },
      {
        "id": "std-2024-009-5",
        "name": "Основы кибербезопасности и защита информации в аудиторской практике",
        "date": "31.01.2024",
        "time": "6-часового курса"
      },
      {
        "id": "std-2024-009-6",
        "name": "Международный стандарт контроля качества 1: Построение системы управления качеством в аудиторской фирме",
        "date": "23.02.2024",
        "time": "8-часового курса"
      },
      {
        "id": "std-2024-009-7",
        "name": "Комплексный обзор Международных стандартов аудита и их практическое применение",
        "date": "15.03.2024",
        "time": "8-часового курса"
      },
      {
        "id": "std-2024-009-8",
        "name": "Международные стандарты финансовой отчетности: принципы, структура и применение",
        "date": "26.04.2024",
        "time": "8-часового курса"
      },
      {
        "id": "std-2024-009-9",
        "name": "Аудиторские доказательства",
        "date": "24.05.2024",
        "time": "3-часового курса"
      },
      {
        "id": "std-2024-009-10",
        "name": "Эффективное взаимодействие с клиентами и обеспечение качества аудиторских услуг",
        "date": "21.06.2024",
        "time": "6-часового курса"
      },
      {
        "id": "std-2024-009-11",
        "name": "Нормативно-правовые требования и стандарты, применимые к аудиту в отдельных секторах экономики",
        "date": "26.07.2024",
        "time": "5-часового курса"
      },
      {
        "id": "std-2024-009-12",
        "name": "Введение в Международный стандарт управления качеством (ISQM 1): принципы, структура и внедрение",
        "date": "29.08.2024",
        "time": "20 (5 дней)-часового курса"
      },
      {
        "id": "std-2024-009-13",
        "name": "Эффективная деловая коммуникация в профессиональной среде: навыки взаимодействия, переговоров и презентации",
        "date": "20.09.2024",
        "time": "2-часового курса"
      },
      {
        "id": "std-2024-009-14",
        "name": "Разработка и реализация стратегии управления клиентским портфелем: сегментация, приоритеты и качество обслуживани",
        "date": "20.12.2024",
        "time": "6-часового курса"
      }
    ]
  },
  {
    "id": "std-2024-010",
    "name": "Разаков Элдор ",
    "certificates": [
      {
        "id": "std-2024-010-1",
        "name": "Принципы профессиональной этики и обеспечение независимости аудиторской организации",
        "date": "06.01.2024",
        "time": "8-часового курса"
      },
      {
        "id": "std-2024-010-2",
        "name": "Профессиональные требования к независимости аудитора",
        "date": "12.01.2024",
        "time": "6-часового курса"
      },
      {
        "id": "std-2024-010-3",
        "name": "Применение МСА 315 при выявлении и оценке рисков существенного искажения финансовой отчетности",
        "date": "19.01.2024",
        "time": "2-часового курса"
      },
      {
        "id": "std-2024-010-4",
        "name": "Актуальные изменения в международных стандартах аудита и нормативных требованиях",
        "date": "26.01.2024",
        "time": "6-часового курса"
      },
      {
        "id": "std-2024-010-5",
        "name": "Основы кибербезопасности и защита информации в аудиторской практике",
        "date": "31.01.2024",
        "time": "6-часового курса"
      },
      {
        "id": "std-2024-010-6",
        "name": "Международный стандарт контроля качества 1: Построение системы управления качеством в аудиторской фирме",
        "date": "23.02.2024",
        "time": "8-часового курса"
      },
      {
        "id": "std-2024-010-7",
        "name": "Комплексный обзор Международных стандартов аудита и их практическое применение",
        "date": "15.03.2024",
        "time": "8-часового курса"
      },
      {
        "id": "std-2024-010-8",
        "name": "Международные стандарты финансовой отчетности: принципы, структура и применение",
        "date": "26.04.2024",
        "time": "8-часового курса"
      },
      {
        "id": "std-2024-010-9",
        "name": "Аудиторские доказательства",
        "date": "24.05.2024",
        "time": "3-часового курса"
      },
      {
        "id": "std-2024-010-10",
        "name": "Эффективное взаимодействие с клиентами и обеспечение качества аудиторских услуг",
        "date": "21.06.2024",
        "time": "6-часового курса"
      },
      {
        "id": "std-2024-010-11",
        "name": "Нормативно-правовые требования и стандарты, применимые к аудиту в отдельных секторах экономики",
        "date": "26.07.2024",
        "time": "5-часового курса"
      },
      {
        "id": "std-2024-010-12",
        "name": "Введение в Международный стандарт управления качеством (ISQM 1): принципы, структура и внедрение",
        "date": "29.08.2024",
        "time": "20 (5 дней)-часового курса"
      },
      {
        "id": "std-2024-010-13",
        "name": "Эффективная деловая коммуникация в профессиональной среде: навыки взаимодействия, переговоров и презентации",
        "date": "20.09.2024",
        "time": "2-часового курса"
      },
      {
        "id": "std-2024-010-14",
        "name": "Аудит оценочных значений, включая справедливую стоимость и резервы: применение МСА 540",
        "date": "25.10.2024",
        "time": "2-часового курса"
      },
      {
        "id": "std-2024-010-15",
        "name": "Разработка и реализация стратегии управления клиентским портфелем: сегментация, приоритеты и качество обслуживани",
        "date": "20.12.2024",
        "time": "6-часового курса"
      }
    ]
  },
  {
    "id": "std-2024-011",
    "name": "Туляганов Жахонгир ",
    "certificates": [
      {
        "id": "std-2024-011-1",
        "name": "Принципы профессиональной этики и обеспечение независимости аудиторской организации",
        "date": "06.01.2024",
        "time": "8-часового курса"
      },
      {
        "id": "std-2024-011-2",
        "name": "Профессиональные требования к независимости аудитора",
        "date": "12.01.2024",
        "time": "6-часового курса"
      },
      {
        "id": "std-2024-011-3",
        "name": "Применение МСА 315 при выявлении и оценке рисков существенного искажения финансовой отчетности",
        "date": "19.01.2024",
        "time": "2-часового курса"
      },
      {
        "id": "std-2024-011-4",
        "name": "Актуальные изменения в международных стандартах аудита и нормативных требованиях",
        "date": "26.01.2024",
        "time": "6-часового курса"
      },
      {
        "id": "std-2024-011-5",
        "name": "Основы кибербезопасности и защита информации в аудиторской практике",
        "date": "31.01.2024",
        "time": "6-часового курса"
      },
      {
        "id": "std-2024-011-6",
        "name": "Международный стандарт контроля качества 1: Построение системы управления качеством в аудиторской фирме",
        "date": "23.02.2024",
        "time": "8-часового курса"
      },
      {
        "id": "std-2024-011-7",
        "name": "Комплексный обзор Международных стандартов аудита и их практическое применение",
        "date": "15.03.2024",
        "time": "8-часового курса"
      },
      {
        "id": "std-2024-011-8",
        "name": "Международные стандарты финансовой отчетности: принципы, структура и применение",
        "date": "26.04.2024",
        "time": "8-часового курса"
      },
      {
        "id": "std-2024-011-9",
        "name": "Аудиторские доказательства",
        "date": "24.05.2024",
        "time": "3-часового курса"
      },
      {
        "id": "std-2024-011-10",
        "name": "Эффективное взаимодействие с клиентами и обеспечение качества аудиторских услуг",
        "date": "21.06.2024",
        "time": "6-часового курса"
      },
      {
        "id": "std-2024-011-11",
        "name": "Нормативно-правовые требования и стандарты, применимые к аудиту в отдельных секторах экономики",
        "date": "26.07.2024",
        "time": "5-часового курса"
      },
      {
        "id": "std-2024-011-12",
        "name": "Введение в Международный стандарт управления качеством (ISQM 1): принципы, структура и внедрение",
        "date": "29.08.2024",
        "time": "20 (5 дней)-часового курса"
      },
      {
        "id": "std-2024-011-13",
        "name": "Применение МСА 330: Аудиторские процедуры в ответ на оцененные риски существенного искажения",
        "date": "24.10.2024",
        "time": "2-часового курса"
      },
      {
        "id": "std-2024-011-14",
        "name": "Аудит оценочных значений, включая справедливую стоимость и резервы: применение МСА 540",
        "date": "25.10.2024",
        "time": "2-часового курса"
      },
      {
        "id": "std-2024-011-15",
        "name": "Разработка и реализация стратегии управления клиентским портфелем: сегментация, приоритеты и качество обслуживани",
        "date": "20.12.2024",
        "time": "6-часового курса"
      }
    ]
  },
  {
    "id": "std-2024-012",
    "name": "Акмалов Саидалихон",
    "certificates": [
      {
        "id": "std-2024-012-1",
        "name": "Принципы профессиональной этики и обеспечение независимости аудиторской организации",
        "date": "06.01.2024",
        "time": "8-часового курса"
      },
      {
        "id": "std-2024-012-2",
        "name": "Профессиональные требования к независимости аудитора",
        "date": "12.01.2024",
        "time": "6-часового курса"
      },
      {
        "id": "std-2024-012-3",
        "name": "Применение МСА 315 при выявлении и оценке рисков существенного искажения финансовой отчетности",
        "date": "19.01.2024",
        "time": "2-часового курса"
      },
      {
        "id": "std-2024-012-4",
        "name": "Актуальные изменения в международных стандартах аудита и нормативных требованиях",
        "date": "26.01.2024",
        "time": "6-часового курса"
      },
      {
        "id": "std-2024-012-5",
        "name": "Основы кибербезопасности и защита информации в аудиторской практике",
        "date": "31.01.2024",
        "time": "6-часового курса"
      },
      {
        "id": "std-2024-012-6",
        "name": "Международный стандарт контроля качества 1: Построение системы управления качеством в аудиторской фирме",
        "date": "23.02.2024",
        "time": "8-часового курса"
      },
      {
        "id": "std-2024-012-7",
        "name": "Комплексный обзор Международных стандартов аудита и их практическое применение",
        "date": "15.03.2024",
        "time": "8-часового курса"
      },
      {
        "id": "std-2024-012-8",
        "name": "Международные стандарты финансовой отчетности: принципы, структура и применение",
        "date": "26.04.2024",
        "time": "8-часового курса"
      },
      {
        "id": "std-2024-012-9",
        "name": "Аудиторские доказательства",
        "date": "24.05.2024",
        "time": "3-часового курса"
      },
      {
        "id": "std-2024-012-10",
        "name": "Эффективное взаимодействие с клиентами и обеспечение качества аудиторских услуг",
        "date": "21.06.2024",
        "time": "6-часового курса"
      },
      {
        "id": "std-2024-012-11",
        "name": "Нормативно-правовые требования и стандарты, применимые к аудиту в отдельных секторах экономики",
        "date": "26.07.2024",
        "time": "5-часового курса"
      },
      {
        "id": "std-2024-012-12",
        "name": "Введение в Международный стандарт управления качеством (ISQM 1): принципы, структура и внедрение",
        "date": "29.08.2024",
        "time": "20 (5 дней)-часового курса"
      },
      {
        "id": "std-2024-012-13",
        "name": "Эффективная деловая коммуникация в профессиональной среде: навыки взаимодействия, переговоров и презентации",
        "date": "20.09.2024",
        "time": "2-часового курса"
      },
      {
        "id": "std-2024-012-14",
        "name": "Применение МСА 330: Аудиторские процедуры в ответ на оцененные риски существенного искажения",
        "date": "24.10.2024",
        "time": "2-часового курса"
      },
      {
        "id": "std-2024-012-15",
        "name": "Аудит оценочных значений, включая справедливую стоимость и резервы: применение МСА 540",
        "date": "25.10.2024",
        "time": "2-часового курса"
      },
      {
        "id": "std-2024-012-16",
        "name": "Разработка и реализация стратегии управления клиентским портфелем: сегментация, приоритеты и качество обслуживани",
        "date": "20.12.2024",
        "time": "6-часового курса"
      }
    ]
  },
  {
    "id": "std-2024-013",
    "name": "Ходжимухамедов Жамолиддин ",
    "certificates": [
      {
        "id": "std-2024-013-1",
        "name": "Принципы профессиональной этики и обеспечение независимости аудиторской организации",
        "date": "06.01.2024",
        "time": "8-часового курса"
      },
      {
        "id": "std-2024-013-2",
        "name": "Профессиональные требования к независимости аудитора",
        "date": "12.01.2024",
        "time": "6-часового курса"
      },
      {
        "id": "std-2024-013-3",
        "name": "Применение МСА 315 при выявлении и оценке рисков существенного искажения финансовой отчетности",
        "date": "19.01.2024",
        "time": "2-часового курса"
      },
      {
        "id": "std-2024-013-4",
        "name": "Актуальные изменения в международных стандартах аудита и нормативных требованиях",
        "date": "26.01.2024",
        "time": "6-часового курса"
      },
      {
        "id": "std-2024-013-5",
        "name": "Основы кибербезопасности и защита информации в аудиторской практике",
        "date": "31.01.2024",
        "time": "6-часового курса"
      },
      {
        "id": "std-2024-013-6",
        "name": "Международный стандарт контроля качества 1: Построение системы управления качеством в аудиторской фирме",
        "date": "23.02.2024",
        "time": "8-часового курса"
      },
      {
        "id": "std-2024-013-7",
        "name": "Комплексный обзор Международных стандартов аудита и их практическое применение",
        "date": "15.03.2024",
        "time": "8-часового курса"
      },
      {
        "id": "std-2024-013-8",
        "name": "Аудиторские доказательства",
        "date": "24.05.2024",
        "time": "3-часового курса"
      },
      {
        "id": "std-2024-013-9",
        "name": "Эффективное взаимодействие с клиентами и обеспечение качества аудиторских услуг",
        "date": "21.06.2024",
        "time": "6-часового курса"
      },
      {
        "id": "std-2024-013-10",
        "name": "Введение в Международный стандарт управления качеством (ISQM 1): принципы, структура и внедрение",
        "date": "29.08.2024",
        "time": "20 (5 дней)-часового курса"
      },
      {
        "id": "std-2024-013-11",
        "name": "Эффективная деловая коммуникация в профессиональной среде: навыки взаимодействия, переговоров и презентации",
        "date": "20.09.2024",
        "time": "2-часового курса"
      },
      {
        "id": "std-2024-013-12",
        "name": "Применение МСА 330: Аудиторские процедуры в ответ на оцененные риски существенного искажения",
        "date": "24.10.2024",
        "time": "2-часового курса"
      },
      {
        "id": "std-2024-013-13",
        "name": "Аудит оценочных значений, включая справедливую стоимость и резервы: применение МСА 540",
        "date": "25.10.2024",
        "time": "2-часового курса"
      },
      {
        "id": "std-2024-013-14",
        "name": "Разработка и реализация стратегии управления клиентским портфелем: сегментация, приоритеты и качество обслуживани",
        "date": "20.12.2024",
        "time": "6-часового курса"
      }
    ]
  },
  {
    "id": "std-2024-014",
    "name": "Жумабоев Толибжон ",
    "certificates": [
      {
        "id": "std-2024-014-1",
        "name": "Принципы профессиональной этики и обеспечение независимости аудиторской организации",
        "date": "06.01.2024",
        "time": "8-часового курса"
      },
      {
        "id": "std-2024-014-2",
        "name": "Профессиональные требования к независимости аудитора",
        "date": "12.01.2024",
        "time": "6-часового курса"
      },
      {
        "id": "std-2024-014-3",
        "name": "Применение МСА 315 при выявлении и оценке рисков существенного искажения финансовой отчетности",
        "date": "19.01.2024",
        "time": "2-часового курса"
      },
      {
        "id": "std-2024-014-4",
        "name": "Актуальные изменения в международных стандартах аудита и нормативных требованиях",
        "date": "26.01.2024",
        "time": "6-часового курса"
      },
      {
        "id": "std-2024-014-5",
        "name": "Основы кибербезопасности и защита информации в аудиторской практике",
        "date": "31.01.2024",
        "time": "6-часового курса"
      },
      {
        "id": "std-2024-014-6",
        "name": "Международный стандарт контроля качества 1: Построение системы управления качеством в аудиторской фирме",
        "date": "23.02.2024",
        "time": "8-часового курса"
      },
      {
        "id": "std-2024-014-7",
        "name": "Комплексный обзор Международных стандартов аудита и их практическое применение",
        "date": "15.03.2024",
        "time": "8-часового курса"
      },
      {
        "id": "std-2024-014-8",
        "name": "Международные стандарты финансовой отчетности: принципы, структура и применение",
        "date": "26.04.2024",
        "time": "8-часового курса"
      },
      {
        "id": "std-2024-014-9",
        "name": "Аудиторские доказательства",
        "date": "24.05.2024",
        "time": "3-часового курса"
      },
      {
        "id": "std-2024-014-10",
        "name": "Эффективное взаимодействие с клиентами и обеспечение качества аудиторских услуг",
        "date": "21.06.2024",
        "time": "6-часового курса"
      },
      {
        "id": "std-2024-014-11",
        "name": "Нормативно-правовые требования и стандарты, применимые к аудиту в отдельных секторах экономики",
        "date": "26.07.2024",
        "time": "5-часового курса"
      },
      {
        "id": "std-2024-014-12",
        "name": "Введение в Международный стандарт управления качеством (ISQM 1): принципы, структура и внедрение",
        "date": "29.08.2024",
        "time": "20 (5 дней)-часового курса"
      },
      {
        "id": "std-2024-014-13",
        "name": "Эффективная деловая коммуникация в профессиональной среде: навыки взаимодействия, переговоров и презентации",
        "date": "20.09.2024",
        "time": "2-часового курса"
      },
      {
        "id": "std-2024-014-14",
        "name": "Применение МСА 330: Аудиторские процедуры в ответ на оцененные риски существенного искажения",
        "date": "24.10.2024",
        "time": "2-часового курса"
      },
      {
        "id": "std-2024-014-15",
        "name": "Аудит оценочных значений, включая справедливую стоимость и резервы: применение МСА 540",
        "date": "25.10.2024",
        "time": "2-часового курса"
      },
      {
        "id": "std-2024-014-16",
        "name": "Разработка и реализация стратегии управления клиентским портфелем: сегментация, приоритеты и качество обслуживани",
        "date": "20.12.2024",
        "time": "6-часового курса"
      }
    ]
  },
  {
    "id": "std-2024-015",
    "name": "Тошпулатова Икболой",
    "certificates": [
      {
        "id": "std-2024-015-1",
        "name": "Принципы профессиональной этики и обеспечение независимости аудиторской организации",
        "date": "06.01.2024",
        "time": "8-часового курса"
      },
      {
        "id": "std-2024-015-2",
        "name": "Профессиональные требования к независимости аудитора",
        "date": "12.01.2024",
        "time": "6-часового курса"
      },
      {
        "id": "std-2024-015-3",
        "name": "Применение МСА 315 при выявлении и оценке рисков существенного искажения финансовой отчетности",
        "date": "19.01.2024",
        "time": "2-часового курса"
      },
      {
        "id": "std-2024-015-4",
        "name": "Актуальные изменения в международных стандартах аудита и нормативных требованиях",
        "date": "26.01.2024",
        "time": "6-часового курса"
      },
      {
        "id": "std-2024-015-5",
        "name": "Основы кибербезопасности и защита информации в аудиторской практике",
        "date": "31.01.2024",
        "time": "6-часового курса"
      },
      {
        "id": "std-2024-015-6",
        "name": "Международный стандарт контроля качества 1: Построение системы управления качеством в аудиторской фирме",
        "date": "23.02.2024",
        "time": "8-часового курса"
      },
      {
        "id": "std-2024-015-7",
        "name": "Комплексный обзор Международных стандартов аудита и их практическое применение",
        "date": "15.03.2024",
        "time": "8-часового курса"
      },
      {
        "id": "std-2024-015-8",
        "name": "Международные стандарты финансовой отчетности: принципы, структура и применение",
        "date": "26.04.2024",
        "time": "8-часового курса"
      },
      {
        "id": "std-2024-015-9",
        "name": "Аудиторские доказательства",
        "date": "24.05.2024",
        "time": "3-часового курса"
      },
      {
        "id": "std-2024-015-10",
        "name": "Эффективное взаимодействие с клиентами и обеспечение качества аудиторских услуг",
        "date": "21.06.2024",
        "time": "6-часового курса"
      },
      {
        "id": "std-2024-015-11",
        "name": "Нормативно-правовые требования и стандарты, применимые к аудиту в отдельных секторах экономики",
        "date": "26.07.2024",
        "time": "5-часового курса"
      },
      {
        "id": "std-2024-015-12",
        "name": "Введение в Международный стандарт управления качеством (ISQM 1): принципы, структура и внедрение",
        "date": "29.08.2024",
        "time": "20 (5 дней)-часового курса"
      },
      {
        "id": "std-2024-015-13",
        "name": "Эффективная деловая коммуникация в профессиональной среде: навыки взаимодействия, переговоров и презентации",
        "date": "20.09.2024",
        "time": "2-часового курса"
      },
      {
        "id": "std-2024-015-14",
        "name": "Применение МСА 330: Аудиторские процедуры в ответ на оцененные риски существенного искажения",
        "date": "24.10.2024",
        "time": "2-часового курса"
      },
      {
        "id": "std-2024-015-15",
        "name": "Аудит оценочных значений, включая справедливую стоимость и резервы: применение МСА 540",
        "date": "25.10.2024",
        "time": "2-часового курса"
      },
      {
        "id": "std-2024-015-16",
        "name": "Разработка и реализация стратегии управления клиентским портфелем: сегментация, приоритеты и качество обслуживани",
        "date": "20.12.2024",
        "time": "6-часового курса"
      }
    ]
  },
  {
    "id": "std-2024-016",
    "name": "Фаттохом Исломжон",
    "certificates": [
      {
        "id": "std-2024-016-1",
        "name": "Принципы профессиональной этики и обеспечение независимости аудиторской организации",
        "date": "06.01.2024",
        "time": "8-часового курса"
      },
      {
        "id": "std-2024-016-2",
        "name": "Профессиональные требования к независимости аудитора",
        "date": "12.01.2024",
        "time": "6-часового курса"
      },
      {
        "id": "std-2024-016-3",
        "name": "Применение МСА 315 при выявлении и оценке рисков существенного искажения финансовой отчетности",
        "date": "19.01.2024",
        "time": "2-часового курса"
      },
      {
        "id": "std-2024-016-4",
        "name": "Актуальные изменения в международных стандартах аудита и нормативных требованиях",
        "date": "26.01.2024",
        "time": "6-часового курса"
      },
      {
        "id": "std-2024-016-5",
        "name": "Основы кибербезопасности и защита информации в аудиторской практике",
        "date": "31.01.2024",
        "time": "6-часового курса"
      },
      {
        "id": "std-2024-016-6",
        "name": "Международный стандарт контроля качества 1: Построение системы управления качеством в аудиторской фирме",
        "date": "23.02.2024",
        "time": "8-часового курса"
      },
      {
        "id": "std-2024-016-7",
        "name": "Комплексный обзор Международных стандартов аудита и их практическое применение",
        "date": "15.03.2024",
        "time": "8-часового курса"
      },
      {
        "id": "std-2024-016-8",
        "name": "Международные стандарты финансовой отчетности: принципы, структура и применение",
        "date": "26.04.2024",
        "time": "8-часового курса"
      },
      {
        "id": "std-2024-016-9",
        "name": "Аудиторские доказательства",
        "date": "24.05.2024",
        "time": "3-часового курса"
      }
    ]
  },
  {
    "id": "std-2024-017",
    "name": "Омонова Элеонора",
    "certificates": [
      {
        "id": "std-2024-017-1",
        "name": "Принципы профессиональной этики и обеспечение независимости аудиторской организации",
        "date": "06.01.2024",
        "time": "8-часового курса"
      },
      {
        "id": "std-2024-017-2",
        "name": "Профессиональные требования к независимости аудитора",
        "date": "12.01.2024",
        "time": "6-часового курса"
      },
      {
        "id": "std-2024-017-3",
        "name": "Применение МСА 315 при выявлении и оценке рисков существенного искажения финансовой отчетности",
        "date": "19.01.2024",
        "time": "2-часового курса"
      },
      {
        "id": "std-2024-017-4",
        "name": "Международный стандарт контроля качества 1: Построение системы управления качеством в аудиторской фирме",
        "date": "23.02.2024",
        "time": "8-часового курса"
      },
      {
        "id": "std-2024-017-5",
        "name": "Комплексный обзор Международных стандартов аудита и их практическое применение",
        "date": "15.03.2024",
        "time": "8-часового курса"
      },
      {
        "id": "std-2024-017-6",
        "name": "Международные стандарты финансовой отчетности: принципы, структура и применение",
        "date": "26.04.2024",
        "time": "8-часового курса"
      },
      {
        "id": "std-2024-017-7",
        "name": "Аудиторские доказательства",
        "date": "24.05.2024",
        "time": "3-часового курса"
      },
      {
        "id": "std-2024-017-8",
        "name": "Эффективное взаимодействие с клиентами и обеспечение качества аудиторских услуг",
        "date": "21.06.2024",
        "time": "6-часового курса"
      },
      {
        "id": "std-2024-017-9",
        "name": "Нормативно-правовые требования и стандарты, применимые к аудиту в отдельных секторах экономики",
        "date": "26.07.2024",
        "time": "5-часового курса"
      },
      {
        "id": "std-2024-017-10",
        "name": "Введение в Международный стандарт управления качеством (ISQM 1): принципы, структура и внедрение",
        "date": "29.08.2024",
        "time": "20 (5 дней)-часового курса"
      },
      {
        "id": "std-2024-017-11",
        "name": "Эффективная деловая коммуникация в профессиональной среде: навыки взаимодействия, переговоров и презентации",
        "date": "20.09.2024",
        "time": "2-часового курса"
      },
      {
        "id": "std-2024-017-12",
        "name": "Применение МСА 330: Аудиторские процедуры в ответ на оцененные риски существенного искажения",
        "date": "24.10.2024",
        "time": "2-часового курса"
      },
      {
        "id": "std-2024-017-13",
        "name": "Аудит оценочных значений, включая справедливую стоимость и резервы: применение МСА 540",
        "date": "25.10.2024",
        "time": "2-часового курса"
      },
      {
        "id": "std-2024-017-14",
        "name": "Разработка и реализация стратегии управления клиентским портфелем: сегментация, приоритеты и качество обслуживани",
        "date": "20.12.2024",
        "time": "6-часового курса"
      }
    ]
  },
  {
    "id": "std-2024-018",
    "name": "Рахматуллаев Хасан ",
    "certificates": [
      {
        "id": "std-2024-018-1",
        "name": "Принципы профессиональной этики и обеспечение независимости аудиторской организации",
        "date": "06.01.2024",
        "time": "8-часового курса"
      },
      {
        "id": "std-2024-018-2",
        "name": "Профессиональные требования к независимости аудитора",
        "date": "12.01.2024",
        "time": "6-часового курса"
      },
      {
        "id": "std-2024-018-3",
        "name": "Применение МСА 315 при выявлении и оценке рисков существенного искажения финансовой отчетности",
        "date": "19.01.2024",
        "time": "2-часового курса"
      },
      {
        "id": "std-2024-018-4",
        "name": "Актуальные изменения в международных стандартах аудита и нормативных требованиях",
        "date": "26.01.2024",
        "time": "6-часового курса"
      },
      {
        "id": "std-2024-018-5",
        "name": "Основы кибербезопасности и защита информации в аудиторской практике",
        "date": "31.01.2024",
        "time": "6-часового курса"
      },
      {
        "id": "std-2024-018-6",
        "name": "Международный стандарт контроля качества 1: Построение системы управления качеством в аудиторской фирме",
        "date": "23.02.2024",
        "time": "8-часового курса"
      },
      {
        "id": "std-2024-018-7",
        "name": "Комплексный обзор Международных стандартов аудита и их практическое применение",
        "date": "15.03.2024",
        "time": "8-часового курса"
      },
      {
        "id": "std-2024-018-8",
        "name": "Аудиторские доказательства",
        "date": "24.05.2024",
        "time": "3-часового курса"
      },
      {
        "id": "std-2024-018-9",
        "name": "Эффективное взаимодействие с клиентами и обеспечение качества аудиторских услуг",
        "date": "21.06.2024",
        "time": "6-часового курса"
      },
      {
        "id": "std-2024-018-10",
        "name": "Нормативно-правовые требования и стандарты, применимые к аудиту в отдельных секторах экономики",
        "date": "26.07.2024",
        "time": "5-часового курса"
      },
      {
        "id": "std-2024-018-11",
        "name": "Введение в Международный стандарт управления качеством (ISQM 1): принципы, структура и внедрение",
        "date": "29.08.2024",
        "time": "20 (5 дней)-часового курса"
      },
      {
        "id": "std-2024-018-12",
        "name": "Эффективная деловая коммуникация в профессиональной среде: навыки взаимодействия, переговоров и презентации",
        "date": "20.09.2024",
        "time": "2-часового курса"
      },
      {
        "id": "std-2024-018-13",
        "name": "Применение МСА 330: Аудиторские процедуры в ответ на оцененные риски существенного искажения",
        "date": "24.10.2024",
        "time": "2-часового курса"
      },
      {
        "id": "std-2024-018-14",
        "name": "Аудит оценочных значений, включая справедливую стоимость и резервы: применение МСА 540",
        "date": "25.10.2024",
        "time": "2-часового курса"
      },
      {
        "id": "std-2024-018-15",
        "name": "Разработка и реализация стратегии управления клиентским портфелем: сегментация, приоритеты и качество обслуживани",
        "date": "20.12.2024",
        "time": "6-часового курса"
      }
    ]
  },
  {
    "id": "std-2024-019",
    "name": "Хакимов Санжар",
    "certificates": [
      {
        "id": "std-2024-019-1",
        "name": "Принципы профессиональной этики и обеспечение независимости аудиторской организации",
        "date": "06.01.2024",
        "time": "8-часового курса"
      },
      {
        "id": "std-2024-019-2",
        "name": "Актуальные изменения в международных стандартах аудита и нормативных требованиях",
        "date": "26.01.2024",
        "time": "6-часового курса"
      },
      {
        "id": "std-2024-019-3",
        "name": "Основы кибербезопасности и защита информации в аудиторской практике",
        "date": "31.01.2024",
        "time": "6-часового курса"
      },
      {
        "id": "std-2024-019-4",
        "name": "Международный стандарт контроля качества 1: Построение системы управления качеством в аудиторской фирме",
        "date": "23.02.2024",
        "time": "8-часового курса"
      },
      {
        "id": "std-2024-019-5",
        "name": "Комплексный обзор Международных стандартов аудита и их практическое применение",
        "date": "15.03.2024",
        "time": "8-часового курса"
      }
    ]
  },
  {
    "id": "std-2024-020",
    "name": "Аразгельдиев Арсланбек",
    "certificates": [
      {
        "id": "std-2024-020-1",
        "name": "Принципы профессиональной этики и обеспечение независимости аудиторской организации",
        "date": "06.01.2024",
        "time": "8-часового курса"
      },
      {
        "id": "std-2024-020-2",
        "name": "Профессиональные требования к независимости аудитора",
        "date": "12.01.2024",
        "time": "6-часового курса"
      },
      {
        "id": "std-2024-020-3",
        "name": "Применение МСА 315 при выявлении и оценке рисков существенного искажения финансовой отчетности",
        "date": "19.01.2024",
        "time": "2-часового курса"
      },
      {
        "id": "std-2024-020-4",
        "name": "Международный стандарт контроля качества 1: Построение системы управления качеством в аудиторской фирме",
        "date": "23.02.2024",
        "time": "8-часового курса"
      },
      {
        "id": "std-2024-020-5",
        "name": "Комплексный обзор Международных стандартов аудита и их практическое применение",
        "date": "15.03.2024",
        "time": "8-часового курса"
      },
      {
        "id": "std-2024-020-6",
        "name": "Международные стандарты финансовой отчетности: принципы, структура и применение",
        "date": "26.04.2024",
        "time": "8-часового курса"
      },
      {
        "id": "std-2024-020-7",
        "name": "Аудиторские доказательства",
        "date": "24.05.2024",
        "time": "3-часового курса"
      },
      {
        "id": "std-2024-020-8",
        "name": "Эффективное взаимодействие с клиентами и обеспечение качества аудиторских услуг",
        "date": "21.06.2024",
        "time": "6-часового курса"
      },
      {
        "id": "std-2024-020-9",
        "name": "Нормативно-правовые требования и стандарты, применимые к аудиту в отдельных секторах экономики",
        "date": "26.07.2024",
        "time": "5-часового курса"
      },
      {
        "id": "std-2024-020-10",
        "name": "Введение в Международный стандарт управления качеством (ISQM 1): принципы, структура и внедрение",
        "date": "29.08.2024",
        "time": "20 (5 дней)-часового курса"
      },
      {
        "id": "std-2024-020-11",
        "name": "Эффективная деловая коммуникация в профессиональной среде: навыки взаимодействия, переговоров и презентации",
        "date": "20.09.2024",
        "time": "2-часового курса"
      },
      {
        "id": "std-2024-020-12",
        "name": "Разработка и реализация стратегии управления клиентским портфелем: сегментация, приоритеты и качество обслуживани",
        "date": "20.12.2024",
        "time": "6-часового курса"
      }
    ]
  },
  {
    "id": "std-2024-021",
    "name": "Мухитдинов Иброхим ",
    "certificates": [
      {
        "id": "std-2024-021-1",
        "name": "Принципы профессиональной этики и обеспечение независимости аудиторской организации",
        "date": "06.01.2024",
        "time": "8-часового курса"
      },
      {
        "id": "std-2024-021-2",
        "name": "Профессиональные требования к независимости аудитора",
        "date": "12.01.2024",
        "time": "6-часового курса"
      },
      {
        "id": "std-2024-021-3",
        "name": "Применение МСА 315 при выявлении и оценке рисков существенного искажения финансовой отчетности",
        "date": "19.01.2024",
        "time": "2-часового курса"
      },
      {
        "id": "std-2024-021-4",
        "name": "Актуальные изменения в международных стандартах аудита и нормативных требованиях",
        "date": "26.01.2024",
        "time": "6-часового курса"
      },
      {
        "id": "std-2024-021-5",
        "name": "Основы кибербезопасности и защита информации в аудиторской практике",
        "date": "31.01.2024",
        "time": "6-часового курса"
      },
      {
        "id": "std-2024-021-6",
        "name": "Международный стандарт контроля качества 1: Построение системы управления качеством в аудиторской фирме",
        "date": "23.02.2024",
        "time": "8-часового курса"
      },
      {
        "id": "std-2024-021-7",
        "name": "Комплексный обзор Международных стандартов аудита и их практическое применение",
        "date": "15.03.2024",
        "time": "8-часового курса"
      },
      {
        "id": "std-2024-021-8",
        "name": "Аудиторские доказательства",
        "date": "24.05.2024",
        "time": "3-часового курса"
      },
      {
        "id": "std-2024-021-9",
        "name": "Эффективное взаимодействие с клиентами и обеспечение качества аудиторских услуг",
        "date": "21.06.2024",
        "time": "6-часового курса"
      },
      {
        "id": "std-2024-021-10",
        "name": "Нормативно-правовые требования и стандарты, применимые к аудиту в отдельных секторах экономики",
        "date": "26.07.2024",
        "time": "5-часового курса"
      },
      {
        "id": "std-2024-021-11",
        "name": "Введение в Международный стандарт управления качеством (ISQM 1): принципы, структура и внедрение",
        "date": "29.08.2024",
        "time": "20 (5 дней)-часового курса"
      },
      {
        "id": "std-2024-021-12",
        "name": "Эффективная деловая коммуникация в профессиональной среде: навыки взаимодействия, переговоров и презентации",
        "date": "20.09.2024",
        "time": "2-часового курса"
      },
      {
        "id": "std-2024-021-13",
        "name": "Применение МСА 330: Аудиторские процедуры в ответ на оцененные риски существенного искажения",
        "date": "24.10.2024",
        "time": "2-часового курса"
      },
      {
        "id": "std-2024-021-14",
        "name": "Аудит оценочных значений, включая справедливую стоимость и резервы: применение МСА 540",
        "date": "25.10.2024",
        "time": "2-часового курса"
      },
      {
        "id": "std-2024-021-15",
        "name": "Разработка и реализация стратегии управления клиентским портфелем: сегментация, приоритеты и качество обслуживани",
        "date": "20.12.2024",
        "time": "6-часового курса"
      }
    ]
  },
  {
    "id": "std-2024-022",
    "name": "Абдувахитов Жавохир",
    "certificates": [
      {
        "id": "std-2024-022-1",
        "name": "Принципы профессиональной этики и обеспечение независимости аудиторской организации",
        "date": "06.01.2024",
        "time": "8-часового курса"
      },
      {
        "id": "std-2024-022-2",
        "name": "Профессиональные требования к независимости аудитора",
        "date": "12.01.2024",
        "time": "6-часового курса"
      },
      {
        "id": "std-2024-022-3",
        "name": "Применение МСА 315 при выявлении и оценке рисков существенного искажения финансовой отчетности",
        "date": "19.01.2024",
        "time": "2-часового курса"
      },
      {
        "id": "std-2024-022-4",
        "name": "Актуальные изменения в международных стандартах аудита и нормативных требованиях",
        "date": "26.01.2024",
        "time": "6-часового курса"
      },
      {
        "id": "std-2024-022-5",
        "name": "Основы кибербезопасности и защита информации в аудиторской практике",
        "date": "31.01.2024",
        "time": "6-часового курса"
      },
      {
        "id": "std-2024-022-6",
        "name": "Международный стандарт контроля качества 1: Построение системы управления качеством в аудиторской фирме",
        "date": "23.02.2024",
        "time": "8-часового курса"
      },
      {
        "id": "std-2024-022-7",
        "name": "Комплексный обзор Международных стандартов аудита и их практическое применение",
        "date": "15.03.2024",
        "time": "8-часового курса"
      },
      {
        "id": "std-2024-022-8",
        "name": "Международные стандарты финансовой отчетности: принципы, структура и применение",
        "date": "26.04.2024",
        "time": "8-часового курса"
      },
      {
        "id": "std-2024-022-9",
        "name": "Аудиторские доказательства",
        "date": "24.05.2024",
        "time": "3-часового курса"
      },
      {
        "id": "std-2024-022-10",
        "name": "Эффективное взаимодействие с клиентами и обеспечение качества аудиторских услуг",
        "date": "21.06.2024",
        "time": "6-часового курса"
      },
      {
        "id": "std-2024-022-11",
        "name": "Нормативно-правовые требования и стандарты, применимые к аудиту в отдельных секторах экономики",
        "date": "26.07.2024",
        "time": "5-часового курса"
      },
      {
        "id": "std-2024-022-12",
        "name": "Введение в Международный стандарт управления качеством (ISQM 1): принципы, структура и внедрение",
        "date": "29.08.2024",
        "time": "20 (5 дней)-часового курса"
      },
      {
        "id": "std-2024-022-13",
        "name": "Эффективная деловая коммуникация в профессиональной среде: навыки взаимодействия, переговоров и презентации",
        "date": "20.09.2024",
        "time": "2-часового курса"
      },
      {
        "id": "std-2024-022-14",
        "name": "Разработка и реализация стратегии управления клиентским портфелем: сегментация, приоритеты и качество обслуживани",
        "date": "20.12.2024",
        "time": "6-часового курса"
      }
    ]
  },
  {
    "id": "std-2024-023",
    "name": "Эшбуриев Аббос ",
    "certificates": [
      {
        "id": "std-2024-023-1",
        "name": "Принципы профессиональной этики и обеспечение независимости аудиторской организации",
        "date": "06.01.2024",
        "time": "8-часового курса"
      },
      {
        "id": "std-2024-023-2",
        "name": "Профессиональные требования к независимости аудитора",
        "date": "12.01.2024",
        "time": "6-часового курса"
      },
      {
        "id": "std-2024-023-3",
        "name": "Применение МСА 315 при выявлении и оценке рисков существенного искажения финансовой отчетности",
        "date": "19.01.2024",
        "time": "2-часового курса"
      },
      {
        "id": "std-2024-023-4",
        "name": "Актуальные изменения в международных стандартах аудита и нормативных требованиях",
        "date": "26.01.2024",
        "time": "6-часового курса"
      },
      {
        "id": "std-2024-023-5",
        "name": "Основы кибербезопасности и защита информации в аудиторской практике",
        "date": "31.01.2024",
        "time": "6-часового курса"
      },
      {
        "id": "std-2024-023-6",
        "name": "Международный стандарт контроля качества 1: Построение системы управления качеством в аудиторской фирме",
        "date": "23.02.2024",
        "time": "8-часового курса"
      },
      {
        "id": "std-2024-023-7",
        "name": "Международные стандарты финансовой отчетности: принципы, структура и применение",
        "date": "26.04.2024",
        "time": "8-часового курса"
      },
      {
        "id": "std-2024-023-8",
        "name": "Аудиторские доказательства",
        "date": "24.05.2024",
        "time": "3-часового курса"
      },
      {
        "id": "std-2024-023-9",
        "name": "Эффективное взаимодействие с клиентами и обеспечение качества аудиторских услуг",
        "date": "21.06.2024",
        "time": "6-часового курса"
      },
      {
        "id": "std-2024-023-10",
        "name": "Нормативно-правовые требования и стандарты, применимые к аудиту в отдельных секторах экономики",
        "date": "26.07.2024",
        "time": "5-часового курса"
      },
      {
        "id": "std-2024-023-11",
        "name": "Введение в Международный стандарт управления качеством (ISQM 1): принципы, структура и внедрение",
        "date": "29.08.2024",
        "time": "20 (5 дней)-часового курса"
      },
      {
        "id": "std-2024-023-12",
        "name": "Эффективная деловая коммуникация в профессиональной среде: навыки взаимодействия, переговоров и презентации",
        "date": "20.09.2024",
        "time": "2-часового курса"
      },
      {
        "id": "std-2024-023-13",
        "name": "Применение МСА 330: Аудиторские процедуры в ответ на оцененные риски существенного искажения",
        "date": "24.10.2024",
        "time": "2-часового курса"
      },
      {
        "id": "std-2024-023-14",
        "name": "Аудит оценочных значений, включая справедливую стоимость и резервы: применение МСА 540",
        "date": "25.10.2024",
        "time": "2-часового курса"
      },
      {
        "id": "std-2024-023-15",
        "name": "Разработка и реализация стратегии управления клиентским портфелем: сегментация, приоритеты и качество обслуживани",
        "date": "20.12.2024",
        "time": "6-часового курса"
      }
    ]
  },
  {
    "id": "std-2024-024",
    "name": "Илхомов Отабек",
    "certificates": [
      {
        "id": "std-2024-024-1",
        "name": "Принципы профессиональной этики и обеспечение независимости аудиторской организации",
        "date": "06.01.2024",
        "time": "8-часового курса"
      },
      {
        "id": "std-2024-024-2",
        "name": "Актуальные изменения в международных стандартах аудита и нормативных требованиях",
        "date": "26.01.2024",
        "time": "6-часового курса"
      },
      {
        "id": "std-2024-024-3",
        "name": "Основы кибербезопасности и защита информации в аудиторской практике",
        "date": "31.01.2024",
        "time": "6-часового курса"
      }
    ]
  },
  {
    "id": "std-2024-025",
    "name": "Исроилова Раййан ",
    "certificates": [
      {
        "id": "std-2024-025-1",
        "name": "Принципы профессиональной этики и обеспечение независимости аудиторской организации",
        "date": "06.01.2024",
        "time": "8-часового курса"
      },
      {
        "id": "std-2024-025-2",
        "name": "Профессиональные требования к независимости аудитора",
        "date": "12.01.2024",
        "time": "6-часового курса"
      },
      {
        "id": "std-2024-025-3",
        "name": "Применение МСА 315 при выявлении и оценке рисков существенного искажения финансовой отчетности",
        "date": "19.01.2024",
        "time": "2-часового курса"
      },
      {
        "id": "std-2024-025-4",
        "name": "Актуальные изменения в международных стандартах аудита и нормативных требованиях",
        "date": "26.01.2024",
        "time": "6-часового курса"
      },
      {
        "id": "std-2024-025-5",
        "name": "Основы кибербезопасности и защита информации в аудиторской практике",
        "date": "31.01.2024",
        "time": "6-часового курса"
      },
      {
        "id": "std-2024-025-6",
        "name": "Международный стандарт контроля качества 1: Построение системы управления качеством в аудиторской фирме",
        "date": "23.02.2024",
        "time": "8-часового курса"
      },
      {
        "id": "std-2024-025-7",
        "name": "Комплексный обзор Международных стандартов аудита и их практическое применение",
        "date": "15.03.2024",
        "time": "8-часового курса"
      },
      {
        "id": "std-2024-025-8",
        "name": "Международные стандарты финансовой отчетности: принципы, структура и применение",
        "date": "26.04.2024",
        "time": "8-часового курса"
      },
      {
        "id": "std-2024-025-9",
        "name": "Аудиторские доказательства",
        "date": "24.05.2024",
        "time": "3-часового курса"
      },
      {
        "id": "std-2024-025-10",
        "name": "Эффективное взаимодействие с клиентами и обеспечение качества аудиторских услуг",
        "date": "21.06.2024",
        "time": "6-часового курса"
      },
      {
        "id": "std-2024-025-11",
        "name": "Нормативно-правовые требования и стандарты, применимые к аудиту в отдельных секторах экономики",
        "date": "26.07.2024",
        "time": "5-часового курса"
      },
      {
        "id": "std-2024-025-12",
        "name": "Введение в Международный стандарт управления качеством (ISQM 1): принципы, структура и внедрение",
        "date": "29.08.2024",
        "time": "20 (5 дней)-часового курса"
      },
      {
        "id": "std-2024-025-13",
        "name": "Эффективная деловая коммуникация в профессиональной среде: навыки взаимодействия, переговоров и презентации",
        "date": "20.09.2024",
        "time": "2-часового курса"
      },
      {
        "id": "std-2024-025-14",
        "name": "Применение МСА 330: Аудиторские процедуры в ответ на оцененные риски существенного искажения",
        "date": "24.10.2024",
        "time": "2-часового курса"
      },
      {
        "id": "std-2024-025-15",
        "name": "Аудит оценочных значений, включая справедливую стоимость и резервы: применение МСА 540",
        "date": "25.10.2024",
        "time": "2-часового курса"
      },
      {
        "id": "std-2024-025-16",
        "name": "Разработка и реализация стратегии управления клиентским портфелем: сегментация, приоритеты и качество обслуживани",
        "date": "20.12.2024",
        "time": "6-часового курса"
      }
    ]
  },
  {
    "id": "std-2024-026",
    "name": "Маъруфжонова Нигорахон",
    "certificates": [
      {
        "id": "std-2024-026-1",
        "name": "Принципы профессиональной этики и обеспечение независимости аудиторской организации",
        "date": "06.01.2024",
        "time": "8-часового курса"
      },
      {
        "id": "std-2024-026-2",
        "name": "Профессиональные требования к независимости аудитора",
        "date": "12.01.2024",
        "time": "6-часового курса"
      },
      {
        "id": "std-2024-026-3",
        "name": "Применение МСА 315 при выявлении и оценке рисков существенного искажения финансовой отчетности",
        "date": "19.01.2024",
        "time": "2-часового курса"
      },
      {
        "id": "std-2024-026-4",
        "name": "Актуальные изменения в международных стандартах аудита и нормативных требованиях",
        "date": "26.01.2024",
        "time": "6-часового курса"
      },
      {
        "id": "std-2024-026-5",
        "name": "Основы кибербезопасности и защита информации в аудиторской практике",
        "date": "31.01.2024",
        "time": "6-часового курса"
      },
      {
        "id": "std-2024-026-6",
        "name": "Международный стандарт контроля качества 1: Построение системы управления качеством в аудиторской фирме",
        "date": "23.02.2024",
        "time": "8-часового курса"
      },
      {
        "id": "std-2024-026-7",
        "name": "Комплексный обзор Международных стандартов аудита и их практическое применение",
        "date": "15.03.2024",
        "time": "8-часового курса"
      },
      {
        "id": "std-2024-026-8",
        "name": "Международные стандарты финансовой отчетности: принципы, структура и применение",
        "date": "26.04.2024",
        "time": "8-часового курса"
      },
      {
        "id": "std-2024-026-9",
        "name": "Аудиторские доказательства",
        "date": "24.05.2024",
        "time": "3-часового курса"
      },
      {
        "id": "std-2024-026-10",
        "name": "Эффективное взаимодействие с клиентами и обеспечение качества аудиторских услуг",
        "date": "21.06.2024",
        "time": "6-часового курса"
      },
      {
        "id": "std-2024-026-11",
        "name": "Нормативно-правовые требования и стандарты, применимые к аудиту в отдельных секторах экономики",
        "date": "26.07.2024",
        "time": "5-часового курса"
      },
      {
        "id": "std-2024-026-12",
        "name": "Введение в Международный стандарт управления качеством (ISQM 1): принципы, структура и внедрение",
        "date": "29.08.2024",
        "time": "20 (5 дней)-часового курса"
      },
      {
        "id": "std-2024-026-13",
        "name": "Эффективная деловая коммуникация в профессиональной среде: навыки взаимодействия, переговоров и презентации",
        "date": "20.09.2024",
        "time": "2-часового курса"
      },
      {
        "id": "std-2024-026-14",
        "name": "Применение МСА 330: Аудиторские процедуры в ответ на оцененные риски существенного искажения",
        "date": "24.10.2024",
        "time": "2-часового курса"
      },
      {
        "id": "std-2024-026-15",
        "name": "Аудит оценочных значений, включая справедливую стоимость и резервы: применение МСА 540",
        "date": "25.10.2024",
        "time": "2-часового курса"
      },
      {
        "id": "std-2024-026-16",
        "name": "Разработка и реализация стратегии управления клиентским портфелем: сегментация, приоритеты и качество обслуживани",
        "date": "20.12.2024",
        "time": "6-часового курса"
      }
    ]
  },
  {
    "id": "std-2024-027",
    "name": "Абдумаликов Жавохир",
    "certificates": [
      {
        "id": "std-2024-027-1",
        "name": "Принципы профессиональной этики и обеспечение независимости аудиторской организации",
        "date": "06.01.2024",
        "time": "8-часового курса"
      },
      {
        "id": "std-2024-027-2",
        "name": "Профессиональные требования к независимости аудитора",
        "date": "12.01.2024",
        "time": "6-часового курса"
      },
      {
        "id": "std-2024-027-3",
        "name": "Применение МСА 315 при выявлении и оценке рисков существенного искажения финансовой отчетности",
        "date": "19.01.2024",
        "time": "2-часового курса"
      },
      {
        "id": "std-2024-027-4",
        "name": "Актуальные изменения в международных стандартах аудита и нормативных требованиях",
        "date": "26.01.2024",
        "time": "6-часового курса"
      },
      {
        "id": "std-2024-027-5",
        "name": "Основы кибербезопасности и защита информации в аудиторской практике",
        "date": "31.01.2024",
        "time": "6-часового курса"
      },
      {
        "id": "std-2024-027-6",
        "name": "Международный стандарт контроля качества 1: Построение системы управления качеством в аудиторской фирме",
        "date": "23.02.2024",
        "time": "8-часового курса"
      },
      {
        "id": "std-2024-027-7",
        "name": "Международные стандарты финансовой отчетности: принципы, структура и применение",
        "date": "26.04.2024",
        "time": "8-часового курса"
      }
    ]
  },
  {
    "id": "std-2024-028",
    "name": "Турсунпулатов Анвар ",
    "certificates": [
      {
        "id": "std-2024-028-1",
        "name": "Принципы профессиональной этики и обеспечение независимости аудиторской организации",
        "date": "06.01.2024",
        "time": "8-часового курса"
      },
      {
        "id": "std-2024-028-2",
        "name": "Профессиональные требования к независимости аудитора",
        "date": "12.01.2024",
        "time": "6-часового курса"
      },
      {
        "id": "std-2024-028-3",
        "name": "Применение МСА 315 при выявлении и оценке рисков существенного искажения финансовой отчетности",
        "date": "19.01.2024",
        "time": "2-часового курса"
      },
      {
        "id": "std-2024-028-4",
        "name": "Актуальные изменения в международных стандартах аудита и нормативных требованиях",
        "date": "26.01.2024",
        "time": "6-часового курса"
      },
      {
        "id": "std-2024-028-5",
        "name": "Основы кибербезопасности и защита информации в аудиторской практике",
        "date": "31.01.2024",
        "time": "6-часового курса"
      },
      {
        "id": "std-2024-028-6",
        "name": "Международный стандарт контроля качества 1: Построение системы управления качеством в аудиторской фирме",
        "date": "23.02.2024",
        "time": "8-часового курса"
      },
      {
        "id": "std-2024-028-7",
        "name": "Комплексный обзор Международных стандартов аудита и их практическое применение",
        "date": "15.03.2024",
        "time": "8-часового курса"
      },
      {
        "id": "std-2024-028-8",
        "name": "Международные стандарты финансовой отчетности: принципы, структура и применение",
        "date": "26.04.2024",
        "time": "8-часового курса"
      },
      {
        "id": "std-2024-028-9",
        "name": "Аудиторские доказательства",
        "date": "24.05.2024",
        "time": "3-часового курса"
      },
      {
        "id": "std-2024-028-10",
        "name": "Эффективное взаимодействие с клиентами и обеспечение качества аудиторских услуг",
        "date": "21.06.2024",
        "time": "6-часового курса"
      },
      {
        "id": "std-2024-028-11",
        "name": "Нормативно-правовые требования и стандарты, применимые к аудиту в отдельных секторах экономики",
        "date": "26.07.2024",
        "time": "5-часового курса"
      },
      {
        "id": "std-2024-028-12",
        "name": "Введение в Международный стандарт управления качеством (ISQM 1): принципы, структура и внедрение",
        "date": "29.08.2024",
        "time": "20 (5 дней)-часового курса"
      },
      {
        "id": "std-2024-028-13",
        "name": "Эффективная деловая коммуникация в профессиональной среде: навыки взаимодействия, переговоров и презентации",
        "date": "20.09.2024",
        "time": "2-часового курса"
      },
      {
        "id": "std-2024-028-14",
        "name": "Применение МСА 330: Аудиторские процедуры в ответ на оцененные риски существенного искажения",
        "date": "24.10.2024",
        "time": "2-часового курса"
      },
      {
        "id": "std-2024-028-15",
        "name": "Аудит оценочных значений, включая справедливую стоимость и резервы: применение МСА 540",
        "date": "25.10.2024",
        "time": "2-часового курса"
      },
      {
        "id": "std-2024-028-16",
        "name": "Разработка и реализация стратегии управления клиентским портфелем: сегментация, приоритеты и качество обслуживани",
        "date": "20.12.2024",
        "time": "6-часового курса"
      }
    ]
  },
  {
    "id": "std-2024-029",
    "name": "Фатхуллаев Дилмурод ",
    "certificates": [
      {
        "id": "std-2024-029-1",
        "name": "Принципы профессиональной этики и обеспечение независимости аудиторской организации",
        "date": "06.01.2024",
        "time": "8-часового курса"
      },
      {
        "id": "std-2024-029-2",
        "name": "Профессиональные требования к независимости аудитора",
        "date": "12.01.2024",
        "time": "6-часового курса"
      },
      {
        "id": "std-2024-029-3",
        "name": "Применение МСА 315 при выявлении и оценке рисков существенного искажения финансовой отчетности",
        "date": "19.01.2024",
        "time": "2-часового курса"
      },
      {
        "id": "std-2024-029-4",
        "name": "Актуальные изменения в международных стандартах аудита и нормативных требованиях",
        "date": "26.01.2024",
        "time": "6-часового курса"
      },
      {
        "id": "std-2024-029-5",
        "name": "Основы кибербезопасности и защита информации в аудиторской практике",
        "date": "31.01.2024",
        "time": "6-часового курса"
      },
      {
        "id": "std-2024-029-6",
        "name": "Международный стандарт контроля качества 1: Построение системы управления качеством в аудиторской фирме",
        "date": "23.02.2024",
        "time": "8-часового курса"
      },
      {
        "id": "std-2024-029-7",
        "name": "Комплексный обзор Международных стандартов аудита и их практическое применение",
        "date": "15.03.2024",
        "time": "8-часового курса"
      },
      {
        "id": "std-2024-029-8",
        "name": "Международные стандарты финансовой отчетности: принципы, структура и применение",
        "date": "26.04.2024",
        "time": "8-часового курса"
      },
      {
        "id": "std-2024-029-9",
        "name": "Аудиторские доказательства",
        "date": "24.05.2024",
        "time": "3-часового курса"
      },
      {
        "id": "std-2024-029-10",
        "name": "Эффективное взаимодействие с клиентами и обеспечение качества аудиторских услуг",
        "date": "21.06.2024",
        "time": "6-часового курса"
      },
      {
        "id": "std-2024-029-11",
        "name": "Нормативно-правовые требования и стандарты, применимые к аудиту в отдельных секторах экономики",
        "date": "26.07.2024",
        "time": "5-часового курса"
      },
      {
        "id": "std-2024-029-12",
        "name": "Введение в Международный стандарт управления качеством (ISQM 1): принципы, структура и внедрение",
        "date": "29.08.2024",
        "time": "20 (5 дней)-часового курса"
      },
      {
        "id": "std-2024-029-13",
        "name": "Эффективная деловая коммуникация в профессиональной среде: навыки взаимодействия, переговоров и презентации",
        "date": "20.09.2024",
        "time": "2-часового курса"
      },
      {
        "id": "std-2024-029-14",
        "name": "Применение МСА 330: Аудиторские процедуры в ответ на оцененные риски существенного искажения",
        "date": "24.10.2024",
        "time": "2-часового курса"
      },
      {
        "id": "std-2024-029-15",
        "name": "Аудит оценочных значений, включая справедливую стоимость и резервы: применение МСА 540",
        "date": "25.10.2024",
        "time": "2-часового курса"
      },
      {
        "id": "std-2024-029-16",
        "name": "Разработка и реализация стратегии управления клиентским портфелем: сегментация, приоритеты и качество обслуживани",
        "date": "20.12.2024",
        "time": "6-часового курса"
      }
    ]
  },
  {
    "id": "std-2024-030",
    "name": "Фатхуллаев Иброхим ",
    "certificates": [
      {
        "id": "std-2024-030-1",
        "name": "Принципы профессиональной этики и обеспечение независимости аудиторской организации",
        "date": "06.01.2024",
        "time": "8-часового курса"
      },
      {
        "id": "std-2024-030-2",
        "name": "Профессиональные требования к независимости аудитора",
        "date": "12.01.2024",
        "time": "6-часового курса"
      },
      {
        "id": "std-2024-030-3",
        "name": "Применение МСА 315 при выявлении и оценке рисков существенного искажения финансовой отчетности",
        "date": "19.01.2024",
        "time": "2-часового курса"
      },
      {
        "id": "std-2024-030-4",
        "name": "Актуальные изменения в международных стандартах аудита и нормативных требованиях",
        "date": "26.01.2024",
        "time": "6-часового курса"
      },
      {
        "id": "std-2024-030-5",
        "name": "Основы кибербезопасности и защита информации в аудиторской практике",
        "date": "31.01.2024",
        "time": "6-часового курса"
      },
      {
        "id": "std-2024-030-6",
        "name": "Международный стандарт контроля качества 1: Построение системы управления качеством в аудиторской фирме",
        "date": "23.02.2024",
        "time": "8-часового курса"
      },
      {
        "id": "std-2024-030-7",
        "name": "Комплексный обзор Международных стандартов аудита и их практическое применение",
        "date": "15.03.2024",
        "time": "8-часового курса"
      },
      {
        "id": "std-2024-030-8",
        "name": "Международные стандарты финансовой отчетности: принципы, структура и применение",
        "date": "26.04.2024",
        "time": "8-часового курса"
      },
      {
        "id": "std-2024-030-9",
        "name": "Аудиторские доказательства",
        "date": "24.05.2024",
        "time": "3-часового курса"
      },
      {
        "id": "std-2024-030-10",
        "name": "Эффективное взаимодействие с клиентами и обеспечение качества аудиторских услуг",
        "date": "21.06.2024",
        "time": "6-часового курса"
      },
      {
        "id": "std-2024-030-11",
        "name": "Нормативно-правовые требования и стандарты, применимые к аудиту в отдельных секторах экономики",
        "date": "26.07.2024",
        "time": "5-часового курса"
      },
      {
        "id": "std-2024-030-12",
        "name": "Введение в Международный стандарт управления качеством (ISQM 1): принципы, структура и внедрение",
        "date": "29.08.2024",
        "time": "20 (5 дней)-часового курса"
      },
      {
        "id": "std-2024-030-13",
        "name": "Эффективная деловая коммуникация в профессиональной среде: навыки взаимодействия, переговоров и презентации",
        "date": "20.09.2024",
        "time": "2-часового курса"
      },
      {
        "id": "std-2024-030-14",
        "name": "Применение МСА 330: Аудиторские процедуры в ответ на оцененные риски существенного искажения",
        "date": "24.10.2024",
        "time": "2-часового курса"
      },
      {
        "id": "std-2024-030-15",
        "name": "Аудит оценочных значений, включая справедливую стоимость и резервы: применение МСА 540",
        "date": "25.10.2024",
        "time": "2-часового курса"
      },
      {
        "id": "std-2024-030-16",
        "name": "Разработка и реализация стратегии управления клиентским портфелем: сегментация, приоритеты и качество обслуживани",
        "date": "20.12.2024",
        "time": "6-часового курса"
      }
    ]
  },
  {
    "id": "std-2024-031",
    "name": "Фармонова Мадина",
    "certificates": [
      {
        "id": "std-2024-031-1",
        "name": "Принципы профессиональной этики и обеспечение независимости аудиторской организации",
        "date": "06.01.2024",
        "time": "8-часового курса"
      },
      {
        "id": "std-2024-031-2",
        "name": "Профессиональные требования к независимости аудитора",
        "date": "12.01.2024",
        "time": "6-часового курса"
      },
      {
        "id": "std-2024-031-3",
        "name": "Применение МСА 315 при выявлении и оценке рисков существенного искажения финансовой отчетности",
        "date": "19.01.2024",
        "time": "2-часового курса"
      },
      {
        "id": "std-2024-031-4",
        "name": "Актуальные изменения в международных стандартах аудита и нормативных требованиях",
        "date": "26.01.2024",
        "time": "6-часового курса"
      },
      {
        "id": "std-2024-031-5",
        "name": "Основы кибербезопасности и защита информации в аудиторской практике",
        "date": "31.01.2024",
        "time": "6-часового курса"
      },
      {
        "id": "std-2024-031-6",
        "name": "Международный стандарт контроля качества 1: Построение системы управления качеством в аудиторской фирме",
        "date": "23.02.2024",
        "time": "8-часового курса"
      },
      {
        "id": "std-2024-031-7",
        "name": "Комплексный обзор Международных стандартов аудита и их практическое применение",
        "date": "15.03.2024",
        "time": "8-часового курса"
      },
      {
        "id": "std-2024-031-8",
        "name": "Международные стандарты финансовой отчетности: принципы, структура и применение",
        "date": "26.04.2024",
        "time": "8-часового курса"
      },
      {
        "id": "std-2024-031-9",
        "name": "Аудиторские доказательства",
        "date": "24.05.2024",
        "time": "3-часового курса"
      },
      {
        "id": "std-2024-031-10",
        "name": "Эффективное взаимодействие с клиентами и обеспечение качества аудиторских услуг",
        "date": "21.06.2024",
        "time": "6-часового курса"
      },
      {
        "id": "std-2024-031-11",
        "name": "Введение в Международный стандарт управления качеством (ISQM 1): принципы, структура и внедрение",
        "date": "29.08.2024",
        "time": "20 (5 дней)-часового курса"
      }
    ]
  },
  {
    "id": "std-2024-032",
    "name": "Сафаева Сафина",
    "certificates": [
      {
        "id": "std-2024-032-1",
        "name": "Принципы профессиональной этики и обеспечение независимости аудиторской организации",
        "date": "06.01.2024",
        "time": "8-часового курса"
      },
      {
        "id": "std-2024-032-2",
        "name": "Профессиональные требования к независимости аудитора",
        "date": "12.01.2024",
        "time": "6-часового курса"
      },
      {
        "id": "std-2024-032-3",
        "name": "Применение МСА 315 при выявлении и оценке рисков существенного искажения финансовой отчетности",
        "date": "19.01.2024",
        "time": "2-часового курса"
      },
      {
        "id": "std-2024-032-4",
        "name": "Актуальные изменения в международных стандартах аудита и нормативных требованиях",
        "date": "26.01.2024",
        "time": "6-часового курса"
      },
      {
        "id": "std-2024-032-5",
        "name": "Основы кибербезопасности и защита информации в аудиторской практике",
        "date": "31.01.2024",
        "time": "6-часового курса"
      },
      {
        "id": "std-2024-032-6",
        "name": "Международный стандарт контроля качества 1: Построение системы управления качеством в аудиторской фирме",
        "date": "23.02.2024",
        "time": "8-часового курса"
      },
      {
        "id": "std-2024-032-7",
        "name": "Комплексный обзор Международных стандартов аудита и их практическое применение",
        "date": "15.03.2024",
        "time": "8-часового курса"
      },
      {
        "id": "std-2024-032-8",
        "name": "Международные стандарты финансовой отчетности: принципы, структура и применение",
        "date": "26.04.2024",
        "time": "8-часового курса"
      },
      {
        "id": "std-2024-032-9",
        "name": "Аудиторские доказательства",
        "date": "24.05.2024",
        "time": "3-часового курса"
      },
      {
        "id": "std-2024-032-10",
        "name": "Эффективное взаимодействие с клиентами и обеспечение качества аудиторских услуг",
        "date": "21.06.2024",
        "time": "6-часового курса"
      },
      {
        "id": "std-2024-032-11",
        "name": "Нормативно-правовые требования и стандарты, применимые к аудиту в отдельных секторах экономики",
        "date": "26.07.2024",
        "time": "5-часового курса"
      },
      {
        "id": "std-2024-032-12",
        "name": "Введение в Международный стандарт управления качеством (ISQM 1): принципы, структура и внедрение",
        "date": "29.08.2024",
        "time": "20 (5 дней)-часового курса"
      },
      {
        "id": "std-2024-032-13",
        "name": "Эффективная деловая коммуникация в профессиональной среде: навыки взаимодействия, переговоров и презентации",
        "date": "20.09.2024",
        "time": "2-часового курса"
      },
      {
        "id": "std-2024-032-14",
        "name": "Применение МСА 330: Аудиторские процедуры в ответ на оцененные риски существенного искажения",
        "date": "24.10.2024",
        "time": "2-часового курса"
      },
      {
        "id": "std-2024-032-15",
        "name": "Аудит оценочных значений, включая справедливую стоимость и резервы: применение МСА 540",
        "date": "25.10.2024",
        "time": "2-часового курса"
      },
      {
        "id": "std-2024-032-16",
        "name": "Разработка и реализация стратегии управления клиентским портфелем: сегментация, приоритеты и качество обслуживани",
        "date": "20.12.2024",
        "time": "6-часового курса"
      }
    ]
  },
  {
    "id": "std-2024-033",
    "name": "Эгамкулов Аббос",
    "certificates": [
      {
        "id": "std-2024-033-1",
        "name": "Принципы профессиональной этики и обеспечение независимости аудиторской организации",
        "date": "06.01.2024",
        "time": "8-часового курса"
      },
      {
        "id": "std-2024-033-2",
        "name": "Профессиональные требования к независимости аудитора",
        "date": "12.01.2024",
        "time": "6-часового курса"
      }
    ]
  },
  {
    "id": "std-2024-034",
    "name": "Джумаев Икромжон ",
    "certificates": [
      {
        "id": "std-2024-034-1",
        "name": "Принципы профессиональной этики и обеспечение независимости аудиторской организации",
        "date": "06.01.2024",
        "time": "8-часового курса"
      },
      {
        "id": "std-2024-034-2",
        "name": "Профессиональные требования к независимости аудитора",
        "date": "12.01.2024",
        "time": "6-часового курса"
      },
      {
        "id": "std-2024-034-3",
        "name": "Применение МСА 315 при выявлении и оценке рисков существенного искажения финансовой отчетности",
        "date": "19.01.2024",
        "time": "2-часового курса"
      },
      {
        "id": "std-2024-034-4",
        "name": "Актуальные изменения в международных стандартах аудита и нормативных требованиях",
        "date": "26.01.2024",
        "time": "6-часового курса"
      },
      {
        "id": "std-2024-034-5",
        "name": "Основы кибербезопасности и защита информации в аудиторской практике",
        "date": "31.01.2024",
        "time": "6-часового курса"
      },
      {
        "id": "std-2024-034-6",
        "name": "Международный стандарт контроля качества 1: Построение системы управления качеством в аудиторской фирме",
        "date": "23.02.2024",
        "time": "8-часового курса"
      },
      {
        "id": "std-2024-034-7",
        "name": "Комплексный обзор Международных стандартов аудита и их практическое применение",
        "date": "15.03.2024",
        "time": "8-часового курса"
      },
      {
        "id": "std-2024-034-8",
        "name": "Международные стандарты финансовой отчетности: принципы, структура и применение",
        "date": "26.04.2024",
        "time": "8-часового курса"
      },
      {
        "id": "std-2024-034-9",
        "name": "Аудиторские доказательства",
        "date": "24.05.2024",
        "time": "3-часового курса"
      },
      {
        "id": "std-2024-034-10",
        "name": "Эффективное взаимодействие с клиентами и обеспечение качества аудиторских услуг",
        "date": "21.06.2024",
        "time": "6-часового курса"
      },
      {
        "id": "std-2024-034-11",
        "name": "Нормативно-правовые требования и стандарты, применимые к аудиту в отдельных секторах экономики",
        "date": "26.07.2024",
        "time": "5-часового курса"
      },
      {
        "id": "std-2024-034-12",
        "name": "Введение в Международный стандарт управления качеством (ISQM 1): принципы, структура и внедрение",
        "date": "29.08.2024",
        "time": "20 (5 дней)-часового курса"
      },
      {
        "id": "std-2024-034-13",
        "name": "Эффективная деловая коммуникация в профессиональной среде: навыки взаимодействия, переговоров и презентации",
        "date": "20.09.2024",
        "time": "2-часового курса"
      },
      {
        "id": "std-2024-034-14",
        "name": "Применение МСА 330: Аудиторские процедуры в ответ на оцененные риски существенного искажения",
        "date": "24.10.2024",
        "time": "2-часового курса"
      },
      {
        "id": "std-2024-034-15",
        "name": "Аудит оценочных значений, включая справедливую стоимость и резервы: применение МСА 540",
        "date": "25.10.2024",
        "time": "2-часового курса"
      },
      {
        "id": "std-2024-034-16",
        "name": "Разработка и реализация стратегии управления клиентским портфелем: сегментация, приоритеты и качество обслуживани",
        "date": "20.12.2024",
        "time": "6-часового курса"
      }
    ]
  },
  {
    "id": "std-2024-035",
    "name": "Юнусов Улугбек ",
    "certificates": [
      {
        "id": "std-2024-035-1",
        "name": "Принципы профессиональной этики и обеспечение независимости аудиторской организации",
        "date": "06.01.2024",
        "time": "8-часового курса"
      },
      {
        "id": "std-2024-035-2",
        "name": "Профессиональные требования к независимости аудитора",
        "date": "12.01.2024",
        "time": "6-часового курса"
      },
      {
        "id": "std-2024-035-3",
        "name": "Применение МСА 315 при выявлении и оценке рисков существенного искажения финансовой отчетности",
        "date": "19.01.2024",
        "time": "2-часового курса"
      },
      {
        "id": "std-2024-035-4",
        "name": "Актуальные изменения в международных стандартах аудита и нормативных требованиях",
        "date": "26.01.2024",
        "time": "6-часового курса"
      },
      {
        "id": "std-2024-035-5",
        "name": "Основы кибербезопасности и защита информации в аудиторской практике",
        "date": "31.01.2024",
        "time": "6-часового курса"
      },
      {
        "id": "std-2024-035-6",
        "name": "Международный стандарт контроля качества 1: Построение системы управления качеством в аудиторской фирме",
        "date": "23.02.2024",
        "time": "8-часового курса"
      },
      {
        "id": "std-2024-035-7",
        "name": "Комплексный обзор Международных стандартов аудита и их практическое применение",
        "date": "15.03.2024",
        "time": "8-часового курса"
      },
      {
        "id": "std-2024-035-8",
        "name": "Международные стандарты финансовой отчетности: принципы, структура и применение",
        "date": "26.04.2024",
        "time": "8-часового курса"
      },
      {
        "id": "std-2024-035-9",
        "name": "Аудиторские доказательства",
        "date": "24.05.2024",
        "time": "3-часового курса"
      },
      {
        "id": "std-2024-035-10",
        "name": "Эффективное взаимодействие с клиентами и обеспечение качества аудиторских услуг",
        "date": "21.06.2024",
        "time": "6-часового курса"
      },
      {
        "id": "std-2024-035-11",
        "name": "Нормативно-правовые требования и стандарты, применимые к аудиту в отдельных секторах экономики",
        "date": "26.07.2024",
        "time": "5-часового курса"
      },
      {
        "id": "std-2024-035-12",
        "name": "Введение в Международный стандарт управления качеством (ISQM 1): принципы, структура и внедрение",
        "date": "29.08.2024",
        "time": "20 (5 дней)-часового курса"
      },
      {
        "id": "std-2024-035-13",
        "name": "Эффективная деловая коммуникация в профессиональной среде: навыки взаимодействия, переговоров и презентации",
        "date": "20.09.2024",
        "time": "2-часового курса"
      },
      {
        "id": "std-2024-035-14",
        "name": "Применение МСА 330: Аудиторские процедуры в ответ на оцененные риски существенного искажения",
        "date": "24.10.2024",
        "time": "2-часового курса"
      },
      {
        "id": "std-2024-035-15",
        "name": "Аудит оценочных значений, включая справедливую стоимость и резервы: применение МСА 540",
        "date": "25.10.2024",
        "time": "2-часового курса"
      },
      {
        "id": "std-2024-035-16",
        "name": "Разработка и реализация стратегии управления клиентским портфелем: сегментация, приоритеты и качество обслуживани",
        "date": "20.12.2024",
        "time": "6-часового курса"
      }
    ]
  },
  {
    "id": "std-2024-036",
    "name": "Алимова Нилуфар ",
    "certificates": [
      {
        "id": "std-2024-036-1",
        "name": "Принципы профессиональной этики и обеспечение независимости аудиторской организации",
        "date": "06.01.2024",
        "time": "8-часового курса"
      },
      {
        "id": "std-2024-036-2",
        "name": "Профессиональные требования к независимости аудитора",
        "date": "12.01.2024",
        "time": "6-часового курса"
      },
      {
        "id": "std-2024-036-3",
        "name": "Основы кибербезопасности и защита информации в аудиторской практике",
        "date": "31.01.2024",
        "time": "6-часового курса"
      },
      {
        "id": "std-2024-036-4",
        "name": "Аудиторские доказательства",
        "date": "24.05.2024",
        "time": "3-часового курса"
      },
      {
        "id": "std-2024-036-5",
        "name": "Эффективное взаимодействие с клиентами и обеспечение качества аудиторских услуг",
        "date": "21.06.2024",
        "time": "6-часового курса"
      },
      {
        "id": "std-2024-036-6",
        "name": "Введение в Международный стандарт управления качеством (ISQM 1): принципы, структура и внедрение",
        "date": "29.08.2024",
        "time": "20 (5 дней)-часового курса"
      },
      {
        "id": "std-2024-036-7",
        "name": "Эффективная деловая коммуникация в профессиональной среде: навыки взаимодействия, переговоров и презентации",
        "date": "20.09.2024",
        "time": "2-часового курса"
      }
    ]
  },
  {
    "id": "std-2024-037",
    "name": "Мирахмедова Феруза",
    "certificates": [
      {
        "id": "std-2024-037-1",
        "name": "Принципы профессиональной этики и обеспечение независимости аудиторской организации",
        "date": "06.01.2024",
        "time": "8-часового курса"
      },
      {
        "id": "std-2024-037-2",
        "name": "Профессиональные требования к независимости аудитора",
        "date": "12.01.2024",
        "time": "6-часового курса"
      },
      {
        "id": "std-2024-037-3",
        "name": "Основы кибербезопасности и защита информации в аудиторской практике",
        "date": "31.01.2024",
        "time": "6-часового курса"
      }
    ]
  },
  {
    "id": "std-2024-039",
    "name": "Азимов Улугбек",
    "certificates": [
      {
        "id": "std-2024-039-1",
        "name": "Принципы профессиональной этики и обеспечение независимости аудиторской организации",
        "date": "24.01.2024",
        "time": "8-часового курса"
      },
      {
        "id": "std-2024-039-2",
        "name": "Профессиональные требования к независимости аудитора",
        "date": "29.01.2024",
        "time": "6-часового курса"
      },
      {
        "id": "std-2024-039-3",
        "name": "Применение МСА 315 при выявлении и оценке рисков существенного искажения финансовой отчетности",
        "date": "02.02.2024",
        "time": "2-часового курса"
      },
      {
        "id": "std-2024-039-4",
        "name": "Актуальные изменения в международных стандартах аудита и нормативных требованиях",
        "date": "26.01.2024",
        "time": "6-часового курса"
      },
      {
        "id": "std-2024-039-5",
        "name": "Основы кибербезопасности и защита информации в аудиторской практике",
        "date": "31.01.2024",
        "time": "6-часового курса"
      },
      {
        "id": "std-2024-039-6",
        "name": "Международный стандарт контроля качества 1: Построение системы управления качеством в аудиторской фирме",
        "date": "23.02.2024",
        "time": "8-часового курса"
      },
      {
        "id": "std-2024-039-7",
        "name": "Комплексный обзор Международных стандартов аудита и их практическое применение",
        "date": "15.03.2024",
        "time": "8-часового курса"
      },
      {
        "id": "std-2024-039-8",
        "name": "Международные стандарты финансовой отчетности: принципы, структура и применение",
        "date": "26.04.2024",
        "time": "8-часового курса"
      },
      {
        "id": "std-2024-039-9",
        "name": "Аудиторские доказательства",
        "date": "24.05.2024",
        "time": "3-часового курса"
      },
      {
        "id": "std-2024-039-10",
        "name": "Эффективное взаимодействие с клиентами и обеспечение качества аудиторских услуг",
        "date": "21.06.2024",
        "time": "6-часового курса"
      },
      {
        "id": "std-2024-039-11",
        "name": "Нормативно-правовые требования и стандарты, применимые к аудиту в отдельных секторах экономики",
        "date": "26.07.2024",
        "time": "5-часового курса"
      },
      {
        "id": "std-2024-039-12",
        "name": "Введение в Международный стандарт управления качеством (ISQM 1): принципы, структура и внедрение",
        "date": "29.08.2024",
        "time": "20 (5 дней)-часового курса"
      },
      {
        "id": "std-2024-039-13",
        "name": "Эффективная деловая коммуникация в профессиональной среде: навыки взаимодействия, переговоров и презентации",
        "date": "20.09.2024",
        "time": "2-часового курса"
      },
      {
        "id": "std-2024-039-14",
        "name": "Применение МСА 330: Аудиторские процедуры в ответ на оцененные риски существенного искажения",
        "date": "24.10.2024",
        "time": "2-часового курса"
      },
      {
        "id": "std-2024-039-15",
        "name": "Аудит оценочных значений, включая справедливую стоимость и резервы: применение МСА 540",
        "date": "25.10.2024",
        "time": "2-часового курса"
      },
      {
        "id": "std-2024-039-16",
        "name": "Разработка и реализация стратегии управления клиентским портфелем: сегментация, приоритеты и качество обслуживани",
        "date": "20.12.2024",
        "time": "6-часового курса"
      }
    ]
  },
  {
    "id": "std-2024-040",
    "name": "Назиржонов Бахтиёржон",
    "certificates": [
      {
        "id": "std-2024-040-1",
        "name": "Принципы профессиональной этики и обеспечение независимости аудиторской организации",
        "date": "24.01.2024",
        "time": "8-часового курса"
      },
      {
        "id": "std-2024-040-2",
        "name": "Профессиональные требования к независимости аудитора",
        "date": "29.01.2024",
        "time": "6-часового курса"
      },
      {
        "id": "std-2024-040-3",
        "name": "Применение МСА 315 при выявлении и оценке рисков существенного искажения финансовой отчетности",
        "date": "02.02.2024",
        "time": "2-часового курса"
      },
      {
        "id": "std-2024-040-4",
        "name": "Актуальные изменения в международных стандартах аудита и нормативных требованиях",
        "date": "26.01.2024",
        "time": "6-часового курса"
      },
      {
        "id": "std-2024-040-5",
        "name": "Основы кибербезопасности и защита информации в аудиторской практике",
        "date": "31.01.2024",
        "time": "6-часового курса"
      },
      {
        "id": "std-2024-040-6",
        "name": "Международный стандарт контроля качества 1: Построение системы управления качеством в аудиторской фирме",
        "date": "23.02.2024",
        "time": "8-часового курса"
      },
      {
        "id": "std-2024-040-7",
        "name": "Комплексный обзор Международных стандартов аудита и их практическое применение",
        "date": "15.03.2024",
        "time": "8-часового курса"
      },
      {
        "id": "std-2024-040-8",
        "name": "Международные стандарты финансовой отчетности: принципы, структура и применение",
        "date": "26.04.2024",
        "time": "8-часового курса"
      }
    ]
  },
  {
    "id": "std-2024-041",
    "name": "Азаматова Асилзода",
    "certificates": [
      {
        "id": "std-2024-041-1",
        "name": "Принципы профессиональной этики и обеспечение независимости аудиторской организации",
        "date": "29.03.2024",
        "time": "8-часового курса"
      },
      {
        "id": "std-2024-041-2",
        "name": "Профессиональные требования к независимости аудитора",
        "date": "05.04.2024",
        "time": "6-часового курса"
      },
      {
        "id": "std-2024-041-3",
        "name": "Применение МСА 315 при выявлении и оценке рисков существенного искажения финансовой отчетности",
        "date": "17.04.2024",
        "time": "2-часового курса"
      },
      {
        "id": "std-2024-041-4",
        "name": "Актуальные изменения в международных стандартах аудита и нормативных требованиях",
        "date": "19.04.2024",
        "time": "6-часового курса"
      },
      {
        "id": "std-2024-041-5",
        "name": "Аудиторские доказательства",
        "date": "24.05.2024",
        "time": "3-часового курса"
      },
      {
        "id": "std-2024-041-6",
        "name": "Эффективное взаимодействие с клиентами и обеспечение качества аудиторских услуг",
        "date": "21.06.2024",
        "time": "6-часового курса"
      },
      {
        "id": "std-2024-041-7",
        "name": "Введение в Международный стандарт управления качеством (ISQM 1): принципы, структура и внедрение",
        "date": "29.08.2024",
        "time": "20 (5 дней)-часового курса"
      },
      {
        "id": "std-2024-041-8",
        "name": "Эффективная деловая коммуникация в профессиональной среде: навыки взаимодействия, переговоров и презентации",
        "date": "20.09.2024",
        "time": "2-часового курса"
      }
    ]
  },
  {
    "id": "std-2024-042",
    "name": "Норбоева Нигина ",
    "certificates": [
      {
        "id": "std-2024-042-1",
        "name": "Принципы профессиональной этики и обеспечение независимости аудиторской организации",
        "date": "31.05.2024",
        "time": "8-часового курса"
      },
      {
        "id": "std-2024-042-2",
        "name": "Профессиональные требования к независимости аудитора",
        "date": "07.06.2024",
        "time": "6-часового курса"
      },
      {
        "id": "std-2024-042-3",
        "name": "Применение МСА 315 при выявлении и оценке рисков существенного искажения финансовой отчетности",
        "date": "12.06.2024",
        "time": "2-часового курса"
      },
      {
        "id": "std-2024-042-4",
        "name": "Актуальные изменения в международных стандартах аудита и нормативных требованиях",
        "date": "14.06.2024",
        "time": "6-часового курса"
      },
      {
        "id": "std-2024-042-5",
        "name": "Основы кибербезопасности и защита информации в аудиторской практике",
        "date": "21.06.2024",
        "time": "6-часового курса"
      },
      {
        "id": "std-2024-042-6",
        "name": "Международный стандарт контроля качества 1: Построение системы управления качеством в аудиторской фирме",
        "date": "28.06.2024",
        "time": "8-часового курса"
      },
      {
        "id": "std-2024-042-7",
        "name": "Комплексный обзор Международных стандартов аудита и их практическое применение",
        "date": "03.07.2024",
        "time": "8-часового курса"
      },
      {
        "id": "std-2024-042-8",
        "name": "Международные стандарты финансовой отчетности: принципы, структура и применение",
        "date": "05.07.2024",
        "time": "8-часового курса"
      },
      {
        "id": "std-2024-042-9",
        "name": "Аудиторские доказательства",
        "date": "12.07.2024",
        "time": "3-часового курса"
      },
      {
        "id": "std-2024-042-10",
        "name": "Эффективное взаимодействие с клиентами и обеспечение качества аудиторских услуг",
        "date": "19.07.2024",
        "time": "6-часового курса"
      },
      {
        "id": "std-2024-042-11",
        "name": "Нормативно-правовые требования и стандарты, применимые к аудиту в отдельных секторах экономики",
        "date": "26.07.2024",
        "time": "5-часового курса"
      },
      {
        "id": "std-2024-042-12",
        "name": "Введение в Международный стандарт управления качеством (ISQM 1): принципы, структура и внедрение",
        "date": "29.08.2024",
        "time": "20 (5 дней)-часового курса"
      },
      {
        "id": "std-2024-042-13",
        "name": "Эффективная деловая коммуникация в профессиональной среде: навыки взаимодействия, переговоров и презентации",
        "date": "20.09.2024",
        "time": "2-часового курса"
      },
      {
        "id": "std-2024-042-14",
        "name": "Применение МСА 330: Аудиторские процедуры в ответ на оцененные риски существенного искажения",
        "date": "24.10.2024",
        "time": "2-часового курса"
      },
      {
        "id": "std-2024-042-15",
        "name": "Аудит оценочных значений, включая справедливую стоимость и резервы: применение МСА 540",
        "date": "25.10.2024",
        "time": "2-часового курса"
      },
      {
        "id": "std-2024-042-16",
        "name": "Разработка и реализация стратегии управления клиентским портфелем: сегментация, приоритеты и качество обслуживани",
        "date": "20.12.2024",
        "time": "6-часового курса"
      }
    ]
  },
  {
    "id": "std-2024-043",
    "name": "Саидов  Жамшидбек ",
    "certificates": [
      {
        "id": "std-2024-043-1",
        "name": "Принципы профессиональной этики и обеспечение независимости аудиторской организации",
        "date": "31.05.2024",
        "time": "8-часового курса"
      },
      {
        "id": "std-2024-043-2",
        "name": "Профессиональные требования к независимости аудитора",
        "date": "07.06.2024",
        "time": "6-часового курса"
      },
      {
        "id": "std-2024-043-3",
        "name": "Применение МСА 315 при выявлении и оценке рисков существенного искажения финансовой отчетности",
        "date": "12.06.2024",
        "time": "2-часового курса"
      },
      {
        "id": "std-2024-043-4",
        "name": "Актуальные изменения в международных стандартах аудита и нормативных требованиях",
        "date": "14.06.2024",
        "time": "6-часового курса"
      },
      {
        "id": "std-2024-043-5",
        "name": "Основы кибербезопасности и защита информации в аудиторской практике",
        "date": "21.06.2024",
        "time": "6-часового курса"
      },
      {
        "id": "std-2024-043-6",
        "name": "Международный стандарт контроля качества 1: Построение системы управления качеством в аудиторской фирме",
        "date": "28.06.2024",
        "time": "8-часового курса"
      },
      {
        "id": "std-2024-043-7",
        "name": "Комплексный обзор Международных стандартов аудита и их практическое применение",
        "date": "03.07.2024",
        "time": "8-часового курса"
      },
      {
        "id": "std-2024-043-8",
        "name": "Международные стандарты финансовой отчетности: принципы, структура и применение",
        "date": "05.07.2024",
        "time": "8-часового курса"
      },
      {
        "id": "std-2024-043-9",
        "name": "Аудиторские доказательства",
        "date": "12.07.2024",
        "time": "3-часового курса"
      },
      {
        "id": "std-2024-043-10",
        "name": "Эффективное взаимодействие с клиентами и обеспечение качества аудиторских услуг",
        "date": "19.07.2024",
        "time": "6-часового курса"
      },
      {
        "id": "std-2024-043-11",
        "name": "Нормативно-правовые требования и стандарты, применимые к аудиту в отдельных секторах экономики",
        "date": "26.07.2024",
        "time": "5-часового курса"
      },
      {
        "id": "std-2024-043-12",
        "name": "Введение в Международный стандарт управления качеством (ISQM 1): принципы, структура и внедрение",
        "date": "29.08.2024",
        "time": "20 (5 дней)-часового курса"
      },
      {
        "id": "std-2024-043-13",
        "name": "Эффективная деловая коммуникация в профессиональной среде: навыки взаимодействия, переговоров и презентации",
        "date": "20.09.2024",
        "time": "2-часового курса"
      },
      {
        "id": "std-2024-043-14",
        "name": "Применение МСА 330: Аудиторские процедуры в ответ на оцененные риски существенного искажения",
        "date": "24.10.2024",
        "time": "2-часового курса"
      },
      {
        "id": "std-2024-043-15",
        "name": "Аудит оценочных значений, включая справедливую стоимость и резервы: применение МСА 540",
        "date": "25.10.2024",
        "time": "2-часового курса"
      }
    ]
  },
  {
    "id": "std-2024-044",
    "name": "Убайдуллаева Фазилат ",
    "certificates": [
      {
        "id": "std-2024-044-1",
        "name": "Принципы профессиональной этики и обеспечение независимости аудиторской организации",
        "date": "31.05.2024",
        "time": "8-часового курса"
      },
      {
        "id": "std-2024-044-2",
        "name": "Профессиональные требования к независимости аудитора",
        "date": "07.06.2024",
        "time": "6-часового курса"
      },
      {
        "id": "std-2024-044-3",
        "name": "Применение МСА 315 при выявлении и оценке рисков существенного искажения финансовой отчетности",
        "date": "12.06.2024",
        "time": "2-часового курса"
      },
      {
        "id": "std-2024-044-4",
        "name": "Актуальные изменения в международных стандартах аудита и нормативных требованиях",
        "date": "14.06.2024",
        "time": "6-часового курса"
      },
      {
        "id": "std-2024-044-5",
        "name": "Основы кибербезопасности и защита информации в аудиторской практике",
        "date": "21.06.2024",
        "time": "6-часового курса"
      },
      {
        "id": "std-2024-044-6",
        "name": "Международный стандарт контроля качества 1: Построение системы управления качеством в аудиторской фирме",
        "date": "28.06.2024",
        "time": "8-часового курса"
      },
      {
        "id": "std-2024-044-7",
        "name": "Комплексный обзор Международных стандартов аудита и их практическое применение",
        "date": "03.07.2024",
        "time": "8-часового курса"
      },
      {
        "id": "std-2024-044-8",
        "name": "Международные стандарты финансовой отчетности: принципы, структура и применение",
        "date": "05.07.2024",
        "time": "8-часового курса"
      },
      {
        "id": "std-2024-044-9",
        "name": "Аудиторские доказательства",
        "date": "12.07.2024",
        "time": "3-часового курса"
      },
      {
        "id": "std-2024-044-10",
        "name": "Эффективное взаимодействие с клиентами и обеспечение качества аудиторских услуг",
        "date": "19.07.2024",
        "time": "6-часового курса"
      },
      {
        "id": "std-2024-044-11",
        "name": "Нормативно-правовые требования и стандарты, применимые к аудиту в отдельных секторах экономики",
        "date": "26.07.2024",
        "time": "5-часового курса"
      },
      {
        "id": "std-2024-044-12",
        "name": "Введение в Международный стандарт управления качеством (ISQM 1): принципы, структура и внедрение",
        "date": "29.08.2024",
        "time": "20 (5 дней)-часового курса"
      },
      {
        "id": "std-2024-044-13",
        "name": "Эффективная деловая коммуникация в профессиональной среде: навыки взаимодействия, переговоров и презентации",
        "date": "20.09.2024",
        "time": "2-часового курса"
      },
      {
        "id": "std-2024-044-14",
        "name": "Применение МСА 330: Аудиторские процедуры в ответ на оцененные риски существенного искажения",
        "date": "24.10.2024",
        "time": "2-часового курса"
      },
      {
        "id": "std-2024-044-15",
        "name": "Аудит оценочных значений, включая справедливую стоимость и резервы: применение МСА 540",
        "date": "25.10.2024",
        "time": "2-часового курса"
      },
      {
        "id": "std-2024-044-16",
        "name": "Разработка и реализация стратегии управления клиентским портфелем: сегментация, приоритеты и качество обслуживани",
        "date": "20.12.2024",
        "time": "6-часового курса"
      }
    ]
  },
  {
    "id": "std-2024-045",
    "name": "Аскарова Угилой ",
    "certificates": [
      {
        "id": "std-2024-045-1",
        "name": "Принципы профессиональной этики и обеспечение независимости аудиторской организации",
        "date": "31.05.2024",
        "time": "8-часового курса"
      },
      {
        "id": "std-2024-045-2",
        "name": "Профессиональные требования к независимости аудитора",
        "date": "07.06.2024",
        "time": "6-часового курса"
      },
      {
        "id": "std-2024-045-3",
        "name": "Применение МСА 315 при выявлении и оценке рисков существенного искажения финансовой отчетности",
        "date": "12.06.2024",
        "time": "2-часового курса"
      },
      {
        "id": "std-2024-045-4",
        "name": "Актуальные изменения в международных стандартах аудита и нормативных требованиях",
        "date": "14.06.2024",
        "time": "6-часового курса"
      },
      {
        "id": "std-2024-045-5",
        "name": "Основы кибербезопасности и защита информации в аудиторской практике",
        "date": "21.06.2024",
        "time": "6-часового курса"
      },
      {
        "id": "std-2024-045-6",
        "name": "Международный стандарт контроля качества 1: Построение системы управления качеством в аудиторской фирме",
        "date": "28.06.2024",
        "time": "8-часового курса"
      },
      {
        "id": "std-2024-045-7",
        "name": "Комплексный обзор Международных стандартов аудита и их практическое применение",
        "date": "03.07.2024",
        "time": "8-часового курса"
      },
      {
        "id": "std-2024-045-8",
        "name": "Международные стандарты финансовой отчетности: принципы, структура и применение",
        "date": "05.07.2024",
        "time": "8-часового курса"
      },
      {
        "id": "std-2024-045-9",
        "name": "Аудиторские доказательства",
        "date": "12.07.2024",
        "time": "3-часового курса"
      },
      {
        "id": "std-2024-045-10",
        "name": "Эффективное взаимодействие с клиентами и обеспечение качества аудиторских услуг",
        "date": "19.07.2024",
        "time": "6-часового курса"
      },
      {
        "id": "std-2024-045-11",
        "name": "Нормативно-правовые требования и стандарты, применимые к аудиту в отдельных секторах экономики",
        "date": "26.07.2024",
        "time": "5-часового курса"
      },
      {
        "id": "std-2024-045-12",
        "name": "Введение в Международный стандарт управления качеством (ISQM 1): принципы, структура и внедрение",
        "date": "29.08.2024",
        "time": "20 (5 дней)-часового курса"
      },
      {
        "id": "std-2024-045-13",
        "name": "Эффективная деловая коммуникация в профессиональной среде: навыки взаимодействия, переговоров и презентации",
        "date": "20.09.2024",
        "time": "2-часового курса"
      },
      {
        "id": "std-2024-045-14",
        "name": "Применение МСА 330: Аудиторские процедуры в ответ на оцененные риски существенного искажения",
        "date": "24.10.2024",
        "time": "2-часового курса"
      },
      {
        "id": "std-2024-045-15",
        "name": "Аудит оценочных значений, включая справедливую стоимость и резервы: применение МСА 540",
        "date": "25.10.2024",
        "time": "2-часового курса"
      },
      {
        "id": "std-2024-045-16",
        "name": "Разработка и реализация стратегии управления клиентским портфелем: сегментация, приоритеты и качество обслуживани",
        "date": "20.12.2024",
        "time": "6-часового курса"
      }
    ]
  },
  {
    "id": "std-2024-046",
    "name": "Гайбуллаев Малик",
    "certificates": [
      {
        "id": "std-2024-046-1",
        "name": "Принципы профессиональной этики и обеспечение независимости аудиторской организации",
        "date": "31.05.2024",
        "time": "8-часового курса"
      },
      {
        "id": "std-2024-046-2",
        "name": "Профессиональные требования к независимости аудитора",
        "date": "07.06.2024",
        "time": "6-часового курса"
      },
      {
        "id": "std-2024-046-3",
        "name": "Применение МСА 315 при выявлении и оценке рисков существенного искажения финансовой отчетности",
        "date": "12.06.2024",
        "time": "2-часового курса"
      },
      {
        "id": "std-2024-046-4",
        "name": "Актуальные изменения в международных стандартах аудита и нормативных требованиях",
        "date": "14.06.2024",
        "time": "6-часового курса"
      },
      {
        "id": "std-2024-046-5",
        "name": "Основы кибербезопасности и защита информации в аудиторской практике",
        "date": "21.06.2024",
        "time": "6-часового курса"
      },
      {
        "id": "std-2024-046-6",
        "name": "Международный стандарт контроля качества 1: Построение системы управления качеством в аудиторской фирме",
        "date": "28.06.2024",
        "time": "8-часового курса"
      },
      {
        "id": "std-2024-046-7",
        "name": "Комплексный обзор Международных стандартов аудита и их практическое применение",
        "date": "03.07.2024",
        "time": "8-часового курса"
      },
      {
        "id": "std-2024-046-8",
        "name": "Международные стандарты финансовой отчетности: принципы, структура и применение",
        "date": "05.07.2024",
        "time": "8-часового курса"
      },
      {
        "id": "std-2024-046-9",
        "name": "Аудиторские доказательства",
        "date": "12.07.2024",
        "time": "3-часового курса"
      },
      {
        "id": "std-2024-046-10",
        "name": "Эффективное взаимодействие с клиентами и обеспечение качества аудиторских услуг",
        "date": "19.07.2024",
        "time": "6-часового курса"
      },
      {
        "id": "std-2024-046-11",
        "name": "Нормативно-правовые требования и стандарты, применимые к аудиту в отдельных секторах экономики",
        "date": "26.07.2024",
        "time": "5-часового курса"
      },
      {
        "id": "std-2024-046-12",
        "name": "Введение в Международный стандарт управления качеством (ISQM 1): принципы, структура и внедрение",
        "date": "29.08.2024",
        "time": "20 (5 дней)-часового курса"
      }
    ]
  },
  {
    "id": "std-2024-047",
    "name": "Носиров Фазлиддин",
    "certificates": [
      {
        "id": "std-2024-047-1",
        "name": "Принципы профессиональной этики и обеспечение независимости аудиторской организации",
        "date": "31.05.2024",
        "time": "8-часового курса"
      },
      {
        "id": "std-2024-047-2",
        "name": "Профессиональные требования к независимости аудитора",
        "date": "07.06.2024",
        "time": "6-часового курса"
      },
      {
        "id": "std-2024-047-3",
        "name": "Применение МСА 315 при выявлении и оценке рисков существенного искажения финансовой отчетности",
        "date": "12.06.2024",
        "time": "2-часового курса"
      },
      {
        "id": "std-2024-047-4",
        "name": "Актуальные изменения в международных стандартах аудита и нормативных требованиях",
        "date": "14.06.2024",
        "time": "6-часового курса"
      },
      {
        "id": "std-2024-047-5",
        "name": "Основы кибербезопасности и защита информации в аудиторской практике",
        "date": "21.06.2024",
        "time": "6-часового курса"
      },
      {
        "id": "std-2024-047-6",
        "name": "Международный стандарт контроля качества 1: Построение системы управления качеством в аудиторской фирме",
        "date": "28.06.2024",
        "time": "8-часового курса"
      },
      {
        "id": "std-2024-047-7",
        "name": "Комплексный обзор Международных стандартов аудита и их практическое применение",
        "date": "03.07.2024",
        "time": "8-часового курса"
      },
      {
        "id": "std-2024-047-8",
        "name": "Международные стандарты финансовой отчетности: принципы, структура и применение",
        "date": "05.07.2024",
        "time": "8-часового курса"
      },
      {
        "id": "std-2024-047-9",
        "name": "Аудиторские доказательства",
        "date": "12.07.2024",
        "time": "3-часового курса"
      },
      {
        "id": "std-2024-047-10",
        "name": "Эффективное взаимодействие с клиентами и обеспечение качества аудиторских услуг",
        "date": "19.07.2024",
        "time": "6-часового курса"
      },
      {
        "id": "std-2024-047-11",
        "name": "Нормативно-правовые требования и стандарты, применимые к аудиту в отдельных секторах экономики",
        "date": "26.07.2024",
        "time": "5-часового курса"
      },
      {
        "id": "std-2024-047-12",
        "name": "Введение в Международный стандарт управления качеством (ISQM 1): принципы, структура и внедрение",
        "date": "29.08.2024",
        "time": "20 (5 дней)-часового курса"
      }
    ]
  },
  {
    "id": "std-2024-048",
    "name": "Йулдашов Нодирбек ",
    "certificates": [
      {
        "id": "std-2024-048-1",
        "name": "Применение МСА 315 при выявлении и оценке рисков существенного искажения финансовой отчетности",
        "date": "12.06.2024",
        "time": "2-часового курса"
      },
      {
        "id": "std-2024-048-2",
        "name": "Актуальные изменения в международных стандартах аудита и нормативных требованиях",
        "date": "14.06.2024",
        "time": "6-часового курса"
      },
      {
        "id": "std-2024-048-3",
        "name": "Основы кибербезопасности и защита информации в аудиторской практике",
        "date": "21.06.2024",
        "time": "6-часового курса"
      },
      {
        "id": "std-2024-048-4",
        "name": "Международный стандарт контроля качества 1: Построение системы управления качеством в аудиторской фирме",
        "date": "28.06.2024",
        "time": "8-часового курса"
      },
      {
        "id": "std-2024-048-5",
        "name": "Комплексный обзор Международных стандартов аудита и их практическое применение",
        "date": "03.07.2024",
        "time": "8-часового курса"
      },
      {
        "id": "std-2024-048-6",
        "name": "Международные стандарты финансовой отчетности: принципы, структура и применение",
        "date": "05.07.2024",
        "time": "8-часового курса"
      },
      {
        "id": "std-2024-048-7",
        "name": "Аудиторские доказательства",
        "date": "12.07.2024",
        "time": "3-часового курса"
      },
      {
        "id": "std-2024-048-8",
        "name": "Эффективное взаимодействие с клиентами и обеспечение качества аудиторских услуг",
        "date": "19.07.2024",
        "time": "6-часового курса"
      },
      {
        "id": "std-2024-048-9",
        "name": "Нормативно-правовые требования и стандарты, применимые к аудиту в отдельных секторах экономики",
        "date": "26.07.2024",
        "time": "5-часового курса"
      },
      {
        "id": "std-2024-048-10",
        "name": "Введение в Международный стандарт управления качеством (ISQM 1): принципы, структура и внедрение",
        "date": "29.08.2024",
        "time": "20 (5 дней)-часового курса"
      },
      {
        "id": "std-2024-048-11",
        "name": "Эффективная деловая коммуникация в профессиональной среде: навыки взаимодействия, переговоров и презентации",
        "date": "20.09.2024",
        "time": "2-часового курса"
      },
      {
        "id": "std-2024-048-12",
        "name": "Применение МСА 330: Аудиторские процедуры в ответ на оцененные риски существенного искажения",
        "date": "24.10.2024",
        "time": "2-часового курса"
      },
      {
        "id": "std-2024-048-13",
        "name": "Аудит оценочных значений, включая справедливую стоимость и резервы: применение МСА 540",
        "date": "25.10.2024",
        "time": "2-часового курса"
      },
      {
        "id": "std-2024-048-14",
        "name": "Разработка и реализация стратегии управления клиентским портфелем: сегментация, приоритеты и качество обслуживани",
        "date": "20.12.2024",
        "time": "6-часового курса"
      }
    ]
  },
  {
    "id": "std-2024-049",
    "name": "Рахимов Одилжон ",
    "certificates": [
      {
        "id": "std-2024-049-1",
        "name": "Основы кибербезопасности и защита информации в аудиторской практике",
        "date": "21.06.2024",
        "time": "6-часового курса"
      },
      {
        "id": "std-2024-049-2",
        "name": "Международный стандарт контроля качества 1: Построение системы управления качеством в аудиторской фирме",
        "date": "28.06.2024",
        "time": "8-часового курса"
      },
      {
        "id": "std-2024-049-3",
        "name": "Комплексный обзор Международных стандартов аудита и их практическое применение",
        "date": "03.07.2024",
        "time": "8-часового курса"
      },
      {
        "id": "std-2024-049-4",
        "name": "Международные стандарты финансовой отчетности: принципы, структура и применение",
        "date": "05.07.2024",
        "time": "8-часового курса"
      },
      {
        "id": "std-2024-049-5",
        "name": "Аудиторские доказательства",
        "date": "12.07.2024",
        "time": "3-часового курса"
      },
      {
        "id": "std-2024-049-6",
        "name": "Эффективное взаимодействие с клиентами и обеспечение качества аудиторских услуг",
        "date": "19.07.2024",
        "time": "6-часового курса"
      },
      {
        "id": "std-2024-049-7",
        "name": "Нормативно-правовые требования и стандарты, применимые к аудиту в отдельных секторах экономики",
        "date": "26.07.2024",
        "time": "5-часового курса"
      },
      {
        "id": "std-2024-049-8",
        "name": "Введение в Международный стандарт управления качеством (ISQM 1): принципы, структура и внедрение",
        "date": "29.08.2024",
        "time": "20 (5 дней)-часового курса"
      },
      {
        "id": "std-2024-049-9",
        "name": "Эффективная деловая коммуникация в профессиональной среде: навыки взаимодействия, переговоров и презентации",
        "date": "20.09.2024",
        "time": "2-часового курса"
      },
      {
        "id": "std-2024-049-10",
        "name": "Применение МСА 330: Аудиторские процедуры в ответ на оцененные риски существенного искажения",
        "date": "24.10.2024",
        "time": "2-часового курса"
      },
      {
        "id": "std-2024-049-11",
        "name": "Аудит оценочных значений, включая справедливую стоимость и резервы: применение МСА 540",
        "date": "25.10.2024",
        "time": "2-часового курса"
      },
      {
        "id": "std-2024-049-12",
        "name": "Разработка и реализация стратегии управления клиентским портфелем: сегментация, приоритеты и качество обслуживани",
        "date": "20.12.2024",
        "time": "6-часового курса"
      }
    ]
  },
  {
    "id": "std-2024-050",
    "name": "Гаффоров Фазлиддин ",
    "certificates": [
      {
        "id": "std-2024-050-1",
        "name": "Принципы профессиональной этики и обеспечение независимости аудиторской организации",
        "date": "12.07.2024",
        "time": "8-часового курса"
      },
      {
        "id": "std-2024-050-2",
        "name": "Профессиональные требования к независимости аудитора",
        "date": "17.07.2024",
        "time": "6-часового курса"
      },
      {
        "id": "std-2024-050-3",
        "name": "Применение МСА 315 при выявлении и оценке рисков существенного искажения финансовой отчетности",
        "date": "18.07.2024",
        "time": "2-часового курса"
      },
      {
        "id": "std-2024-050-4",
        "name": "Актуальные изменения в международных стандартах аудита и нормативных требованиях",
        "date": "24.07.2024",
        "time": "6-часового курса"
      },
      {
        "id": "std-2024-050-5",
        "name": "Основы кибербезопасности и защита информации в аудиторской практике",
        "date": "26.07.2024",
        "time": "6-часового курса"
      },
      {
        "id": "std-2024-050-6",
        "name": "Международный стандарт контроля качества 1: Построение системы управления качеством в аудиторской фирме",
        "date": "02.08.2024",
        "time": "8-часового курса"
      },
      {
        "id": "std-2024-050-7",
        "name": "Комплексный обзор Международных стандартов аудита и их практическое применение",
        "date": "07.08.2024",
        "time": "8-часового курса"
      },
      {
        "id": "std-2024-050-8",
        "name": "Международные стандарты финансовой отчетности: принципы, структура и применение",
        "date": "09.08.2024",
        "time": "8-часового курса"
      },
      {
        "id": "std-2024-050-9",
        "name": "Аудиторские доказательства",
        "date": "14.08.2024",
        "time": "3-часового курса"
      },
      {
        "id": "std-2024-050-10",
        "name": "Эффективное взаимодействие с клиентами и обеспечение качества аудиторских услуг",
        "date": "16.08.2024",
        "time": "6-часового курса"
      },
      {
        "id": "std-2024-050-11",
        "name": "Нормативно-правовые требования и стандарты, применимые к аудиту в отдельных секторах экономики",
        "date": "21.08.2024",
        "time": "5-часового курса"
      },
      {
        "id": "std-2024-050-12",
        "name": "Введение в Международный стандарт управления качеством (ISQM 1): принципы, структура и внедрение",
        "date": "29.08.2024",
        "time": "20 (5 дней)-часового курса"
      },
      {
        "id": "std-2024-050-13",
        "name": "Эффективная деловая коммуникация в профессиональной среде: навыки взаимодействия, переговоров и презентации",
        "date": "20.09.2024",
        "time": "2-часового курса"
      },
      {
        "id": "std-2024-050-14",
        "name": "Применение МСА 330: Аудиторские процедуры в ответ на оцененные риски существенного искажения",
        "date": "24.10.2024",
        "time": "2-часового курса"
      },
      {
        "id": "std-2024-050-15",
        "name": "Аудит оценочных значений, включая справедливую стоимость и резервы: применение МСА 540",
        "date": "25.10.2024",
        "time": "2-часового курса"
      },
      {
        "id": "std-2024-050-16",
        "name": "Разработка и реализация стратегии управления клиентским портфелем: сегментация, приоритеты и качество обслуживани",
        "date": "20.12.2024",
        "time": "6-часового курса"
      }
    ]
  },
  {
    "id": "std-2024-051",
    "name": "Абдурахимов Сарварбек ",
    "certificates": [
      {
        "id": "std-2024-051-1",
        "name": "Принципы профессиональной этики и обеспечение независимости аудиторской организации",
        "date": "23.07.2024",
        "time": "8-часового курса"
      },
      {
        "id": "std-2024-051-2",
        "name": "Профессиональные требования к независимости аудитора",
        "date": "26.07.2024",
        "time": "6-часового курса"
      },
      {
        "id": "std-2024-051-3",
        "name": "Применение МСА 315 при выявлении и оценке рисков существенного искажения финансовой отчетности",
        "date": "24.07.2024",
        "time": "2-часового курса"
      },
      {
        "id": "std-2024-051-4",
        "name": "Актуальные изменения в международных стандартах аудита и нормативных требованиях",
        "date": "26.07.2024",
        "time": "6-часового курса"
      },
      {
        "id": "std-2024-051-5",
        "name": "Основы кибербезопасности и защита информации в аудиторской практике",
        "date": "31.07.2024",
        "time": "6-часового курса"
      },
      {
        "id": "std-2024-051-6",
        "name": "Международный стандарт контроля качества 1: Построение системы управления качеством в аудиторской фирме",
        "date": "02.08.2024",
        "time": "8-часового курса"
      },
      {
        "id": "std-2024-051-7",
        "name": "Комплексный обзор Международных стандартов аудита и их практическое применение",
        "date": "07.08.2024",
        "time": "8-часового курса"
      },
      {
        "id": "std-2024-051-8",
        "name": "Международные стандарты финансовой отчетности: принципы, структура и применение",
        "date": "09.08.2024",
        "time": "8-часового курса"
      },
      {
        "id": "std-2024-051-9",
        "name": "Аудиторские доказательства",
        "date": "14.08.2024",
        "time": "3-часового курса"
      },
      {
        "id": "std-2024-051-10",
        "name": "Эффективное взаимодействие с клиентами и обеспечение качества аудиторских услуг",
        "date": "16.08.2024",
        "time": "6-часового курса"
      },
      {
        "id": "std-2024-051-11",
        "name": "Нормативно-правовые требования и стандарты, применимые к аудиту в отдельных секторах экономики",
        "date": "21.08.2024",
        "time": "5-часового курса"
      },
      {
        "id": "std-2024-051-12",
        "name": "Введение в Международный стандарт управления качеством (ISQM 1): принципы, структура и внедрение",
        "date": "29.08.2024",
        "time": "20 (5 дней)-часового курса"
      },
      {
        "id": "std-2024-051-13",
        "name": "Эффективная деловая коммуникация в профессиональной среде: навыки взаимодействия, переговоров и презентации",
        "date": "20.09.2024",
        "time": "2-часового курса"
      },
      {
        "id": "std-2024-051-14",
        "name": "Применение МСА 330: Аудиторские процедуры в ответ на оцененные риски существенного искажения",
        "date": "24.10.2024",
        "time": "2-часового курса"
      },
      {
        "id": "std-2024-051-15",
        "name": "Аудит оценочных значений, включая справедливую стоимость и резервы: применение МСА 540",
        "date": "25.10.2024",
        "time": "2-часового курса"
      },
      {
        "id": "std-2024-051-16",
        "name": "Разработка и реализация стратегии управления клиентским портфелем: сегментация, приоритеты и качество обслуживани",
        "date": "20.12.2024",
        "time": "6-часового курса"
      }
    ]
  },
  {
    "id": "std-2024-052",
    "name": "Хошимов Иброхимжон ",
    "certificates": [
      {
        "id": "std-2024-052-1",
        "name": "Принципы профессиональной этики и обеспечение независимости аудиторской организации",
        "date": "27.08.2024",
        "time": "8-часового курса"
      },
      {
        "id": "std-2024-052-2",
        "name": "Профессиональные требования к независимости аудитора",
        "date": "29.08.2024",
        "time": "6-часового курса"
      },
      {
        "id": "std-2024-052-3",
        "name": "Применение МСА 315 при выявлении и оценке рисков существенного искажения финансовой отчетности",
        "date": "06.09.2024",
        "time": "2-часового курса"
      },
      {
        "id": "std-2024-052-4",
        "name": "Актуальные изменения в международных стандартах аудита и нормативных требованиях",
        "date": "11.09.2024",
        "time": "6-часового курса"
      },
      {
        "id": "std-2024-052-5",
        "name": "Основы кибербезопасности и защита информации в аудиторской практике",
        "date": "13.09.2024",
        "time": "6-часового курса"
      },
      {
        "id": "std-2024-052-6",
        "name": "Международный стандарт контроля качества 1: Построение системы управления качеством в аудиторской фирме",
        "date": "18.08.2024",
        "time": "8-часового курса"
      },
      {
        "id": "std-2024-052-7",
        "name": "Комплексный обзор Международных стандартов аудита и их практическое применение",
        "date": "20.08.2024",
        "time": "8-часового курса"
      },
      {
        "id": "std-2024-052-8",
        "name": "Международные стандарты финансовой отчетности: принципы, структура и применение",
        "date": "25.09.2024",
        "time": "8-часового курса"
      },
      {
        "id": "std-2024-052-9",
        "name": "Аудиторские доказательства",
        "date": "27.09.2024",
        "time": "3-часового курса"
      },
      {
        "id": "std-2024-052-10",
        "name": "Эффективное взаимодействие с клиентами и обеспечение качества аудиторских услуг",
        "date": "04.10.2024",
        "time": "6-часового курса"
      },
      {
        "id": "std-2024-052-11",
        "name": "Нормативно-правовые требования и стандарты, применимые к аудиту в отдельных секторах экономики",
        "date": "11.10.2024",
        "time": "5-часового курса"
      },
      {
        "id": "std-2024-052-12",
        "name": "Введение в Международный стандарт управления качеством (ISQM 1): принципы, структура и внедрение",
        "date": "18.10.2024",
        "time": "20 (5 дней)-часового курса"
      },
      {
        "id": "std-2024-052-13",
        "name": "Эффективная деловая коммуникация в профессиональной среде: навыки взаимодействия, переговоров и презентации",
        "date": "22.10.2024",
        "time": "2-часового курса"
      },
      {
        "id": "std-2024-052-14",
        "name": "Применение МСА 330: Аудиторские процедуры в ответ на оцененные риски существенного искажения",
        "date": "24.10.2024",
        "time": "2-часового курса"
      },
      {
        "id": "std-2024-052-15",
        "name": "Аудит оценочных значений, включая справедливую стоимость и резервы: применение МСА 540",
        "date": "25.10.2024",
        "time": "2-часового курса"
      },
      {
        "id": "std-2024-052-16",
        "name": "Разработка и реализация стратегии управления клиентским портфелем: сегментация, приоритеты и качество обслуживани",
        "date": "20.12.2024",
        "time": "6-часового курса"
      }
    ]
  },
  {
    "id": "std-2024-053",
    "name": "Юлдашева Камола ",
    "certificates": [
      {
        "id": "std-2024-053-1",
        "name": "Принципы профессиональной этики и обеспечение независимости аудиторской организации",
        "date": "27.08.2024",
        "time": "8-часового курса"
      },
      {
        "id": "std-2024-053-2",
        "name": "Профессиональные требования к независимости аудитора",
        "date": "29.08.2024",
        "time": "6-часового курса"
      },
      {
        "id": "std-2024-053-3",
        "name": "Применение МСА 315 при выявлении и оценке рисков существенного искажения финансовой отчетности",
        "date": "06.09.2024",
        "time": "2-часового курса"
      },
      {
        "id": "std-2024-053-4",
        "name": "Актуальные изменения в международных стандартах аудита и нормативных требованиях",
        "date": "11.09.2024",
        "time": "6-часового курса"
      },
      {
        "id": "std-2024-053-5",
        "name": "Основы кибербезопасности и защита информации в аудиторской практике",
        "date": "13.09.2024",
        "time": "6-часового курса"
      },
      {
        "id": "std-2024-053-6",
        "name": "Международный стандарт контроля качества 1: Построение системы управления качеством в аудиторской фирме",
        "date": "18.08.2024",
        "time": "8-часового курса"
      },
      {
        "id": "std-2024-053-7",
        "name": "Комплексный обзор Международных стандартов аудита и их практическое применение",
        "date": "20.08.2024",
        "time": "8-часового курса"
      },
      {
        "id": "std-2024-053-8",
        "name": "Международные стандарты финансовой отчетности: принципы, структура и применение",
        "date": "25.09.2024",
        "time": "8-часового курса"
      },
      {
        "id": "std-2024-053-9",
        "name": "Аудиторские доказательства",
        "date": "27.09.2024",
        "time": "3-часового курса"
      },
      {
        "id": "std-2024-053-10",
        "name": "Эффективное взаимодействие с клиентами и обеспечение качества аудиторских услуг",
        "date": "04.10.2024",
        "time": "6-часового курса"
      },
      {
        "id": "std-2024-053-11",
        "name": "Нормативно-правовые требования и стандарты, применимые к аудиту в отдельных секторах экономики",
        "date": "11.10.2024",
        "time": "5-часового курса"
      },
      {
        "id": "std-2024-053-12",
        "name": "Введение в Международный стандарт управления качеством (ISQM 1): принципы, структура и внедрение",
        "date": "18.10.2024",
        "time": "20 (5 дней)-часового курса"
      },
      {
        "id": "std-2024-053-13",
        "name": "Эффективная деловая коммуникация в профессиональной среде: навыки взаимодействия, переговоров и презентации",
        "date": "22.10.2024",
        "time": "2-часового курса"
      },
      {
        "id": "std-2024-053-14",
        "name": "Применение МСА 330: Аудиторские процедуры в ответ на оцененные риски существенного искажения",
        "date": "24.10.2024",
        "time": "2-часового курса"
      },
      {
        "id": "std-2024-053-15",
        "name": "Аудит оценочных значений, включая справедливую стоимость и резервы: применение МСА 540",
        "date": "25.10.2024",
        "time": "2-часового курса"
      },
      {
        "id": "std-2024-053-16",
        "name": "Разработка и реализация стратегии управления клиентским портфелем: сегментация, приоритеты и качество обслуживани",
        "date": "20.12.2024",
        "time": "6-часового курса"
      }
    ]
  },
  {
    "id": "std-2024-054",
    "name": "Суннатуллаев Жавохир ",
    "certificates": [
      {
        "id": "std-2024-054-1",
        "name": "Принципы профессиональной этики и обеспечение независимости аудиторской организации",
        "date": "20.09.2024",
        "time": "8-часового курса"
      },
      {
        "id": "std-2024-054-2",
        "name": "Профессиональные требования к независимости аудитора",
        "date": "27.09.2024",
        "time": "6-часового курса"
      },
      {
        "id": "std-2024-054-3",
        "name": "Применение МСА 315 при выявлении и оценке рисков существенного искажения финансовой отчетности",
        "date": "30.09.2024",
        "time": "2-часового курса"
      },
      {
        "id": "std-2024-054-4",
        "name": "Актуальные изменения в международных стандартах аудита и нормативных требованиях",
        "date": "04.10.2024",
        "time": "6-часового курса"
      },
      {
        "id": "std-2024-054-5",
        "name": "Основы кибербезопасности и защита информации в аудиторской практике",
        "date": "11.10.2024",
        "time": "6-часового курса"
      },
      {
        "id": "std-2024-054-6",
        "name": "Международный стандарт контроля качества 1: Построение системы управления качеством в аудиторской фирме",
        "date": "18.10.2024",
        "time": "8-часового курса"
      },
      {
        "id": "std-2024-054-7",
        "name": "Комплексный обзор Международных стандартов аудита и их практическое применение",
        "date": "23.10.2024",
        "time": "8-часового курса"
      },
      {
        "id": "std-2024-054-8",
        "name": "Международные стандарты финансовой отчетности: принципы, структура и применение",
        "date": "25.10.2024",
        "time": "8-часового курса"
      },
      {
        "id": "std-2024-054-9",
        "name": "Аудиторские доказательства",
        "date": "31.10.2024",
        "time": "3-часового курса"
      },
      {
        "id": "std-2024-054-10",
        "name": "Эффективное взаимодействие с клиентами и обеспечение качества аудиторских услуг",
        "date": "06.11.2024",
        "time": "6-часового курса"
      },
      {
        "id": "std-2024-054-11",
        "name": "Нормативно-правовые требования и стандарты, применимые к аудиту в отдельных секторах экономики",
        "date": "08.11.2024",
        "time": "5-часового курса"
      },
      {
        "id": "std-2024-054-12",
        "name": "Введение в Международный стандарт управления качеством (ISQM 1): принципы, структура и внедрение",
        "date": "15.11.2024",
        "time": "20 (5 дней)-часового курса"
      },
      {
        "id": "std-2024-054-13",
        "name": "Эффективная деловая коммуникация в профессиональной среде: навыки взаимодействия, переговоров и презентации",
        "date": "20.11.2024",
        "time": "2-часового курса"
      },
      {
        "id": "std-2024-054-14",
        "name": "Применение МСА 330: Аудиторские процедуры в ответ на оцененные риски существенного искажения",
        "date": "21.11.2024",
        "time": "2-часового курса"
      },
      {
        "id": "std-2024-054-15",
        "name": "Аудит оценочных значений, включая справедливую стоимость и резервы: применение МСА 540",
        "date": "22.11.2024",
        "time": "2-часового курса"
      },
      {
        "id": "std-2024-054-16",
        "name": "Разработка и реализация стратегии управления клиентским портфелем: сегментация, приоритеты и качество обслуживани",
        "date": "20.12.2024",
        "time": "6-часового курса"
      }
    ]
  },
  {
    "id": "std-2024-055",
    "name": "Олижонова Насиба",
    "certificates": [
      {
        "id": "std-2024-055-1",
        "name": "Принципы профессиональной этики и обеспечение независимости аудиторской организации",
        "date": "30.10.2024",
        "time": "8-часового курса"
      },
      {
        "id": "std-2024-055-2",
        "name": "Профессиональные требования к независимости аудитора",
        "date": "06.11.2024",
        "time": "6-часового курса"
      },
      {
        "id": "std-2024-055-3",
        "name": "Применение МСА 315 при выявлении и оценке рисков существенного искажения финансовой отчетности",
        "date": "08.11.2024",
        "time": "2-часового курса"
      },
      {
        "id": "std-2024-055-4",
        "name": "Актуальные изменения в международных стандартах аудита и нормативных требованиях",
        "date": "13.11.2024",
        "time": "6-часового курса"
      },
      {
        "id": "std-2024-055-5",
        "name": "Основы кибербезопасности и защита информации в аудиторской практике",
        "date": "15.11.2024",
        "time": "6-часового курса"
      },
      {
        "id": "std-2024-055-6",
        "name": "Международный стандарт контроля качества 1: Построение системы управления качеством в аудиторской фирме",
        "date": "20.11.2024",
        "time": "8-часового курса"
      },
      {
        "id": "std-2024-055-7",
        "name": "Комплексный обзор Международных стандартов аудита и их практическое применение",
        "date": "22.11.2024",
        "time": "8-часового курса"
      },
      {
        "id": "std-2024-055-8",
        "name": "Международные стандарты финансовой отчетности: принципы, структура и применение",
        "date": "27.11.2024",
        "time": "8-часового курса"
      },
      {
        "id": "std-2024-055-9",
        "name": "Аудиторские доказательства",
        "date": "29.11.2024",
        "time": "3-часового курса"
      },
      {
        "id": "std-2024-055-10",
        "name": "Эффективное взаимодействие с клиентами и обеспечение качества аудиторских услуг",
        "date": "04.12.2024",
        "time": "6-часового курса"
      },
      {
        "id": "std-2024-055-11",
        "name": "Нормативно-правовые требования и стандарты, применимые к аудиту в отдельных секторах экономики",
        "date": "06.12.2024",
        "time": "5-часового курса"
      },
      {
        "id": "std-2024-055-12",
        "name": "Введение в Международный стандарт управления качеством (ISQM 1): принципы, структура и внедрение",
        "date": "14.12.2024",
        "time": "20 (5 дней)-часового курса"
      },
      {
        "id": "std-2024-055-13",
        "name": "Эффективная деловая коммуникация в профессиональной среде: навыки взаимодействия, переговоров и презентации",
        "date": "20.11.2024",
        "time": "2-часового курса"
      },
      {
        "id": "std-2024-055-14",
        "name": "Применение МСА 330: Аудиторские процедуры в ответ на оцененные риски существенного искажения",
        "date": "21.11.2024",
        "time": "2-часового курса"
      },
      {
        "id": "std-2024-055-15",
        "name": "Аудит оценочных значений, включая справедливую стоимость и резервы: применение МСА 540",
        "date": "22.11.2024",
        "time": "2-часового курса"
      },
      {
        "id": "std-2024-055-16",
        "name": "Разработка и реализация стратегии управления клиентским портфелем: сегментация, приоритеты и качество обслуживани",
        "date": "20.12.2024",
        "time": "6-часового курса"
      }
    ]
  },
  {
    "id": "std-2024-056",
    "name": "Уткирова Мадина",
    "certificates": [
      {
        "id": "std-2024-056-1",
        "name": "Принципы профессиональной этики и обеспечение независимости аудиторской организации",
        "date": "04.11.2024",
        "time": "8-часового курса"
      },
      {
        "id": "std-2024-056-2",
        "name": "Профессиональные требования к независимости аудитора",
        "date": "06.11.2024",
        "time": "6-часового курса"
      },
      {
        "id": "std-2024-056-3",
        "name": "Применение МСА 315 при выявлении и оценке рисков существенного искажения финансовой отчетности",
        "date": "08.11.2024",
        "time": "2-часового курса"
      },
      {
        "id": "std-2024-056-4",
        "name": "Актуальные изменения в международных стандартах аудита и нормативных требованиях",
        "date": "13.11.2024",
        "time": "6-часового курса"
      },
      {
        "id": "std-2024-056-5",
        "name": "Основы кибербезопасности и защита информации в аудиторской практике",
        "date": "15.11.2024",
        "time": "6-часового курса"
      },
      {
        "id": "std-2024-056-6",
        "name": "Международный стандарт контроля качества 1: Построение системы управления качеством в аудиторской фирме",
        "date": "20.11.2024",
        "time": "8-часового курса"
      },
      {
        "id": "std-2024-056-7",
        "name": "Комплексный обзор Международных стандартов аудита и их практическое применение",
        "date": "22.11.2024",
        "time": "8-часового курса"
      },
      {
        "id": "std-2024-056-8",
        "name": "Международные стандарты финансовой отчетности: принципы, структура и применение",
        "date": "27.11.2024",
        "time": "8-часового курса"
      },
      {
        "id": "std-2024-056-9",
        "name": "Аудиторские доказательства",
        "date": "29.11.2024",
        "time": "3-часового курса"
      },
      {
        "id": "std-2024-056-10",
        "name": "Эффективное взаимодействие с клиентами и обеспечение качества аудиторских услуг",
        "date": "04.12.2024",
        "time": "6-часового курса"
      },
      {
        "id": "std-2024-056-11",
        "name": "Нормативно-правовые требования и стандарты, применимые к аудиту в отдельных секторах экономики",
        "date": "06.12.2024",
        "time": "5-часового курса"
      },
      {
        "id": "std-2024-056-12",
        "name": "Введение в Международный стандарт управления качеством (ISQM 1): принципы, структура и внедрение",
        "date": "14.12.2024",
        "time": "20 (5 дней)-часового курса"
      },
      {
        "id": "std-2024-056-13",
        "name": "Эффективная деловая коммуникация в профессиональной среде: навыки взаимодействия, переговоров и презентации",
        "date": "20.11.2024",
        "time": "2-часового курса"
      },
      {
        "id": "std-2024-056-14",
        "name": "Применение МСА 330: Аудиторские процедуры в ответ на оцененные риски существенного искажения",
        "date": "21.11.2024",
        "time": "2-часового курса"
      },
      {
        "id": "std-2024-056-15",
        "name": "Аудит оценочных значений, включая справедливую стоимость и резервы: применение МСА 540",
        "date": "22.11.2024",
        "time": "2-часового курса"
      },
      {
        "id": "std-2024-056-16",
        "name": "Разработка и реализация стратегии управления клиентским портфелем: сегментация, приоритеты и качество обслуживани",
        "date": "20.12.2024",
        "time": "6-часового курса"
      }
    ]
  },
  {
    "id": "EMP-2024-KN-17",
    "name": "Каримов Нематулла",
    "certificates": [
      {
        "id": "CERT-2024-KN-01",
        "name": "Принципы профессиональной этики и обеспечение независимости аудиторской организации",
        "date": "06.01.2024",
        "time": "8-часового курса"
      },
      {
        "id": "CERT-2024-KN-02",
        "name": "Профессиональные требования к независимости аудитора",
        "date": "12.01.2024",
        "time": "6-часового курса"
      },
      {
        "id": "CERT-2024-KN-03",
        "name": "Применение МСА 315 при выявлении и оценке рисков существенного искажения финансовой отчетности",
        "date": "19.01.2024",
        "time": "2-часового курса"
      },
      {
        "id": "CERT-2024-KN-04",
        "name": "Актуальные изменения в международных стандартах аудита и нормативных требованиях",
        "date": "26.01.2024",
        "time": "6-часового курса"
      },
      {
        "id": "CERT-2024-KN-05",
        "name": "Основы кибербезопасности и защита информации в аудиторской практике",
        "date": "31.01.2024",
        "time": "6-часового курса"
      },
      {
        "id": "CERT-2024-KN-06",
        "name": "Международный стандарт контроля качества 1: Построение системы управления качеством в аудиторской фирме",
        "date": "23.02.2024",
        "time": "8-часового курса"
      },
      {
        "id": "CERT-2024-KN-07",
        "name": "Комплексный обзор Международных стандартов аудита и их практическое применение",
        "date": "15.03.2024",
        "time": "8-часового курса"
      },
      {
        "id": "CERT-2024-KN-08",
        "name": "Международные стандарты финансовой отчетности: принципы, структура и применение",
        "date": "26.04.2024",
        "time": "8-часового курса"
      },
      {
        "id": "CERT-2024-KN-09",
        "name": "Аудиторские доказательства",
        "date": "24.05.2024",
        "time": "3-часового курса"
      },
      {
        "id": "CERT-2024-KN-10",
        "name": "Нормативно-правовые требования и стандарты, применимые к аудиту в отдельных секторах экономики",
        "date": "26.07.2024",
        "time": "5-часового курса"
      },
      {
        "id": "CERT-2024-KN-11",
        "name": "Введение в Международный стандарт управления качеством (ISQM 1): принципы, структура и внедрение",
        "date": "29.08.2024",
        "time": "20 (5 дней)-часового курса"
      },
      {
        "id": "CERT-2024-KN-12",
        "name": "Эффективная деловая коммуникация в профессиональной среде: навыки взаимодействия, переговоров и презентации",
        "date": "20.09.2024",
        "time": "2-часового курса"
      },
      {
        "id": "CERT-2024-KN-13",
        "name": "Применение МСА 330: Аудиторские процедуры в ответ на оцененные риски существенного искажения",
        "date": "24.10.2024",
        "time": "2-часового курса"
      },
      {
        "id": "CERT-2024-KN-14",
        "name": "Аудит оценочных значений, включая справедливую стоимость и резервы: применение МСА 540",
        "date": "25.10.2024",
        "time": "2-часового курса"
      },
      {
        "id": "CERT-2024-KN-15",
        "name": "Разработка и реализация стратегии управления клиентским портфелем: сегментация, приоритеты и качество обслуживани",
        "date": "20.12.2024",
        "time": "6-часового курса"
      }
    ]
  },
  {
    "id": "EMP-2023-UA-03",
    "name": "Узоков Абдурасул",
    "certificates": [
      {
        "id": "CERT-2023-UA-01",
        "name": "Управление рисками качества на уровне фирмы",
        "date": "11.08.2023",
        "time": "6-часового курса"
      },
      {
        "id": "CERT-2023-UA-02",
        "name": "Внедрение ISQM 1: построение системы управления качеством",
        "date": "22.09.2023",
        "time": "6-часового курса"
      },
      {
        "id": "CERT-2023-UA-03",
        "name": "Внешний контроль качества: подготовка к проверкам",
        "date": "27.11.2023",
        "time": "4-часового курса"
      }
    ]
  }
]
export function formatDate(dateString) {
  const date = new Date(dateString);
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();
  return `${day}.${month}.${year}`;
}
